
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("hWOvD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d10f08892cad5fe5$var$_react = $d10f08892cad5fe5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $d10f08892cad5fe5$var$_error = $d10f08892cad5fe5$var$_interopRequireDefault((parcelRequire("ijSqY")));
function $d10f08892cad5fe5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d10f08892cad5fe5$var$ErrorIcon = (props)=>/*#__PURE__*/ $d10f08892cad5fe5$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $d10f08892cad5fe5$var$_error.default
    }));
$d10f08892cad5fe5$var$ErrorIcon.displayName = 'ErrorIcon';
var $d10f08892cad5fe5$var$_default = module.exports.default = $d10f08892cad5fe5$var$ErrorIcon;

});
parcelRegister("983KX", function(module, exports) {

$parcel$export(module.exports, "IconFacade", () => $34b2eed93eb6e4b5$export$3cfb73f70dfca966);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $ltBcH = parcelRequire("ltBcH");
const $34b2eed93eb6e4b5$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
const $34b2eed93eb6e4b5$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $5uXOq.memo)(function IconFacade({ dangerouslySetGlyph: dangerouslySetGlyph, ...props }) {
    const NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    const size = props.size ?? 'medium';
    const useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $fHpHg.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (size === 'small' || size === 'medium')) {
        if (props.iconType === 'utility') {
            const Icon = NewIcon;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                ...props,
                spacing: (0, $fHpHg.fg)('platform-visual-refresh-icons-facade-button-fix') ? $34b2eed93eb6e4b5$var$sizeSpacingMap['utility'][size] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            });
        } else {
            const Icon = NewIcon;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                ...props,
                spacing: $34b2eed93eb6e4b5$var$sizeSpacingMap['core'][size],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            });
        }
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ltBcH.Icon), {
        dangerouslySetGlyph: dangerouslySetGlyph,
        ...props
    });
});

});
parcelRegister("ltBcH", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $edb33acc9d1978b4$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $edb33acc9d1978b4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $3a7Um = parcelRequire("3a7Um");

var $4KSLR = parcelRequire("4KSLR");
function $edb33acc9d1978b4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $edb33acc9d1978b4$var$iconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-block',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> svg': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        ...(0, $3a7Um.commonSVGStyles),
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    }
});
/**
 * For windows high contrast mode
 */ const $edb33acc9d1978b4$var$baseHcmStyles = {
    name: "tdbe8",
    styles: "@media screen and (forced-colors: active){> svg{filter:grayscale(1);--icon-primary-color:CanvasText;--icon-secondary-color:Canvas;}}"
};
const $edb33acc9d1978b4$var$primaryEqualsSecondaryHcmStyles = {
    name: "1pgb0eo",
    styles: "@media screen and (forced-colors: active){> svg{--icon-primary-color:Canvas;}}"
};
const $edb33acc9d1978b4$var$secondaryTransparentHcmStyles = {
    name: "s2qd3p",
    styles: "@media screen and (forced-colors: active){> svg{--icon-secondary-color:transparent;}}"
};
const $edb33acc9d1978b4$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5uXOq.memo)(function Icon(props) {
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ (0, $f8Sb3.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    const dimensions = (0, $3a7Um.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        "data-testid": testId,
        "data-vc": `icon-${testId}`,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor || (0, $4KSLR.getBackground)(),
            margin: UNSAFE_margin
        },
        ...glyphProps,
        css: [
            $edb33acc9d1978b4$var$iconStyles,
            $edb33acc9d1978b4$var$baseHcmStyles,
            primaryColor === secondaryColor && $edb33acc9d1978b4$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $edb33acc9d1978b4$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $f8Sb3.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                '> svg': dimensions
            })
        ]
    });
});
var $edb33acc9d1978b4$export$2e2bcd8739ae039 = $edb33acc9d1978b4$export$f04a61298a47a40f;

});
parcelRegister("3a7Um", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", () => $351790669fa67df9$export$16374db1c3e6dfba);
$parcel$export(module.exports, "sizeStyleMap", () => $351790669fa67df9$export$ef0ad74202575b64);
$parcel$export(module.exports, "getIconSize", () => $351790669fa67df9$export$3eb7d6130acfda37);

var $7Z721 = parcelRequire("7Z721");

var $f8Sb3 = parcelRequire("f8Sb3");
const $351790669fa67df9$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $351790669fa67df9$var$smallStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $7Z721.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $351790669fa67df9$var$mediumStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $7Z721.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $351790669fa67df9$var$largeStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $7Z721.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $351790669fa67df9$var$xlargeStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $7Z721.dimensions).xlarge);
const $351790669fa67df9$export$ef0ad74202575b64 = {
    small: $351790669fa67df9$var$smallStyles,
    medium: $351790669fa67df9$var$mediumStyles,
    large: $351790669fa67df9$var$largeStyles,
    xlarge: $351790669fa67df9$var$xlargeStyles
};
const $351790669fa67df9$export$3eb7d6130acfda37 = ({ width: width, height: height, size: size })=>{
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $7Z721.dimensions)[size];
    return undefined;
};

});
parcelRegister("7Z721", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $b6b3371c199000f2$export$c647cb0ee6e282fe);
$parcel$export(module.exports, "dimensions", () => $b6b3371c199000f2$export$62ad7b0c781000e9);
const $b6b3371c199000f2$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $b6b3371c199000f2$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $b6b3371c199000f2$export$62ad7b0c781000e9 = {
    small: {
        width: $b6b3371c199000f2$export$c647cb0ee6e282fe.small,
        height: $b6b3371c199000f2$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $b6b3371c199000f2$export$c647cb0ee6e282fe.medium,
        height: $b6b3371c199000f2$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $b6b3371c199000f2$export$c647cb0ee6e282fe.large,
        height: $b6b3371c199000f2$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $b6b3371c199000f2$export$c647cb0ee6e282fe.xlarge,
        height: $b6b3371c199000f2$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("4KSLR", function(module, exports) {

$parcel$export(module.exports, "getBackground", () => $aa02605f14b719d1$export$18cb9425622d4e06);
const $aa02605f14b719d1$export$18cb9425622d4e06 = ()=>"var(--ds-surface, #FFFFFF)";

});



parcelRegister("ijSqY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::257fef37d04db299e24e95484ff9b12f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d56439cba5b92e57$var$_react = $d56439cba5b92e57$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d56439cba5b92e57$var$_baseNew = $d56439cba5b92e57$var$_interopRequireDefault((parcelRequire("enEmH")));
function $d56439cba5b92e57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d56439cba5b92e57$var$ErrorIcon = (props)=>/*#__PURE__*/ $d56439cba5b92e57$var$_react.default.createElement($d56439cba5b92e57$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$d56439cba5b92e57$var$ErrorIcon.displayName = 'ErrorIcon';
var $d56439cba5b92e57$var$_default = module.exports.default = $d56439cba5b92e57$var$ErrorIcon;

});
parcelRegister("enEmH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("k7V9T")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("k7V9T")).Icon);

var $k7V9T = parcelRequire("k7V9T");

});
parcelRegister("k7V9T", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $cc2fe861c8da8975$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $cc2fe861c8da8975$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $fHpHg = parcelRequire("fHpHg");
function $cc2fe861c8da8975$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cc2fe861c8da8975$var$commonSVGStyles = {
    name: "10ihzwq",
    styles: "overflow:hidden;pointer-events:none;stop{stop-color:currentColor;}"
};
const $cc2fe861c8da8975$var$svgStyles = {
    name: "x6fk93",
    styles: "color:currentColor;vertical-align:bottom"
};
const $cc2fe861c8da8975$var$iconStyles = {
    name: "mrp99y",
    styles: "display:inline-block;box-sizing:border-box;flex-shrink:0;line-height:1;padding-inline-end:var(--ds--button--new-icon-padding-end, 0);padding-inline-start:var(--ds--button--new-icon-padding-start, 0)"
};
const $cc2fe861c8da8975$var$utilityIconStyles = {
    name: "1j4yvsm",
    styles: "line-height:var(--ds-space-150, 12px)"
};
const $cc2fe861c8da8975$var$scaleStyles = {
    name: "1a1gyup",
    styles: "width:inherit;height:inherit"
};
/**
 * For windows high contrast mode
 */ const $cc2fe861c8da8975$var$baseHcmStyles = {
    name: "9vywkz",
    styles: "@media screen and (forced-colors: active){color:CanvasText;filter:grayscale(1);}"
};
const $cc2fe861c8da8975$var$scaleSize = {
    name: "1a1gyup",
    styles: "width:inherit;height:inherit"
};
const $cc2fe861c8da8975$var$sizeMap = {
    core: {
        none: {
            name: "1rrhp72",
            styles: "width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px)"
        },
        spacious: {
            name: "ljflj6",
            styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
        }
    },
    utility: {
        none: {
            name: "1w03az9",
            styles: "width:var(--ds-space-150, 12px);height:var(--ds-space-150, 12px)"
        },
        compact: {
            name: "1rrhp72",
            styles: "width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px)"
        },
        spacious: {
            name: "ljflj6",
            styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
        }
    }
};
const $cc2fe861c8da8975$var$baseSizeMap = {
    core: 16,
    utility: 12
};
const $cc2fe861c8da8975$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
const $cc2fe861c8da8975$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5uXOq.memo)(function Icon(props) {
    const { color: color = 'currentColor', testId: testId, label: label, LEGACY_primaryColor: LEGACY_primaryColor, LEGACY_secondaryColor: LEGACY_secondaryColor, LEGACY_size: LEGACY_size, LEGACY_fallbackIcon: FallbackIcon, dangerouslySetGlyph: // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph, shouldScale: // Used with iconTile to scale icon up and down
    shouldScale, LEGACY_margin: LEGACY_margin } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $fHpHg.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor ?? color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        // @ts-ignore-next-line
        UNSAFE_margin: LEGACY_margin
    });
    const baseSize = $cc2fe861c8da8975$var$baseSizeMap[props.type ?? 'core'];
    let viewBoxPadding;
    if (props.type === 'utility') viewBoxPadding = $cc2fe861c8da8975$var$paddingMap[props.type][props.spacing ?? 'none'];
    else viewBoxPadding = $cc2fe861c8da8975$var$paddingMap['core'][props.spacing ?? 'none'];
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        css: [
            $cc2fe861c8da8975$var$iconStyles,
            $cc2fe861c8da8975$var$baseHcmStyles,
            shouldScale && $cc2fe861c8da8975$var$scaleStyles,
            props.type === 'utility' && $cc2fe861c8da8975$var$utilityIconStyles
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("svg", {
        fill: "none",
        // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
        // we want for Icon Tile
        viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
        role: "presentation",
        css: [
            $cc2fe861c8da8975$var$commonSVGStyles,
            $cc2fe861c8da8975$var$svgStyles,
            shouldScale ? $cc2fe861c8da8975$var$scaleSize : props.type === 'utility' ? $cc2fe861c8da8975$var$sizeMap[props.type][props.spacing ?? 'none'] : $cc2fe861c8da8975$var$sizeMap['core'][props.spacing ?? 'none']
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $cc2fe861c8da8975$export$2e2bcd8739ae039 = $cc2fe861c8da8975$export$f04a61298a47a40f;

});




parcelRegister("jDpWv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e4b5c886536d92b2$var$_react = $e4b5c886536d92b2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $e4b5c886536d92b2$var$_success = $e4b5c886536d92b2$var$_interopRequireDefault((parcelRequire("cFUJ2")));
function $e4b5c886536d92b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e4b5c886536d92b2$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $e4b5c886536d92b2$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $e4b5c886536d92b2$var$_success.default
    }));
$e4b5c886536d92b2$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $e4b5c886536d92b2$var$_default = module.exports.default = $e4b5c886536d92b2$var$CheckCircleIcon;

});
parcelRegister("cFUJ2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8a54e77ebc6c63c295a0cd7c7e0eeda>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $93a550daee5da876$var$_react = $93a550daee5da876$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $93a550daee5da876$var$_baseNew = $93a550daee5da876$var$_interopRequireDefault((parcelRequire("enEmH")));
function $93a550daee5da876$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $93a550daee5da876$var$SuccessIcon = (props)=>/*#__PURE__*/ $93a550daee5da876$var$_react.default.createElement($93a550daee5da876$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$93a550daee5da876$var$SuccessIcon.displayName = 'SuccessIcon';
var $93a550daee5da876$var$_default = module.exports.default = $93a550daee5da876$var$SuccessIcon;

});


parcelRegister("goMg1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf045227a612666a$var$_react = $bf045227a612666a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $bf045227a612666a$var$_close = $bf045227a612666a$var$_interopRequireDefault((parcelRequire("eh9vz")));
function $bf045227a612666a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bf045227a612666a$var$CrossIcon = (props)=>/*#__PURE__*/ $bf045227a612666a$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $bf045227a612666a$var$_close.default
    }));
$bf045227a612666a$var$CrossIcon.displayName = 'CrossIcon';
var $bf045227a612666a$var$_default = module.exports.default = $bf045227a612666a$var$CrossIcon;

});
parcelRegister("eh9vz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13d0fc846b6bef3d8e704c9e8e0a2026>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a64a075857ba1ebe$var$_react = $a64a075857ba1ebe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a64a075857ba1ebe$var$_baseNew = $a64a075857ba1ebe$var$_interopRequireDefault((parcelRequire("enEmH")));
function $a64a075857ba1ebe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Close".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a64a075857ba1ebe$var$CloseIcon = (props)=>/*#__PURE__*/ $a64a075857ba1ebe$var$_react.default.createElement($a64a075857ba1ebe$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m9.06 8 4.97-4.97-1.06-1.06L8 6.94 3.03 1.97 1.97 3.03 6.94 8l-4.97 4.97 1.06 1.06L8 9.06l4.97 4.97 1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$a64a075857ba1ebe$var$CloseIcon.displayName = 'CloseIcon';
var $a64a075857ba1ebe$var$_default = module.exports.default = $a64a075857ba1ebe$var$CloseIcon;

});


parcelRegister("dcVSO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99d94bba4afa6c32$var$_react = $99d94bba4afa6c32$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $99d94bba4afa6c32$var$_chevronDown = $99d94bba4afa6c32$var$_interopRequireDefault((parcelRequire("jVpd1")));
function $99d94bba4afa6c32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $99d94bba4afa6c32$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $99d94bba4afa6c32$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props, {
        newIcon: $99d94bba4afa6c32$var$_chevronDown.default,
        iconType: "utility"
    }));
$99d94bba4afa6c32$var$HipchatChevronDownIcon.displayName = 'HipchatChevronDownIcon';
var $99d94bba4afa6c32$var$_default = module.exports.default = $99d94bba4afa6c32$var$HipchatChevronDownIcon;

});
parcelRegister("jVpd1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1a026656028c05157ac730015f665601>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e816e527b9f605d6$var$_react = $e816e527b9f605d6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e816e527b9f605d6$var$_baseNew = $e816e527b9f605d6$var$_interopRequireDefault((parcelRequire("enEmH")));
function $e816e527b9f605d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e816e527b9f605d6$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $e816e527b9f605d6$var$_react.default.createElement($e816e527b9f605d6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.03 3.97 6 7.94l3.97-3.97 1.06 1.06-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$e816e527b9f605d6$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $e816e527b9f605d6$var$_default = module.exports.default = $e816e527b9f605d6$var$ChevronDownIcon;

});


parcelRegister("aB7fx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7b72fbb5229b9f34$var$_react = $7b72fbb5229b9f34$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $7b72fbb5229b9f34$var$_chevronUp = $7b72fbb5229b9f34$var$_interopRequireDefault((parcelRequire("4V64t")));
function $7b72fbb5229b9f34$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7b72fbb5229b9f34$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $7b72fbb5229b9f34$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.294 8.708-4.549 4.559a1.051 1.051 0 1 0 1.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 0 0 1.486.001h.001a1.054 1.054 0 0 0 .001-1.489L12.71 8.708a1 1 0 0 0-1.415-.001"/></svg>`
    }, props, {
        newIcon: $7b72fbb5229b9f34$var$_chevronUp.default,
        iconType: "utility"
    }));
$7b72fbb5229b9f34$var$HipchatChevronUpIcon.displayName = 'HipchatChevronUpIcon';
var $7b72fbb5229b9f34$var$_default = module.exports.default = $7b72fbb5229b9f34$var$HipchatChevronUpIcon;

});
parcelRegister("4V64t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afcaa915720f5b4d9e69ee6ef0943c67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $395131e802bed643$var$_react = $395131e802bed643$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $395131e802bed643$var$_baseNew = $395131e802bed643$var$_interopRequireDefault((parcelRequire("enEmH")));
function $395131e802bed643$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $395131e802bed643$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $395131e802bed643$var$_react.default.createElement($395131e802bed643$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 4.06 2.03 8.03.97 6.97l4.5-4.5a.75.75 0 0 1 1.06 0l4.5 4.5-1.06 1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$395131e802bed643$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $395131e802bed643$var$_default = module.exports.default = $395131e802bed643$var$ChevronUpIcon;

});


parcelRegister("lVF4A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff6ec812e214b9b0$var$_react = $ff6ec812e214b9b0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $ff6ec812e214b9b0$var$_information = $ff6ec812e214b9b0$var$_interopRequireDefault((parcelRequire("9a675")));
function $ff6ec812e214b9b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ff6ec812e214b9b0$var$InfoIcon = (props)=>/*#__PURE__*/ $ff6ec812e214b9b0$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $ff6ec812e214b9b0$var$_information.default
    }));
$ff6ec812e214b9b0$var$InfoIcon.displayName = 'InfoIcon';
var $ff6ec812e214b9b0$var$_default = module.exports.default = $ff6ec812e214b9b0$var$InfoIcon;

});
parcelRegister("9a675", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11503d00887c85dd37060e980bd5f02d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6ab9ca346a18bc43$var$_react = $6ab9ca346a18bc43$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6ab9ca346a18bc43$var$_baseNew = $6ab9ca346a18bc43$var$_interopRequireDefault((parcelRequire("enEmH")));
function $6ab9ca346a18bc43$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6ab9ca346a18bc43$var$InformationIcon = (props)=>/*#__PURE__*/ $6ab9ca346a18bc43$var$_react.default.createElement($6ab9ca346a18bc43$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$6ab9ca346a18bc43$var$InformationIcon.displayName = 'InformationIcon';
var $6ab9ca346a18bc43$var$_default = module.exports.default = $6ab9ca346a18bc43$var$InformationIcon;

});


parcelRegister("bzBk6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86cfea3a93f4541b$var$_react = $86cfea3a93f4541b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $86cfea3a93f4541b$var$_warning = $86cfea3a93f4541b$var$_interopRequireDefault((parcelRequire("c0tV6")));
function $86cfea3a93f4541b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $86cfea3a93f4541b$var$WarningIcon = (props)=>/*#__PURE__*/ $86cfea3a93f4541b$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $86cfea3a93f4541b$var$_warning.default
    }));
$86cfea3a93f4541b$var$WarningIcon.displayName = 'WarningIcon';
var $86cfea3a93f4541b$var$_default = module.exports.default = $86cfea3a93f4541b$var$WarningIcon;

});
parcelRegister("c0tV6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1447c2d9394cec1fac504fd0d225fa23>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bdcb19c3802e0f5$var$_react = $8bdcb19c3802e0f5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8bdcb19c3802e0f5$var$_baseNew = $8bdcb19c3802e0f5$var$_interopRequireDefault((parcelRequire("enEmH")));
function $8bdcb19c3802e0f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8bdcb19c3802e0f5$var$WarningIcon = (props)=>/*#__PURE__*/ $8bdcb19c3802e0f5$var$_react.default.createElement($8bdcb19c3802e0f5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$8bdcb19c3802e0f5$var$WarningIcon.displayName = 'WarningIcon';
var $8bdcb19c3802e0f5$var$_default = module.exports.default = $8bdcb19c3802e0f5$var$WarningIcon;

});


parcelRegister("3ppm2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("cNW3X")).default);
$parcel$export(module.exports, "LoadingButton", () => (parcelRequire("i95f5")).default);
$parcel$export(module.exports, "CustomThemeButton", () => (parcelRequire("1nSOt")).default);
$parcel$export(module.exports, "Theme", () => (parcelRequire("ep3GE")).default);
$parcel$export(module.exports, "ButtonGroup", () => (parcelRequire("jHTSg")).default);
// Ideally this file is not used directly. But rather, you go through the entry points

var $cNW3X = parcelRequire("cNW3X");

var $i95f5 = parcelRequire("i95f5");

var $1nSOt = parcelRequire("1nSOt");
var $ep3GE = parcelRequire("ep3GE");

var $jHTSg = parcelRequire("jHTSg");

});
parcelRegister("cNW3X", function(module, exports) {

$parcel$export(module.exports, "default", () => $31ac7744cecfa391$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bKnKN = parcelRequire("bKnKN");

var $l2QOa = parcelRequire("l2QOa");

var $4WJDn = parcelRequire("4WJDn");

var $aXhtj = parcelRequire("aXhtj");

var $1iaMM = parcelRequire("1iaMM");
const $31ac7744cecfa391$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ const $31ac7744cecfa391$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function Button({ appearance: appearance = 'default', children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected = false, onMouseDown: providedOnMouseDown = (0, $bKnKN.default), onMouseUp: providedOnMouseUp = (0, $bKnKN.default), shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', ...rest }, ref) {
    const { mode: mode } = (0, $l2QOa.useGlobalTheme)();
    const isOnlySingleIcon = (0, $1iaMM.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    const [isActive, setIsActive] = (0, $5uXOq.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    const onMouseDown = (0, $5uXOq.useCallback)((event)=>{
        providedOnMouseDown(event);
        if ($31ac7744cecfa391$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, $5uXOq.useCallback)((event)=>{
        providedOnMouseUp(event);
        if ($31ac7744cecfa391$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, $5uXOq.useMemo)(()=>(0, $aXhtj.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        }), [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4WJDn.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        // Due to how click events are set, we need to set active styles
        //  manually in Firefox and wrap onMouseDown/onMouseUp
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    });
}));
// Tools including enzyme rely on components having a display name
$31ac7744cecfa391$var$Button.displayName = 'Button';
var $31ac7744cecfa391$export$2e2bcd8739ae039 = $31ac7744cecfa391$var$Button;

});
parcelRegister("bKnKN", function(module, exports) {

$parcel$export(module.exports, "default", () => $195a80234056da7d$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $195a80234056da7d$export$2e2bcd8739ae039() {}

});

parcelRegister("l2QOa", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", () => $7f1e763903eb2de1$export$7692396083754928);
$parcel$export(module.exports, "default", () => $7f1e763903eb2de1$export$2e2bcd8739ae039);

var $cKNod = parcelRequire("cKNod");
// Create default global light theme
const { Provider: $7f1e763903eb2de1$var$Provider, Consumer: $7f1e763903eb2de1$var$Consumer, useTheme: $7f1e763903eb2de1$export$7692396083754928 } = (0, $cKNod.createTheme)(()=>({
        mode: 'light'
    }));
const $7f1e763903eb2de1$var$Theme = {
    Provider: $7f1e763903eb2de1$var$Provider,
    Consumer: $7f1e763903eb2de1$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7f1e763903eb2de1$export$2e2bcd8739ae039 = $7f1e763903eb2de1$var$Theme;

});
parcelRegister("cKNod", function(module, exports) {

$parcel$export(module.exports, "createTheme", () => $ad0dc8914babe155$export$25d302a5b900a763);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $ad0dc8914babe155$export$25d302a5b900a763(defaultGetTokens) {
    const emptyThemeFn = (getTokens, props)=>getTokens(props);
    /**
	 * Internally, Theme uses React Context, with internal providers and consumers.
	 * The React Context passes only a function that gets props, and turns them into tokens. This
	 * function gets mixed as more Providers with their own themes are added. This mixed function
	 * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
	 * the theme.
	 */ const ThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        const theme = (0, $5uXOq.useContext)(ThemeContext);
        const themeFn = theme || emptyThemeFn;
        const tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        const { children: children, ...themeProps } = props;
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        const tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children(tokens)
        });
    }
    /**
	 * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
	 * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
	 * - The getTokens function isn't called immediately - instead the props are passed
	 *    through a mix of parent theming functions
	 * Children of this provider will receive this mixed theme
	 */ function Provider(props) {
        const themeFn = (0, $5uXOq.useContext)(ThemeContext);
        const valueFn = props.value || emptyThemeFn;
        const mixedFn = (0, $5uXOq.useCallback)((themeProps)=>valueFn(themeFn, themeProps), [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ThemeContext.Provider, {
            value: mixedFn,
            children: props.children
        });
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("4WJDn", function(module, exports) {

$parcel$export(module.exports, "default", () => $21ad90d2900d66d4$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
                                                                        * @jsxRuntime classic
                                                                        * @jsx jsx
                                                                        */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $eNCZ4 = parcelRequire("eNCZ4");

var $bKnKN = parcelRequire("bKnKN");

var $42A03 = parcelRequire("42A03");

var $6fV04 = parcelRequire("6fV04");

var $9ewsv = parcelRequire("9ewsv");


var $j7QuV = parcelRequire("j7QuV");

var $aXhtj = parcelRequire("aXhtj");

var $9ncAe = parcelRequire("9ncAe");
function $21ad90d2900d66d4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const $21ad90d2900d66d4$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ const $21ad90d2900d66d4$var$iconBeforeSpacingFixStyle = {
    name: "s584p2",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-025, 2px);--ds--button--new-icon-padding-start:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-negative-025, -2px)"
};
const $21ad90d2900d66d4$var$iconAfterSpacingFixStyle = {
    name: "150qmyr",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-050, 4px);--ds--button--new-icon-padding-start:var(--ds-space-025, 2px);margin-inline-end:var(--ds-space-negative-025, -2px)"
};
const $21ad90d2900d66d4$var$getSpacingFix = (children, spacingStyles)=>{
    if (!children || (0, $9ncAe.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const $21ad90d2900d66d4$var$getChildren = (children, childrenStyles)=>{
    if ((0, $9ncAe.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
const $21ad90d2900d66d4$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function ButtonBase(props, ref) {
    const { analyticsContext: // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, buttonCss: buttonCss, children: children, className: className, href: href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled = false, isSelected: isSelected = false, onBlur: onBlur, onClick: providedOnClick = (0, $bKnKN.default), onFocus: onFocus, onMouseDown: providedOnMouseDown = (0, $bKnKN.default), overlay: overlay, shouldFitContainer: // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing: spacing = 'default', tabIndex: tabIndex = 0, type: type = !href ? 'button' : undefined, testId: testId, ...rest } = props;
    const ourRef = (0, $5uXOq.useRef)();
    const setRef = (0, $5uXOq.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $42A03.default)(ourRef, autoFocus);
    const interactionContext = (0, $5uXOq.useContext)((0, $9ewsv.default));
    const handleClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $5uXOq.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const fadeStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $aXhtj.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? `var(--ds-icon-subtle, ${0, $a7f8c6b391092279$export$c39c0fe0f26207ae})` : `var(--ds-icon-warning-inverse, ${0, $a7f8c6b391092279$export$c39c0fe0f26207ae})`} !important`
        }
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6fV04.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        ...rest,
        ref: setRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $21ad90d2900d66d4$var$noPointerEventsOnChildrenCss
        ],
        // using undefined so that the property doesn't exist when false
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        // Adding a tab index so element is always focusable, even when not a <button> or <a>
        // Disabling focus via keyboard navigation when disabled
        // as this is standard button behaviour
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type,
        ...(0, $j7QuV.default)({
            isInteractive: isInteractive
        })
    }, iconBefore ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $aXhtj.getIconStyle)({
                spacing: spacing
            }),
            $21ad90d2900d66d4$var$getSpacingFix(children, $21ad90d2900d66d4$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $21ad90d2900d66d4$var$getChildren(children, [
        fadeStyles,
        (0, $aXhtj.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $aXhtj.getIconStyle)({
                spacing: spacing
            }),
            $21ad90d2900d66d4$var$getSpacingFix(children, $21ad90d2900d66d4$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: [
            (0, $aXhtj.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$21ad90d2900d66d4$export$2e2bcd8739ae039 = $21ad90d2900d66d4$var$ButtonBase;

});
parcelRegister("eNCZ4", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $5321372b78fdc6b0$export$a4687b0234b40e28);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $cLmtE = parcelRequire("cLmtE");
function $5321372b78fdc6b0$export$a4687b0234b40e28({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $cLmtE.useTrackedRef)(analyticsData);
    const fnRef = (0, $cLmtE.useTrackedRef)(fn);
    const handler = (0, $5uXOq.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("bngFq", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $8c0b3d9a013fa08e$export$5bf35293e545f20c);

var $3YMLK = parcelRequire("3YMLK");

var $49NSg = parcelRequire("49NSg");

var $d5pZX = parcelRequire("d5pZX");
function $8c0b3d9a013fa08e$export$5bf35293e545f20c() {
    const analyticsContext = (0, $d5pZX.useAnalyticsContext)();
    const createAnalyticsEvent = (0, $3YMLK.useCallbackOne)((payload)=>{
        return new (0, $49NSg.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("49NSg", function(module, exports) {

$parcel$export(module.exports, "isUIAnalyticsEvent", () => $831cccb2356ffa25$export$35f8383928ba8d7);
$parcel$export(module.exports, "default", () => $831cccb2356ffa25$export$2e2bcd8739ae039);
/// <reference types="node" />

var $iyUkr = parcelRequire("iyUkr");
const $831cccb2356ffa25$export$35f8383928ba8d7 = (obj)=>obj instanceof $831cccb2356ffa25$export$2e2bcd8739ae039 || !!obj?._isUIAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'UIAnalyticsEvent';
class $831cccb2356ffa25$export$2e2bcd8739ae039 extends (0, $iyUkr.default) {
    constructor(props){
        super(props), this._isUIAnalyticsEvent = true, this.clone = ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            /**
		 * A hacky "deep clone" of the object. This is limited in that it wont
		 * support functions, regexs, Maps, Sets, etc, but none of those need to
		 * be represented in our payload.
		 */ const payload = JSON.parse(JSON.stringify(this.payload));
            return new $831cccb2356ffa25$export$2e2bcd8739ae039({
                context: context,
                handlers: handlers,
                payload: payload
            });
        }, this.fire = (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>handler(this, channel));
            this.hasFired = true;
        };
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
}

});
parcelRegister("iyUkr", function(module, exports) {

$parcel$export(module.exports, "default", () => $270025a818b79786$export$2e2bcd8739ae039);
const $270025a818b79786$export$ad4be5c2ec28cecf = (obj)=>obj instanceof $270025a818b79786$export$2e2bcd8739ae039 || !!obj?._isAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'AnalyticsEvent';
class $270025a818b79786$export$2e2bcd8739ae039 {
    constructor(props){
        this._isAnalyticsEvent = true;
        this.clone = ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = {
                ...this.payload
            };
            return new $270025a818b79786$export$2e2bcd8739ae039({
                payload: payload
            });
        };
        this.payload = props.payload;
    }
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
}

});


parcelRegister("d5pZX", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", () => $3ef3938f979d3f1a$export$d1f587f82ad51c4);

var $5uXOq = parcelRequire("5uXOq");

var $fy0vt = parcelRequire("fy0vt");
const $3ef3938f979d3f1a$export$d1f587f82ad51c4 = ()=>{
    return (0, $5uXOq.useContext)((0, $fy0vt.default));
};

});
parcelRegister("fy0vt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b51a6c9c41c41fef$export$2e2bcd8739ae039);

var $3eEea = parcelRequire("3eEea");
var $b51a6c9c41c41fef$export$2e2bcd8739ae039 = (0, $3eEea.default);

});
parcelRegister("3eEea", function(module, exports) {

$parcel$export(module.exports, "default", () => $25b1e245577cd18c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $25b1e245577cd18c$var$AnalyticsNextContext = (0, $5uXOq.createContext)({
    getAtlaskitAnalyticsContext: ()=>[],
    getAtlaskitAnalyticsEventHandlers: ()=>[]
});
var $25b1e245577cd18c$export$2e2bcd8739ae039 = $25b1e245577cd18c$var$AnalyticsNextContext;

});




parcelRegister("cLmtE", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", () => $8ed5824982fad6f0$export$1d27a74659855e44);

var $5uXOq = parcelRequire("5uXOq");
const $8ed5824982fad6f0$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("42A03", function(module, exports) {

$parcel$export(module.exports, "default", () => $d940c98811abe918$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $d940c98811abe918$export$2e2bcd8739ae039(ref, autoFocus) {
    const initialMount = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("6fV04", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e257131eb9b336e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
const $0e257131eb9b336e$var$BORDER_WIDTH = 2;
const $0e257131eb9b336e$var$baseFocusOutsideStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    outline: `${$0e257131eb9b336e$var$BORDER_WIDTH}px solid ${"var(--ds-border-focused, #2684FF)"}`,
    outlineOffset: $0e257131eb9b336e$var$BORDER_WIDTH
});
const $0e257131eb9b336e$var$baseInsetStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$0e257131eb9b336e$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
const $0e257131eb9b336e$var$focusRingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $0e257131eb9b336e$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $0e257131eb9b336e$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
const $0e257131eb9b336e$var$insetFocusRingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $0e257131eb9b336e$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $0e257131eb9b336e$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ const $0e257131eb9b336e$var$FocusRing = /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children, isInset: isInset, focus: focus })=>{
    const controlledStyles = isInset ? $0e257131eb9b336e$var$baseInsetStyles : $0e257131eb9b336e$var$baseFocusOutsideStyles;
    const uncontrolledStyles = isInset ? $0e257131eb9b336e$var$insetFocusRingStyles : $0e257131eb9b336e$var$focusRingStyles;
    const focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.ClassNames), null, ({ css: css, cx: cx })=>(0, $5uXOq.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, $5uXOq.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children));
});
$0e257131eb9b336e$var$FocusRing.displayName = 'FocusRing';
var $0e257131eb9b336e$export$2e2bcd8739ae039 = $0e257131eb9b336e$var$FocusRing;

});

var $a7f8c6b391092279$exports = {};

$parcel$export($a7f8c6b391092279$exports, "R50", () => $a7f8c6b391092279$export$4b84fd0e2c617bd);
$parcel$export($a7f8c6b391092279$exports, "R75", () => $a7f8c6b391092279$export$b34b069eff244586);
$parcel$export($a7f8c6b391092279$exports, "R100", () => $a7f8c6b391092279$export$be802dd0d8b57f35);
$parcel$export($a7f8c6b391092279$exports, "R200", () => $a7f8c6b391092279$export$60847d42f9da92a6);
$parcel$export($a7f8c6b391092279$exports, "R300", () => $a7f8c6b391092279$export$4a7404f376229999);
$parcel$export($a7f8c6b391092279$exports, "R400", () => $a7f8c6b391092279$export$2010d0fb4295b346);
$parcel$export($a7f8c6b391092279$exports, "R500", () => $a7f8c6b391092279$export$2837b5a1a71d5c02);
$parcel$export($a7f8c6b391092279$exports, "Y50", () => $a7f8c6b391092279$export$8d9596b529bbb9cf);
$parcel$export($a7f8c6b391092279$exports, "Y75", () => $a7f8c6b391092279$export$41060a744ab0b7ae);
$parcel$export($a7f8c6b391092279$exports, "Y100", () => $a7f8c6b391092279$export$1cc05bbbf340e559);
$parcel$export($a7f8c6b391092279$exports, "Y200", () => $a7f8c6b391092279$export$5aae31392d72caaa);
$parcel$export($a7f8c6b391092279$exports, "Y300", () => $a7f8c6b391092279$export$c6930421db9fa514);
$parcel$export($a7f8c6b391092279$exports, "Y400", () => $a7f8c6b391092279$export$59619663aa6500fb);
$parcel$export($a7f8c6b391092279$exports, "Y500", () => $a7f8c6b391092279$export$874739ea9e379ab6);
$parcel$export($a7f8c6b391092279$exports, "G50", () => $a7f8c6b391092279$export$8a6341c32b6a3ee6);
$parcel$export($a7f8c6b391092279$exports, "G75", () => $a7f8c6b391092279$export$69a3bf21b9686c2b);
$parcel$export($a7f8c6b391092279$exports, "G100", () => $a7f8c6b391092279$export$afbce1382ec95f73);
$parcel$export($a7f8c6b391092279$exports, "G200", () => $a7f8c6b391092279$export$747d86715d4175de);
$parcel$export($a7f8c6b391092279$exports, "G300", () => $a7f8c6b391092279$export$940e1f69e873f202);
$parcel$export($a7f8c6b391092279$exports, "G400", () => $a7f8c6b391092279$export$a49394138f7b8e85);
$parcel$export($a7f8c6b391092279$exports, "G500", () => $a7f8c6b391092279$export$6fa04827ac68a4fb);
$parcel$export($a7f8c6b391092279$exports, "B50", () => $a7f8c6b391092279$export$226de0355ed012f8);
$parcel$export($a7f8c6b391092279$exports, "B75", () => $a7f8c6b391092279$export$8c13c2ee36917869);
$parcel$export($a7f8c6b391092279$exports, "B100", () => $a7f8c6b391092279$export$ecfc1dff386a3e7a);
$parcel$export($a7f8c6b391092279$exports, "B200", () => $a7f8c6b391092279$export$215b7063051591f1);
$parcel$export($a7f8c6b391092279$exports, "B300", () => $a7f8c6b391092279$export$e62e8919cca44969);
$parcel$export($a7f8c6b391092279$exports, "B400", () => $a7f8c6b391092279$export$b3de0ae08da2ce64);
$parcel$export($a7f8c6b391092279$exports, "B500", () => $a7f8c6b391092279$export$a6ee3d71bc067634);
$parcel$export($a7f8c6b391092279$exports, "B600", () => $a7f8c6b391092279$export$67f15409e87642a1);
$parcel$export($a7f8c6b391092279$exports, "B700", () => $a7f8c6b391092279$export$f0539dbc42dbb067);
$parcel$export($a7f8c6b391092279$exports, "P50", () => $a7f8c6b391092279$export$363e4475840015bb);
$parcel$export($a7f8c6b391092279$exports, "P75", () => $a7f8c6b391092279$export$4b0a4417ed59760f);
$parcel$export($a7f8c6b391092279$exports, "P100", () => $a7f8c6b391092279$export$6011520a64d9a187);
$parcel$export($a7f8c6b391092279$exports, "P200", () => $a7f8c6b391092279$export$a7175d4e9206bc80);
$parcel$export($a7f8c6b391092279$exports, "P300", () => $a7f8c6b391092279$export$b48405b95304b5a1);
$parcel$export($a7f8c6b391092279$exports, "P400", () => $a7f8c6b391092279$export$c71e4279dd54a18d);
$parcel$export($a7f8c6b391092279$exports, "P500", () => $a7f8c6b391092279$export$147899de772240ec);
$parcel$export($a7f8c6b391092279$exports, "T50", () => $a7f8c6b391092279$export$2cf711fe14c66f06);
$parcel$export($a7f8c6b391092279$exports, "T75", () => $a7f8c6b391092279$export$7a8f4d33f6f9772c);
$parcel$export($a7f8c6b391092279$exports, "T100", () => $a7f8c6b391092279$export$776c9c497ef08533);
$parcel$export($a7f8c6b391092279$exports, "T200", () => $a7f8c6b391092279$export$69cb3ca10c1e330e);
$parcel$export($a7f8c6b391092279$exports, "T300", () => $a7f8c6b391092279$export$9dc1ef0f3f48059b);
$parcel$export($a7f8c6b391092279$exports, "T400", () => $a7f8c6b391092279$export$7c835c78b6fcdef8);
$parcel$export($a7f8c6b391092279$exports, "T500", () => $a7f8c6b391092279$export$6036577f95c3877e);
$parcel$export($a7f8c6b391092279$exports, "N0", () => $a7f8c6b391092279$export$29a4f05edc054374);
$parcel$export($a7f8c6b391092279$exports, "N10", () => $a7f8c6b391092279$export$e655ef011c4aa1a2);
$parcel$export($a7f8c6b391092279$exports, "N20", () => $a7f8c6b391092279$export$9fdfb749e33cdf97);
$parcel$export($a7f8c6b391092279$exports, "N30", () => $a7f8c6b391092279$export$3e51e8f1440314ba);
$parcel$export($a7f8c6b391092279$exports, "N40", () => $a7f8c6b391092279$export$1ce2d1575d444ceb);
$parcel$export($a7f8c6b391092279$exports, "N50", () => $a7f8c6b391092279$export$8754fc7e6d8b3000);
$parcel$export($a7f8c6b391092279$exports, "N60", () => $a7f8c6b391092279$export$c2e91cbeada39b8b);
$parcel$export($a7f8c6b391092279$exports, "N70", () => $a7f8c6b391092279$export$5f71e19f3a7ad9de);
$parcel$export($a7f8c6b391092279$exports, "N80", () => $a7f8c6b391092279$export$eaa8c8a70ac22806);
$parcel$export($a7f8c6b391092279$exports, "N90", () => $a7f8c6b391092279$export$7c87d337fb91a97d);
$parcel$export($a7f8c6b391092279$exports, "N100", () => $a7f8c6b391092279$export$d6447c357493214f);
$parcel$export($a7f8c6b391092279$exports, "N200", () => $a7f8c6b391092279$export$f563ee71e9ee74cd);
$parcel$export($a7f8c6b391092279$exports, "N300", () => $a7f8c6b391092279$export$e2ef2124cf4024b1);
$parcel$export($a7f8c6b391092279$exports, "N400", () => $a7f8c6b391092279$export$eece5f492e429f08);
$parcel$export($a7f8c6b391092279$exports, "N500", () => $a7f8c6b391092279$export$c39c0fe0f26207ae);
$parcel$export($a7f8c6b391092279$exports, "N600", () => $a7f8c6b391092279$export$7090862dc3038a9f);
$parcel$export($a7f8c6b391092279$exports, "N700", () => $a7f8c6b391092279$export$ad0bacf983b7ddaa);
$parcel$export($a7f8c6b391092279$exports, "N800", () => $a7f8c6b391092279$export$7d61b15e0da132af);
$parcel$export($a7f8c6b391092279$exports, "N900", () => $a7f8c6b391092279$export$fbda843f0a27fe96);
$parcel$export($a7f8c6b391092279$exports, "N10A", () => $a7f8c6b391092279$export$791e57b27ca738ef);
$parcel$export($a7f8c6b391092279$exports, "N20A", () => $a7f8c6b391092279$export$8d43898f60b96a82);
$parcel$export($a7f8c6b391092279$exports, "N30A", () => $a7f8c6b391092279$export$920c0d5c49070351);
$parcel$export($a7f8c6b391092279$exports, "N40A", () => $a7f8c6b391092279$export$46987b49aab6d1a8);
$parcel$export($a7f8c6b391092279$exports, "N50A", () => $a7f8c6b391092279$export$7d3359664e8bb0e5);
$parcel$export($a7f8c6b391092279$exports, "N60A", () => $a7f8c6b391092279$export$d2d3bedfb276cac0);
$parcel$export($a7f8c6b391092279$exports, "N70A", () => $a7f8c6b391092279$export$6e5e7499ff054f6d);
$parcel$export($a7f8c6b391092279$exports, "N80A", () => $a7f8c6b391092279$export$59264b346c877fa7);
$parcel$export($a7f8c6b391092279$exports, "N90A", () => $a7f8c6b391092279$export$d092757d7c64925c);
$parcel$export($a7f8c6b391092279$exports, "N100A", () => $a7f8c6b391092279$export$486ab785e4bac3c6);
$parcel$export($a7f8c6b391092279$exports, "N200A", () => $a7f8c6b391092279$export$fba592bbc6419fea);
$parcel$export($a7f8c6b391092279$exports, "N300A", () => $a7f8c6b391092279$export$13609db0e6812ab8);
$parcel$export($a7f8c6b391092279$exports, "N400A", () => $a7f8c6b391092279$export$fbae4efaa892d883);
$parcel$export($a7f8c6b391092279$exports, "N500A", () => $a7f8c6b391092279$export$f13946d26f440ce6);
$parcel$export($a7f8c6b391092279$exports, "N600A", () => $a7f8c6b391092279$export$19f58225ac52a306);
$parcel$export($a7f8c6b391092279$exports, "N700A", () => $a7f8c6b391092279$export$6384f09da70e7b62);
$parcel$export($a7f8c6b391092279$exports, "N800A", () => $a7f8c6b391092279$export$d0dccc730683edc2);
$parcel$export($a7f8c6b391092279$exports, "DN900", () => $a7f8c6b391092279$export$2f6319cf7d736c2a);
$parcel$export($a7f8c6b391092279$exports, "DN800", () => $a7f8c6b391092279$export$95126bc8884d6634);
$parcel$export($a7f8c6b391092279$exports, "DN700", () => $a7f8c6b391092279$export$8338d8c35d44ff1);
$parcel$export($a7f8c6b391092279$exports, "DN600", () => $a7f8c6b391092279$export$5368d76ae4fbbda7);
$parcel$export($a7f8c6b391092279$exports, "DN500", () => $a7f8c6b391092279$export$9f0a771d16ec8d36);
$parcel$export($a7f8c6b391092279$exports, "DN400", () => $a7f8c6b391092279$export$abcf8c38338b4aa5);
$parcel$export($a7f8c6b391092279$exports, "DN300", () => $a7f8c6b391092279$export$97e81faa16a182c7);
$parcel$export($a7f8c6b391092279$exports, "DN200", () => $a7f8c6b391092279$export$bfe21c59123ecf33);
$parcel$export($a7f8c6b391092279$exports, "DN100", () => $a7f8c6b391092279$export$ee82aa2ea6a1558);
$parcel$export($a7f8c6b391092279$exports, "DN90", () => $a7f8c6b391092279$export$682927c6ed76be02);
$parcel$export($a7f8c6b391092279$exports, "DN80", () => $a7f8c6b391092279$export$91fd9994c5be9757);
$parcel$export($a7f8c6b391092279$exports, "DN70", () => $a7f8c6b391092279$export$d281fbfe3cff2df6);
$parcel$export($a7f8c6b391092279$exports, "DN60", () => $a7f8c6b391092279$export$3902c91d8b98a753);
$parcel$export($a7f8c6b391092279$exports, "DN50", () => $a7f8c6b391092279$export$8e8133c1ba5845b5);
$parcel$export($a7f8c6b391092279$exports, "DN40", () => $a7f8c6b391092279$export$33ff357f6620b39);
$parcel$export($a7f8c6b391092279$exports, "DN30", () => $a7f8c6b391092279$export$633847cf062b69e0);
$parcel$export($a7f8c6b391092279$exports, "DN20", () => $a7f8c6b391092279$export$9776a6e503bdbf76);
$parcel$export($a7f8c6b391092279$exports, "DN10", () => $a7f8c6b391092279$export$6c813d5160dff5db);
$parcel$export($a7f8c6b391092279$exports, "DN0", () => $a7f8c6b391092279$export$3d4f271a500072a);
$parcel$export($a7f8c6b391092279$exports, "DN800A", () => $a7f8c6b391092279$export$fe151285c22759ec);
$parcel$export($a7f8c6b391092279$exports, "DN700A", () => $a7f8c6b391092279$export$a101c6190d0da34);
$parcel$export($a7f8c6b391092279$exports, "DN600A", () => $a7f8c6b391092279$export$4b16f52932fda51);
$parcel$export($a7f8c6b391092279$exports, "DN500A", () => $a7f8c6b391092279$export$a74bcd7b9845b0d8);
$parcel$export($a7f8c6b391092279$exports, "DN400A", () => $a7f8c6b391092279$export$9209c179316d1751);
$parcel$export($a7f8c6b391092279$exports, "DN300A", () => $a7f8c6b391092279$export$88f55133f636c8dd);
$parcel$export($a7f8c6b391092279$exports, "DN200A", () => $a7f8c6b391092279$export$51126f85d1009512);
$parcel$export($a7f8c6b391092279$exports, "DN100A", () => $a7f8c6b391092279$export$a069b547bd23af78);
$parcel$export($a7f8c6b391092279$exports, "DN90A", () => $a7f8c6b391092279$export$40cce05af3b2600a);
$parcel$export($a7f8c6b391092279$exports, "DN80A", () => $a7f8c6b391092279$export$b78942185925a0d);
$parcel$export($a7f8c6b391092279$exports, "DN70A", () => $a7f8c6b391092279$export$e058fb44b8eaafca);
$parcel$export($a7f8c6b391092279$exports, "DN60A", () => $a7f8c6b391092279$export$92b0b8de26920c18);
$parcel$export($a7f8c6b391092279$exports, "DN50A", () => $a7f8c6b391092279$export$67564f7459d3fc9e);
$parcel$export($a7f8c6b391092279$exports, "DN40A", () => $a7f8c6b391092279$export$77868e1ca884ffa3);
$parcel$export($a7f8c6b391092279$exports, "DN30A", () => $a7f8c6b391092279$export$2afd71d7d3ea2cd5);
$parcel$export($a7f8c6b391092279$exports, "DN20A", () => $a7f8c6b391092279$export$f2a0acaab9972c70);
$parcel$export($a7f8c6b391092279$exports, "DN10A", () => $a7f8c6b391092279$export$9ab70e67d6475361);
$parcel$export($a7f8c6b391092279$exports, "T30", () => $a7f8c6b391092279$export$d2adc5dedf09fced);
$parcel$export($a7f8c6b391092279$exports, "L50", () => $a7f8c6b391092279$export$f51762073d2bb381);
$parcel$export($a7f8c6b391092279$exports, "L75", () => $a7f8c6b391092279$export$95e26d54def96891);
// Reds
const $a7f8c6b391092279$export$4b84fd0e2c617bd = '#FFEBE6';
const $a7f8c6b391092279$export$b34b069eff244586 = '#FFBDAD';
const $a7f8c6b391092279$export$be802dd0d8b57f35 = '#FF8F73';
const $a7f8c6b391092279$export$60847d42f9da92a6 = '#FF7452';
const $a7f8c6b391092279$export$4a7404f376229999 = '#FF5630';
const $a7f8c6b391092279$export$2010d0fb4295b346 = '#DE350B';
const $a7f8c6b391092279$export$2837b5a1a71d5c02 = '#BF2600';
const $a7f8c6b391092279$export$8d9596b529bbb9cf = '#FFFAE6';
const $a7f8c6b391092279$export$41060a744ab0b7ae = '#FFF0B3';
const $a7f8c6b391092279$export$1cc05bbbf340e559 = '#FFE380';
const $a7f8c6b391092279$export$5aae31392d72caaa = '#FFC400';
const $a7f8c6b391092279$export$c6930421db9fa514 = '#FFAB00';
const $a7f8c6b391092279$export$59619663aa6500fb = '#FF991F';
const $a7f8c6b391092279$export$874739ea9e379ab6 = '#FF8B00';
const $a7f8c6b391092279$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $a7f8c6b391092279$export$69a3bf21b9686c2b = '#ABF5D1';
const $a7f8c6b391092279$export$afbce1382ec95f73 = '#79F2C0';
const $a7f8c6b391092279$export$747d86715d4175de = '#57D9A3';
const $a7f8c6b391092279$export$940e1f69e873f202 = '#36B37E';
const $a7f8c6b391092279$export$a49394138f7b8e85 = '#00875A';
const $a7f8c6b391092279$export$6fa04827ac68a4fb = '#006644';
const $a7f8c6b391092279$export$226de0355ed012f8 = '#DEEBFF';
const $a7f8c6b391092279$export$8c13c2ee36917869 = '#B3D4FF';
const $a7f8c6b391092279$export$ecfc1dff386a3e7a = '#4C9AFF';
const $a7f8c6b391092279$export$215b7063051591f1 = '#2684FF';
const $a7f8c6b391092279$export$e62e8919cca44969 = '#0065FF';
const $a7f8c6b391092279$export$b3de0ae08da2ce64 = '#0052CC';
const $a7f8c6b391092279$export$a6ee3d71bc067634 = '#0747A6';
const $a7f8c6b391092279$export$67f15409e87642a1 = '#669DF1';
const $a7f8c6b391092279$export$f0539dbc42dbb067 = '#8FB8F6';
const $a7f8c6b391092279$export$363e4475840015bb = '#EAE6FF';
const $a7f8c6b391092279$export$4b0a4417ed59760f = '#C0B6F2';
const $a7f8c6b391092279$export$6011520a64d9a187 = '#998DD9';
const $a7f8c6b391092279$export$a7175d4e9206bc80 = '#8777D9';
const $a7f8c6b391092279$export$b48405b95304b5a1 = '#6554C0';
const $a7f8c6b391092279$export$c71e4279dd54a18d = '#5243AA';
const $a7f8c6b391092279$export$147899de772240ec = '#403294';
const $a7f8c6b391092279$export$2cf711fe14c66f06 = '#E6FCFF';
const $a7f8c6b391092279$export$7a8f4d33f6f9772c = '#B3F5FF';
const $a7f8c6b391092279$export$776c9c497ef08533 = '#79E2F2';
const $a7f8c6b391092279$export$69cb3ca10c1e330e = '#00C7E6';
const $a7f8c6b391092279$export$9dc1ef0f3f48059b = '#00B8D9';
const $a7f8c6b391092279$export$7c835c78b6fcdef8 = '#00A3BF';
const $a7f8c6b391092279$export$6036577f95c3877e = '#008DA6';
const $a7f8c6b391092279$export$29a4f05edc054374 = '#FFFFFF';
const $a7f8c6b391092279$export$e655ef011c4aa1a2 = '#FAFBFC';
const $a7f8c6b391092279$export$9fdfb749e33cdf97 = '#F4F5F7';
const $a7f8c6b391092279$export$3e51e8f1440314ba = '#EBECF0';
const $a7f8c6b391092279$export$1ce2d1575d444ceb = '#DFE1E6';
const $a7f8c6b391092279$export$8754fc7e6d8b3000 = '#C1C7D0';
const $a7f8c6b391092279$export$c2e91cbeada39b8b = '#B3BAC5';
const $a7f8c6b391092279$export$5f71e19f3a7ad9de = '#A5ADBA';
const $a7f8c6b391092279$export$eaa8c8a70ac22806 = '#97A0AF';
const $a7f8c6b391092279$export$7c87d337fb91a97d = '#8993A4';
const $a7f8c6b391092279$export$d6447c357493214f = '#7A869A';
const $a7f8c6b391092279$export$f563ee71e9ee74cd = '#6B778C';
const $a7f8c6b391092279$export$e2ef2124cf4024b1 = '#5E6C84';
const $a7f8c6b391092279$export$eece5f492e429f08 = '#505F79';
const $a7f8c6b391092279$export$c39c0fe0f26207ae = '#42526E';
const $a7f8c6b391092279$export$7090862dc3038a9f = '#344563';
const $a7f8c6b391092279$export$ad0bacf983b7ddaa = '#253858';
const $a7f8c6b391092279$export$7d61b15e0da132af = '#172B4D';
const $a7f8c6b391092279$export$fbda843f0a27fe96 = '#091E42';
const $a7f8c6b391092279$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $a7f8c6b391092279$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $a7f8c6b391092279$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $a7f8c6b391092279$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $a7f8c6b391092279$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $a7f8c6b391092279$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $a7f8c6b391092279$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $a7f8c6b391092279$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $a7f8c6b391092279$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $a7f8c6b391092279$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $a7f8c6b391092279$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $a7f8c6b391092279$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $a7f8c6b391092279$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $a7f8c6b391092279$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $a7f8c6b391092279$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $a7f8c6b391092279$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $a7f8c6b391092279$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $a7f8c6b391092279$export$2f6319cf7d736c2a = '#E6EDFA';
const $a7f8c6b391092279$export$95126bc8884d6634 = '#DCE5F5';
const $a7f8c6b391092279$export$8338d8c35d44ff1 = '#CED9EB';
const $a7f8c6b391092279$export$5368d76ae4fbbda7 = '#B8C7E0';
const $a7f8c6b391092279$export$9f0a771d16ec8d36 = '#ABBBD6';
const $a7f8c6b391092279$export$abcf8c38338b4aa5 = '#9FB0CC';
const $a7f8c6b391092279$export$97e81faa16a182c7 = '#8C9CB8';
const $a7f8c6b391092279$export$bfe21c59123ecf33 = '#7988A3';
const $a7f8c6b391092279$export$ee82aa2ea6a1558 = '#67758F';
const $a7f8c6b391092279$export$682927c6ed76be02 = '#56637A';
const $a7f8c6b391092279$export$91fd9994c5be9757 = '#455166';
const $a7f8c6b391092279$export$d281fbfe3cff2df6 = '#3B475C';
const $a7f8c6b391092279$export$3902c91d8b98a753 = '#313D52';
const $a7f8c6b391092279$export$8e8133c1ba5845b5 = '#283447';
const $a7f8c6b391092279$export$33ff357f6620b39 = '#202B3D';
const $a7f8c6b391092279$export$633847cf062b69e0 = '#1B2638';
const $a7f8c6b391092279$export$9776a6e503bdbf76 = '#121A29';
const $a7f8c6b391092279$export$6c813d5160dff5db = '#0E1624';
const $a7f8c6b391092279$export$3d4f271a500072a = '#0D1424';
const $a7f8c6b391092279$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $a7f8c6b391092279$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $a7f8c6b391092279$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $a7f8c6b391092279$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $a7f8c6b391092279$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $a7f8c6b391092279$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $a7f8c6b391092279$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $a7f8c6b391092279$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $a7f8c6b391092279$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $a7f8c6b391092279$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $a7f8c6b391092279$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $a7f8c6b391092279$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $a7f8c6b391092279$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $a7f8c6b391092279$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $a7f8c6b391092279$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $a7f8c6b391092279$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $a7f8c6b391092279$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $a7f8c6b391092279$export$d2adc5dedf09fced = '#292A2E';
const $a7f8c6b391092279$export$f51762073d2bb381 = '#94C748';
const $a7f8c6b391092279$export$95e26d54def96891 = '#B3DF72';

parcelRegister("j7QuV", function(module, exports) {

$parcel$export(module.exports, "default", () => $55c741f6997b2d85$export$2e2bcd8739ae039);
function $55c741f6997b2d85$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $55c741f6997b2d85$var$tabKeyCode = 9;
function $55c741f6997b2d85$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $55c741f6997b2d85$var$tabKeyCode) return;
    $55c741f6997b2d85$var$abort(event);
}
const $55c741f6997b2d85$var$block = {
    onMouseDownCapture: $55c741f6997b2d85$var$abort,
    onMouseUpCapture: $55c741f6997b2d85$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $55c741f6997b2d85$var$onKey,
    onKeyUpCapture: $55c741f6997b2d85$var$onKey,
    onTouchStartCapture: $55c741f6997b2d85$var$abort,
    onTouchEndCapture: $55c741f6997b2d85$var$abort,
    onPointerDownCapture: $55c741f6997b2d85$var$abort,
    onPointerUpCapture: $55c741f6997b2d85$var$abort,
    onClickCapture: $55c741f6997b2d85$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $55c741f6997b2d85$var$abort
};
const $55c741f6997b2d85$var$doNotBlock = {};
function $55c741f6997b2d85$export$2e2bcd8739ae039({ isInteractive: isInteractive }) {
    return isInteractive ? $55c741f6997b2d85$var$doNotBlock : $55c741f6997b2d85$var$block;
}

});

parcelRegister("aXhtj", function(module, exports) {

$parcel$export(module.exports, "getCss", () => $b65ee8698bacf257$export$955358618f994a11);
$parcel$export(module.exports, "getIconStyle", () => $b65ee8698bacf257$export$864eea3f4ec3368f);
$parcel$export(module.exports, "getContentStyle", () => $b65ee8698bacf257$export$7ad0316cc0dd65a);
$parcel$export(module.exports, "getFadingCss", () => $b65ee8698bacf257$export$1b5827d324e945b1);
$parcel$export(module.exports, "overlayCss", () => $b65ee8698bacf257$export$1a9fe1b84c876bb5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $fHpHg = parcelRequire("fHpHg");

var $b4a3S = parcelRequire("b4a3S");

var $eURBQ = parcelRequire("eURBQ");
const $b65ee8698bacf257$var$gridSize = (0, $b4a3S.gridSize)();
const $b65ee8698bacf257$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
const $b65ee8698bacf257$var$heights = {
    default: `${32 / 14}em`,
    // 32px
    compact: `${24 / 14}em`,
    none: 'auto'
};
const $b65ee8698bacf257$var$lineHeights = {
    default: $b65ee8698bacf257$var$heights.default,
    compact: $b65ee8698bacf257$var$heights.compact,
    none: 'inherit'
};
const $b65ee8698bacf257$var$padding = {
    // 10px gutter
    default: `0 ${$b65ee8698bacf257$var$gridSize + $b65ee8698bacf257$var$gridSize / 4}px`,
    compact: `0 ${$b65ee8698bacf257$var$gridSize + $b65ee8698bacf257$var$gridSize / 4}px`,
    none: '0'
};
const $b65ee8698bacf257$var$singleIconPadding = {
    // 2px gutter
    compact: `0 ${$b65ee8698bacf257$var$gridSize / 4}px`,
    default: `0 ${$b65ee8698bacf257$var$gridSize / 4}px`,
    none: '0'
};
const $b65ee8698bacf257$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const $b65ee8698bacf257$var$innerMargin = {
    content: `0 ${$b65ee8698bacf257$var$gridSize / 4}px`,
    icon: `0 ${$b65ee8698bacf257$var$gridSize / 4}px`
};
const $b65ee8698bacf257$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
const $b65ee8698bacf257$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    '&:not([disabled])::after': {
        ...$b65ee8698bacf257$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    },
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
const $b65ee8698bacf257$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #0C66E4)"
    }
};
const $b65ee8698bacf257$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #0C66E4)",
    '&:hover': {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: 'underline'
    }
};
const $b65ee8698bacf257$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
const $b65ee8698bacf257$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #172B4D)",
        textDecoration: 'underline'
    }
};
const $b65ee8698bacf257$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #F5CD47)"
    }
};
const $b65ee8698bacf257$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
const $b65ee8698bacf257$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    '&:not([disabled])::after': {
        ...$b65ee8698bacf257$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    }
};
const $b65ee8698bacf257$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $b65ee8698bacf257$var$getColor({ group: group, key: key, mode: mode }) {
    const rule = group[key] || group.default;
    return rule[mode];
}
function $b65ee8698bacf257$var$getColors({ appearance: appearance, key: key, mode: mode }) {
    return {
        background: $b65ee8698bacf257$var$getColor({
            group: (0, $eURBQ.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: `${$b65ee8698bacf257$var$getColor({
            group: (0, $eURBQ.default).color[appearance],
            key: key,
            mode: mode
        })} !important`
    };
}
function $b65ee8698bacf257$export$955358618f994a11({ appearance: appearance, spacing: spacing, mode: mode, isSelected: isSelected, shouldFitContainer: shouldFitContainer, isOnlySingleIcon: isOnlySingleIcon }) {
    const baseColors = $b65ee8698bacf257$var$getColors({
        appearance: appearance,
        key: isSelected ? 'selected' : 'default',
        mode: mode
    });
    return {
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        // dynamic styles
        ...!(0, $fHpHg.fg)('platform-component-visual-refresh') && baseColors,
        cursor: 'pointer',
        height: $b65ee8698bacf257$var$heights[spacing],
        lineHeight: $b65ee8698bacf257$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $b65ee8698bacf257$var$singleIconPadding[spacing] : $b65ee8698bacf257$var$padding[spacing],
        verticalAlign: $b65ee8698bacf257$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        // Note: we cannot disable pointer events when there is an overlay.
        // That would be easy for styling, but it would start letting events through on disabled buttons
        ...!(0, $fHpHg.fg)('platform-component-visual-refresh') && {
            // Disabling visited styles (just using the base colors)
            '&:visited': {
                ...baseColors
            },
            '&:hover': {
                ...$b65ee8698bacf257$var$getColors({
                    appearance: appearance,
                    key: isSelected ? 'selected' : 'hover',
                    mode: mode
                }),
                textDecoration: !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? 'underline' : 'inherit',
                // background, box-shadow
                transitionDuration: '0s, 0.15s'
            },
            // giving active styles preference by listing them after focus
            '&:active': {
                ...$b65ee8698bacf257$var$getColors({
                    appearance: appearance,
                    key: isSelected ? 'selected' : 'active',
                    mode: mode
                }),
                // background, box-shadow
                transitionDuration: '0s, 0s'
            },
            // preventDefault prevents regular active styles from applying in Firefox
            '&[data-firefox-is-active="true"]': {
                ...$b65ee8698bacf257$var$getColors({
                    appearance: appearance,
                    key: isSelected ? 'selected' : 'active',
                    mode: mode
                }),
                // background, box-shadow
                transitionDuration: '0s, 0s'
            },
            // Giving disabled styles preference over active by listing them after.
            // Not using '&:disabled' because :disabled is not a valid state for all element types
            // so we are targeting the attribute
            // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
            '&[disabled]': {
                // always using 'disabled' even when selected
                ...$b65ee8698bacf257$var$getColors({
                    appearance: appearance,
                    key: 'disabled',
                    mode: mode
                }),
                cursor: 'not-allowed',
                textDecoration: 'none'
            },
            ...$b65ee8698bacf257$var$hasOverlayStyles,
            // disabling hover and active color changes when there is an overlay, but the button is not disabled
            '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': {
                ...$b65ee8698bacf257$var$getColors({
                    appearance: appearance,
                    key: isSelected ? 'selected' : 'default',
                    mode: mode
                })
            }
        },
        // dynamic colours for visual refresh:
        ...(0, $fHpHg.fg)('platform-component-visual-refresh') && (isSelected ? $b65ee8698bacf257$var$selectedStyles : {
            ...appearance === 'default' && $b65ee8698bacf257$var$defaultStyles,
            ...appearance === 'primary' && $b65ee8698bacf257$var$primaryStyles,
            ...appearance === 'link' && $b65ee8698bacf257$var$linkStyles,
            ...appearance === 'subtle' && $b65ee8698bacf257$var$subtleStyles,
            ...appearance === 'subtle-link' && $b65ee8698bacf257$var$subtleLinkStyles,
            ...appearance === 'warning' && $b65ee8698bacf257$var$warningStyles,
            ...appearance === 'danger' && $b65ee8698bacf257$var$dangerStyles,
            '&[disabled]': {
                color: "var(--ds-text-disabled, #091E424F)",
                backgroundColor: $b65ee8698bacf257$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent',
                cursor: 'not-allowed',
                textDecoration: 'none',
                '&:hovered': {
                    backgroundColor: $b65ee8698bacf257$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
                },
                '&:active': {
                    backgroundColor: $b65ee8698bacf257$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
                }
            },
            ...$b65ee8698bacf257$var$hasOverlayStyles
        }),
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    };
}
function $b65ee8698bacf257$export$864eea3f4ec3368f({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $b65ee8698bacf257$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $b65ee8698bacf257$export$7ad0316cc0dd65a({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $b65ee8698bacf257$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $b65ee8698bacf257$export$1b5827d324e945b1({ hasOverlay: hasOverlay }) {
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
const $b65ee8698bacf257$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});
parcelRegister("b4a3S", function(module, exports) {

$parcel$export(module.exports, "borderRadius", () => $48d75fd15aded330$export$7a57f79000377ca2);
$parcel$export(module.exports, "gridSize", () => $48d75fd15aded330$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "noFocusRing", () => $48d75fd15aded330$export$c0dd343266bc3261);
$parcel$export(module.exports, "layers", () => $48d75fd15aded330$export$7be255094ccdc533);
$parcel$export(module.exports, "skeletonShimmer", () => $48d75fd15aded330$export$e497e856b4f89fcd);

var $lGEY5 = parcelRequire("lGEY5");

const $48d75fd15aded330$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
const $48d75fd15aded330$export$c93026a968943f95 = 'light';
const $48d75fd15aded330$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
const $48d75fd15aded330$export$7a57f79000377ca2 = ()=>3;
const $48d75fd15aded330$export$6d8204c2cb2e06b8 = ()=>8;
const $48d75fd15aded330$export$8e24544ddba725ee = (color = `var(--ds-border-focused, ${0, $a7f8c6b391092279$export$215b7063051591f1})`, outlineWidth = $48d75fd15aded330$export$6d8204c2cb2e06b8() / 4)=>{
    (0, $lGEY5.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return `
  &:focus {
    outline: none;
    box-shadow: 0px 0px 0px ${outlineWidth}px ${color};
  }
`;
};
const $48d75fd15aded330$export$c0dd343266bc3261 = ()=>`
  box-shadow: none;
`;
const $48d75fd15aded330$export$7be255094ccdc533 = {
    card: ()=>100,
    navigation: ()=>200,
    dialog: ()=>300,
    layer: ()=>400,
    blanket: ()=>500,
    modal: ()=>510,
    flag: ()=>600,
    spotlight: ()=>700,
    tooltip: ()=>9999
};
const $48d75fd15aded330$export$a1b3edb637fb4f35 = ()=>{
    (0, $lGEY5.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
const $48d75fd15aded330$export$ba1d834b86d72a09 = $48d75fd15aded330$export$a1b3edb637fb4f35;
const $48d75fd15aded330$export$e497e856b4f89fcd = ()=>({
        css: {
            backgroundColor: `var(--ds-skeleton, ${0, $a7f8c6b391092279$export$8d43898f60b96a82})`,
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: `var(--ds-skeleton, ${0, $a7f8c6b391092279$export$8d43898f60b96a82})`
            },
            to: {
                backgroundColor: `var(--ds-skeleton-subtle, ${0, $a7f8c6b391092279$export$920c0d5c49070351})`
            }
        }
    });

});
parcelRegister("lGEY5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1608125c3ce67296$export$2e2bcd8739ae039);
$parcel$export(module.exports, "propDeprecationWarning", () => $1608125c3ce67296$export$eb1decd851a5ae56);

var $bSTaj = parcelRequire("bSTaj");

var $6cAn5 = parcelRequire("6cAn5");
function $1608125c3ce67296$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $bSTaj.default)(`[${packageName}]: The ${api} is deprecated.${additionalMessage && ` ${additionalMessage}`}`);
}
function $1608125c3ce67296$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $6cAn5;
}

});
parcelRegister("bSTaj", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dcd88284609e36b$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $4dcd88284609e36b$var$printed = {};
function $4dcd88284609e36b$export$2e2bcd8739ae039(message) {
    if ($4dcd88284609e36b$var$printed[message]) return;
    $4dcd88284609e36b$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});



parcelRegister("eURBQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $881754bab9771149$export$2e2bcd8739ae039);

// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
const $881754bab9771149$var$fadedB75 = 'rgba(179, 212, 255, 0.6)';
const $881754bab9771149$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: `var(--ds-background-neutral, ${$a7f8c6b391092279$export$8d43898f60b96a82})`,
                dark: `var(--ds-background-neutral, ${$a7f8c6b391092279$export$d281fbfe3cff2df6})`
            },
            hover: {
                light: `var(--ds-background-neutral-hovered, ${$a7f8c6b391092279$export$920c0d5c49070351})`,
                dark: `var(--ds-background-neutral-hovered, ${$a7f8c6b391092279$export$3902c91d8b98a753})`
            },
            active: {
                light: `var(--ds-background-neutral-pressed, ${$881754bab9771149$var$fadedB75})`,
                dark: `var(--ds-background-neutral-pressed, ${$a7f8c6b391092279$export$8c13c2ee36917869})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$a7f8c6b391092279$export$8d43898f60b96a82})`,
                dark: `var(--ds-background-disabled, ${$a7f8c6b391092279$export$d281fbfe3cff2df6})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$a7f8c6b391092279$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected, ${$a7f8c6b391092279$export$3d4f271a500072a})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$a7f8c6b391092279$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected, ${$a7f8c6b391092279$export$3d4f271a500072a})`
            }
        },
        primary: {
            default: {
                light: `var(--ds-background-brand-bold, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
                dark: `var(--ds-background-brand-bold, ${$a7f8c6b391092279$export$ecfc1dff386a3e7a})`
            },
            hover: {
                light: `var(--ds-background-brand-bold-hovered, ${$a7f8c6b391092279$export$e62e8919cca44969})`,
                dark: `var(--ds-background-brand-bold-hovered, ${$a7f8c6b391092279$export$8c13c2ee36917869})`
            },
            active: {
                light: `var(--ds-background-brand-bold-pressed, ${$a7f8c6b391092279$export$a6ee3d71bc067634})`,
                dark: `var(--ds-background-brand-bold-pressed, ${$a7f8c6b391092279$export$215b7063051591f1})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$a7f8c6b391092279$export$8d43898f60b96a82})`,
                dark: `var(--ds-background-disabled, ${$a7f8c6b391092279$export$d281fbfe3cff2df6})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$a7f8c6b391092279$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected, ${$a7f8c6b391092279$export$3d4f271a500072a})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$a7f8c6b391092279$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected, ${$a7f8c6b391092279$export$3d4f271a500072a})`
            }
        },
        warning: {
            default: {
                light: `var(--ds-background-warning-bold, ${$a7f8c6b391092279$export$c6930421db9fa514})`,
                dark: `var(--ds-background-warning-bold, ${$a7f8c6b391092279$export$c6930421db9fa514})`
            },
            hover: {
                light: `var(--ds-background-warning-bold-hovered, ${$a7f8c6b391092279$export$5aae31392d72caaa})`,
                dark: `var(--ds-background-warning-bold-hovered, ${$a7f8c6b391092279$export$5aae31392d72caaa})`
            },
            active: {
                light: `var(--ds-background-warning-bold-pressed, ${$a7f8c6b391092279$export$59619663aa6500fb})`,
                dark: `var(--ds-background-warning-bold-pressed, ${$a7f8c6b391092279$export$59619663aa6500fb})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$a7f8c6b391092279$export$8d43898f60b96a82})`,
                dark: `var(--ds-background-disabled, ${$a7f8c6b391092279$export$d281fbfe3cff2df6})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$a7f8c6b391092279$export$59619663aa6500fb})`,
                dark: `var(--ds-background-selected, ${$a7f8c6b391092279$export$59619663aa6500fb})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$a7f8c6b391092279$export$59619663aa6500fb})`,
                dark: `var(--ds-background-selected, ${$a7f8c6b391092279$export$59619663aa6500fb})`
            }
        },
        danger: {
            default: {
                light: `var(--ds-background-danger-bold, ${$a7f8c6b391092279$export$2010d0fb4295b346})`,
                dark: `var(--ds-background-danger-bold, ${$a7f8c6b391092279$export$2010d0fb4295b346})`
            },
            hover: {
                light: `var(--ds-background-danger-bold-hovered, ${$a7f8c6b391092279$export$4a7404f376229999})`,
                dark: `var(--ds-background-danger-bold-hovered, ${$a7f8c6b391092279$export$4a7404f376229999})`
            },
            active: {
                light: `var(--ds-background-danger-bold-pressed, ${$a7f8c6b391092279$export$2837b5a1a71d5c02})`,
                dark: `var(--ds-background-danger-bold-pressed, ${$a7f8c6b391092279$export$2837b5a1a71d5c02})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$a7f8c6b391092279$export$8d43898f60b96a82})`,
                dark: `var(--ds-background-disabled, ${$a7f8c6b391092279$export$d281fbfe3cff2df6})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$a7f8c6b391092279$export$2837b5a1a71d5c02})`,
                dark: `var(--ds-background-selected, ${$a7f8c6b391092279$export$2837b5a1a71d5c02})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$a7f8c6b391092279$export$2837b5a1a71d5c02})`,
                dark: `var(--ds-background-selected, ${$a7f8c6b391092279$export$2837b5a1a71d5c02})`
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: `var(--ds-background-selected, ${$a7f8c6b391092279$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected, ${$a7f8c6b391092279$export$9fdfb749e33cdf97})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$a7f8c6b391092279$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected, ${$a7f8c6b391092279$export$9fdfb749e33cdf97})`
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: `var(--ds-background-neutral-subtle-hovered, ${$a7f8c6b391092279$export$920c0d5c49070351})`,
                dark: `var(--ds-background-neutral-subtle-hovered, ${$a7f8c6b391092279$export$3902c91d8b98a753})`
            },
            active: {
                light: `var(--ds-background-neutral-subtle-pressed, ${$881754bab9771149$var$fadedB75})`,
                dark: `var(--ds-background-neutral-subtle-pressed, ${$a7f8c6b391092279$export$8c13c2ee36917869})`
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: `var(--ds-background-selected, ${$a7f8c6b391092279$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected, ${$a7f8c6b391092279$export$3d4f271a500072a})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$a7f8c6b391092279$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected, ${$a7f8c6b391092279$export$3d4f271a500072a})`
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: `var(--ds-background-selected, ${$a7f8c6b391092279$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected, ${$a7f8c6b391092279$export$9fdfb749e33cdf97})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$a7f8c6b391092279$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected, ${$a7f8c6b391092279$export$9fdfb749e33cdf97})`
            }
        }
    },
    color: {
        default: {
            default: {
                light: `var(--ds-text, ${$a7f8c6b391092279$export$c39c0fe0f26207ae})`,
                dark: `var(--ds-text, ${$a7f8c6b391092279$export$abcf8c38338b4aa5})`
            },
            active: {
                light: `var(--ds-text, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
                dark: `var(--ds-text, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$a7f8c6b391092279$export$5f71e19f3a7ad9de})`,
                dark: `var(--ds-text-disabled, ${$a7f8c6b391092279$export$633847cf062b69e0})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$a7f8c6b391092279$export$9fdfb749e33cdf97})`,
                dark: `var(--ds-text-selected, ${$a7f8c6b391092279$export$abcf8c38338b4aa5})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$a7f8c6b391092279$export$9fdfb749e33cdf97})`,
                dark: `var(--ds-text-selected, ${$a7f8c6b391092279$export$abcf8c38338b4aa5})`
            }
        },
        primary: {
            default: {
                light: `var(--ds-text-inverse, ${$a7f8c6b391092279$export$29a4f05edc054374})`,
                dark: `var(--ds-text-inverse, ${$a7f8c6b391092279$export$633847cf062b69e0})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$a7f8c6b391092279$export$5f71e19f3a7ad9de})`,
                dark: `var(--ds-text-disabled, ${$a7f8c6b391092279$export$633847cf062b69e0})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$a7f8c6b391092279$export$9fdfb749e33cdf97})`,
                dark: `var(--ds-text-selected, ${$a7f8c6b391092279$export$abcf8c38338b4aa5})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$a7f8c6b391092279$export$9fdfb749e33cdf97})`,
                dark: `var(--ds-text-selected, ${$a7f8c6b391092279$export$abcf8c38338b4aa5})`
            }
        },
        warning: {
            default: {
                light: `var(--ds-text-warning-inverse, ${$a7f8c6b391092279$export$7d61b15e0da132af})`,
                dark: `var(--ds-text-warning-inverse, ${$a7f8c6b391092279$export$7d61b15e0da132af})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$a7f8c6b391092279$export$5f71e19f3a7ad9de})`,
                dark: `var(--ds-text-disabled, ${$a7f8c6b391092279$export$633847cf062b69e0})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$a7f8c6b391092279$export$7d61b15e0da132af})`,
                dark: `var(--ds-text-selected, ${$a7f8c6b391092279$export$7d61b15e0da132af})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$a7f8c6b391092279$export$7d61b15e0da132af})`,
                dark: `var(--ds-text-selected, ${$a7f8c6b391092279$export$7d61b15e0da132af})`
            }
        },
        danger: {
            default: {
                light: `var(--ds-text-inverse, ${$a7f8c6b391092279$export$29a4f05edc054374})`,
                dark: `var(--ds-text-inverse, ${$a7f8c6b391092279$export$29a4f05edc054374})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$a7f8c6b391092279$export$5f71e19f3a7ad9de})`,
                dark: `var(--ds-text-disabled, ${$a7f8c6b391092279$export$633847cf062b69e0})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$a7f8c6b391092279$export$29a4f05edc054374})`,
                dark: `var(--ds-text-selected, ${$a7f8c6b391092279$export$29a4f05edc054374})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$a7f8c6b391092279$export$29a4f05edc054374})`,
                dark: `var(--ds-text-selected, ${$a7f8c6b391092279$export$29a4f05edc054374})`
            }
        },
        link: {
            default: {
                light: `var(--ds-link, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
                dark: `var(--ds-link, ${$a7f8c6b391092279$export$ecfc1dff386a3e7a})`
            },
            hover: {
                light: `var(--ds-link, ${$a7f8c6b391092279$export$e62e8919cca44969})`,
                dark: `var(--ds-link, ${$a7f8c6b391092279$export$8c13c2ee36917869})`
            },
            active: {
                light: `var(--ds-link-pressed, ${$a7f8c6b391092279$export$a6ee3d71bc067634})`,
                dark: `var(--ds-link-pressed, ${$a7f8c6b391092279$export$215b7063051591f1})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$a7f8c6b391092279$export$5f71e19f3a7ad9de})`,
                dark: `var(--ds-text-disabled, ${$a7f8c6b391092279$export$ee82aa2ea6a1558})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$a7f8c6b391092279$export$9fdfb749e33cdf97})`,
                dark: `var(--ds-text-selected, ${$a7f8c6b391092279$export$ad0bacf983b7ddaa})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$a7f8c6b391092279$export$9fdfb749e33cdf97})`,
                dark: `var(--ds-text-selected, ${$a7f8c6b391092279$export$ad0bacf983b7ddaa})`
            }
        },
        subtle: {
            default: {
                light: `var(--ds-text, ${$a7f8c6b391092279$export$c39c0fe0f26207ae})`,
                dark: `var(--ds-text, ${$a7f8c6b391092279$export$abcf8c38338b4aa5})`
            },
            active: {
                light: `var(--ds-text, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`,
                dark: `var(--ds-text, ${$a7f8c6b391092279$export$b3de0ae08da2ce64})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$a7f8c6b391092279$export$5f71e19f3a7ad9de})`,
                dark: `var(--ds-text-disabled, ${$a7f8c6b391092279$export$ee82aa2ea6a1558})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$a7f8c6b391092279$export$9fdfb749e33cdf97})`,
                dark: `var(--ds-text-selected, ${$a7f8c6b391092279$export$abcf8c38338b4aa5})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$a7f8c6b391092279$export$9fdfb749e33cdf97})`,
                dark: `var(--ds-text-selected, ${$a7f8c6b391092279$export$abcf8c38338b4aa5})`
            }
        },
        'subtle-link': {
            default: {
                light: `var(--ds-text-subtle, ${$a7f8c6b391092279$export$f563ee71e9ee74cd})`,
                dark: `var(--ds-text-subtle, ${$a7f8c6b391092279$export$abcf8c38338b4aa5})`
            },
            hover: {
                light: `var(--ds-text-subtle, ${$a7f8c6b391092279$export$7c87d337fb91a97d})`,
                dark: `var(--ds-text-subtle, ${$a7f8c6b391092279$export$226de0355ed012f8})`
            },
            active: {
                light: `var(--ds-text, ${$a7f8c6b391092279$export$eece5f492e429f08})`,
                dark: `var(--ds-text, ${$a7f8c6b391092279$export$97e81faa16a182c7})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$a7f8c6b391092279$export$5f71e19f3a7ad9de})`,
                dark: `var(--ds-text-disabled, ${$a7f8c6b391092279$export$ee82aa2ea6a1558})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$a7f8c6b391092279$export$9fdfb749e33cdf97})`,
                dark: `var(--ds-text-selected, ${$a7f8c6b391092279$export$abcf8c38338b4aa5})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$a7f8c6b391092279$export$9fdfb749e33cdf97})`,
                dark: `var(--ds-text-selected, ${$a7f8c6b391092279$export$abcf8c38338b4aa5})`
            }
        }
    }
};
var $881754bab9771149$export$2e2bcd8739ae039 = $881754bab9771149$var$values;

});


parcelRegister("9ncAe", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $70a1efe68152b5bd$export$20bbd2efb0d734c4);

var $5uXOq = parcelRequire("5uXOq");

var $cBCgC = parcelRequire("cBCgC");
const $70a1efe68152b5bd$export$20bbd2efb0d734c4 = (children)=>{
    return children && /*#__PURE__*/ (0, $5uXOq.isValidElement)(children) && children.type === (0, $cBCgC.default);
};

});
parcelRegister("cBCgC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7a59df1327889f6$export$2e2bcd8739ae039);
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $f7a59df1327889f6$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ const $f7a59df1327889f6$var$VisuallyHidden = ({ children: children, testId: testId, role: role, id: id })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ]),
        children: children
    });
};
var $f7a59df1327889f6$export$2e2bcd8739ae039 = $f7a59df1327889f6$var$VisuallyHidden;

});



parcelRegister("1iaMM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3b3bfc7849d7432$export$2e2bcd8739ae039);

var $9ncAe = parcelRequire("9ncAe");
function $a3b3bfc7849d7432$export$2e2bcd8739ae039({ children: children, iconBefore: iconBefore, iconAfter: iconAfter }) {
    if ((0, $9ncAe.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("i95f5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d17f947e803e7e87$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $ffDrH = parcelRequire("ffDrH");
/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ const $d17f947e803e7e87$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function LoadingButton({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, isLoading: isLoading = false, spacing: spacing, ...rest }, ref) {
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        // No need to render aria-disabled when it is false
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ffDrH.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    });
});
// Tools including enzyme rely on components having a display name
$d17f947e803e7e87$var$LoadingButton.displayName = 'LoadingButton';
var $d17f947e803e7e87$export$2e2bcd8739ae039 = $d17f947e803e7e87$var$LoadingButton;

});
parcelRegister("ffDrH", function(module, exports) {

$parcel$export(module.exports, "default", () => $28e89daaa44a5ebe$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $clxo5 = parcelRequire("clxo5");
function $28e89daaa44a5ebe$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $28e89daaa44a5ebe$export$2e2bcd8739ae039({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, spacing: spacing = 'default' }) {
    const size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {
        size: size,
        label: ", Loading",
        appearance: $28e89daaa44a5ebe$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("clxo5", function(module, exports) {

$parcel$export(module.exports, "default", () => $efa7d1d50d37d6cf$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $9ewsv = parcelRequire("9ewsv");


var $jq2tU = parcelRequire("jq2tU");
/**
 * Returns the appropriate circle stroke color.
 */ function $efa7d1d50d37d6cf$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? `var(--ds-icon-subtle, ${0, $a7f8c6b391092279$export$c39c0fe0f26207ae})` : `var(--ds-icon-inverse, ${0, $a7f8c6b391092279$export$29a4f05edc054374})`;
}
const $efa7d1d50d37d6cf$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ const $efa7d1d50d37d6cf$var$loadIn = null;
const $efa7d1d50d37d6cf$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ const $efa7d1d50d37d6cf$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5uXOq.useEffect) : (0, $5uXOq.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ const $efa7d1d50d37d6cf$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function Spinner({ appearance: appearance = 'inherit', delay: delay = 0, interactionName: interactionName, label: label, size: providedSize = 'medium', testId: testId }, ref) {
    const size = typeof providedSize === 'number' ? providedSize : (0, $jq2tU.presetSizes)[providedSize];
    const animationDelay = `${delay}ms`;
    const stroke = $efa7d1d50d37d6cf$var$getStrokeColor(appearance);
    const context = (0, $5uXOq.useContext)((0, $9ewsv.default));
    $efa7d1d50d37d6cf$var$useLayoutEffect(()=>{
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        /**
   * This span exists to off-load animations from the circle element,
   * which were causing performance issues (style recalculations)
   * on Safari and older versions of Chrome.
   *
   * This can be removed and styles placed back on the circle element once
   * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
   */ "data-testid": testId ? `${testId}-wrapper` : 'spinner-wrapper',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $bwpsq.default)([
            $efa7d1d50d37d6cf$var$styles.wrapperStyles,
            $efa7d1d50d37d6cf$var$styles.rotateStyles
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": testId,
            ref: ref,
            "aria-label": label || undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                animationDelay: animationDelay
            },
            role: label ? 'img' : 'none',
            className: (0, $bwpsq.default)([
                $efa7d1d50d37d6cf$var$styles.loadInStyles
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "7",
                style: {
                    stroke: stroke
                },
                className: (0, $bwpsq.default)([
                    $efa7d1d50d37d6cf$var$styles.circleStyles
                ])
            })
        })
    });
}));
var $efa7d1d50d37d6cf$export$2e2bcd8739ae039 = $efa7d1d50d37d6cf$var$Spinner;

});
parcelRegister("jq2tU", function(module, exports) {

$parcel$export(module.exports, "presetSizes", () => $1dc8a29b689e46f1$export$4e9f1640bbe7a1a8);
const $1dc8a29b689e46f1$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("1nSOt", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f54a51123235f33$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $l2QOa = parcelRequire("l2QOa");

var $4WJDn = parcelRequire("4WJDn");

var $1iaMM = parcelRequire("1iaMM");

var $ffDrH = parcelRequire("ffDrH");

var $ep3GE = parcelRequire("ep3GE");
function $2f54a51123235f33$var$getInteractionState({ isDisabled: isDisabled = false, isActive: isActive = false, isFocus: isFocus = false, isHover: isHover = false, isSelected: isSelected = false, isLoading: isLoading = false }) {
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
const $2f54a51123235f33$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ const $2f54a51123235f33$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function CustomThemeButton({ appearance: // Calculate default props for use in custom themes
appearance = 'default', autoFocus: autoFocus = false, isDisabled: isDisabled = false, isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', isLoading: isLoading = false, onMouseEnter: providedOnMouseEnter, onMouseLeave: providedOnMouseLeave, onMouseDown: providedOnMouseDown, onMouseUp: providedOnMouseUp, onFocus: providedOnFocus, onBlur: providedOnBlur, theme: theme = (0, $ep3GE.defaultThemeFn), ...rest }, ref) {
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    const restProps = {
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ...rest
    };
    const [state, setState] = (0, $5uXOq.useState)($2f54a51123235f33$var$initial);
    const onMouseEnter = (0, $5uXOq.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: true
            }));
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    const onMouseLeave = (0, $5uXOq.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: false,
                isActive: false
            }));
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    const onMouseDown = (0, $5uXOq.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: true
            }));
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    const onMouseUp = (0, $5uXOq.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: false
            }));
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    const onFocus = (0, $5uXOq.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: true
            }));
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    const onBlur = (0, $5uXOq.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: false
            }));
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ep3GE.default).Provider, {
        value: theme,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l2QOa.default).Consumer, {
            children: ({ mode: mode })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ep3GE.default).Consumer, {
                    mode: mode,
                    state: $2f54a51123235f33$var$getInteractionState({
                        ...state,
                        isLoading: isLoading,
                        isSelected: restProps.isSelected,
                        isDisabled: restProps.isDisabled
                    }),
                    iconIsOnlyChild: (0, $1iaMM.default)(restProps),
                    isLoading: isLoading,
                    ...restProps,
                    children: ({ buttonStyles: buttonStyles })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4WJDn.default), {
                            ...restProps,
                            ref: ref,
                            overlay: isLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ffDrH.default), {
                                ...restProps
                            }) : null,
                            // No need to render aria-disabled when it is false
                            "aria-disabled": isLoading || restProps['aria-disabled'],
                            onMouseEnter: onMouseEnter,
                            onMouseLeave: onMouseLeave,
                            onMouseDown: onMouseDown,
                            onMouseUp: onMouseUp,
                            onFocus: onFocus,
                            onBlur: onBlur,
                            buttonCss: (0, $ep3GE.getSpecifiers)(buttonStyles)
                        })
                })
        })
    });
}));
// Tools including enzyme rely on components having a display name
$2f54a51123235f33$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $2f54a51123235f33$export$2e2bcd8739ae039 = $2f54a51123235f33$var$CustomThemeButton;

});
parcelRegister("ep3GE", function(module, exports) {

$parcel$export(module.exports, "getSpecifiers", () => $f2230328edf4c085$export$643db0b8d8778e);
$parcel$export(module.exports, "defaultThemeFn", () => $f2230328edf4c085$export$437a7f77d13d7916);
$parcel$export(module.exports, "default", () => $f2230328edf4c085$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $cKNod = parcelRequire("cKNod");

var $aXhtj = parcelRequire("aXhtj");
const $f2230328edf4c085$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $f2230328edf4c085$export$31512de7fa606fa4({ appearance: appearance = 'default', spacing: spacing = 'default', mode: mode = 'light', isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, iconIsOnlyChild: iconIsOnlyChild = false, isLoading: isLoading = false, state: state }) {
    let result = (0, $aXhtj.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    const selector = $f2230328edf4c085$var$stateToSelectorMap[state];
    if (selector) result = {
        ...result,
        ...result[selector]
    };
    if (isLoading) result = {
        ...result,
        // Pull overlay styles up to the top
        ...result['&[data-has-overlay="true"]']
    };
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach((key)=>{
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}
function $f2230328edf4c085$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}
function $f2230328edf4c085$export$437a7f77d13d7916(current, values) {
    return current(values);
}
const $f2230328edf4c085$var$Theme = (0, $cKNod.createTheme)((themeProps)=>({
        buttonStyles: $f2230328edf4c085$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f2230328edf4c085$export$2e2bcd8739ae039 = $f2230328edf4c085$var$Theme;

});


parcelRegister("jHTSg", function(module, exports) {

$parcel$export(module.exports, "default", () => $164bc8260a604137$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
function $164bc8260a604137$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $164bc8260a604137$var$buttonGroupStyles = {
    name: "1oy5iav",
    styles: "display:inline-flex;gap:var(--ds-space-050, 4px);> *{flex:1 0 auto;}"
};
function $164bc8260a604137$export$2e2bcd8739ae039({ children: children, testId: testId, label: label, titleId: titleId }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $164bc8260a604137$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children), (child, idx)=>{
        if (!child) return null;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), {
            key: idx
        }, child);
    }));
}

});


parcelRegister("cnhic", function(module, exports) {

$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => (parcelRequire("dZtFw")).ELEMENTS_CONTEXT);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => (parcelRequire("dZtFw")).FabricElementsAnalyticsContext);
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => (parcelRequire("ijQ0g")).NAVIGATION_CONTEXT);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("ijQ0g")).NavigationAnalyticsContext);
$parcel$export(module.exports, "EDITOR_CONTEXT", () => (parcelRequire("df3mZ")).EDITOR_CONTEXT);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => (parcelRequire("df3mZ")).FabricEditorAnalyticsContext);
$parcel$export(module.exports, "MEDIA_CONTEXT", () => $86eff7942395d7f1$export$70df29c238ba7306);
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => (parcelRequire("eGyZ0")).PEOPLE_TEAMS_CONTEXT);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => (parcelRequire("eGyZ0")).PeopleTeamsAnalyticsContext);
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => (parcelRequire("5vo1b")).NOTIFICATIONS_CONTEXT);
$parcel$export(module.exports, "NotificationsAnalyticsContext", () => (parcelRequire("5vo1b")).NotificationsAnalyticsContext);
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => (parcelRequire("ir8t7")).RECENT_WORK_CONTEXT);
$parcel$export(module.exports, "RecentWorkAnalyticsContext", () => (parcelRequire("ir8t7")).RecentWorkAnalyticsContext);
$parcel$export(module.exports, "ATLAS_CONTEXT", () => (parcelRequire("2zY3Y")).ATLAS_CONTEXT);
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => (parcelRequire("bsk2y")).LINKING_PLATFORM_CONTEXT);
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => (parcelRequire("2m7ZL")).POST_OFFICE_CONTEXT);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => (parcelRequire("2m7ZL")).PostOfficeAnalyticsContext);
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => (parcelRequire("9YUki")).AI_MATE_CONTEXT);
$parcel$export(module.exports, "AIMateAnalyticsContext", () => (parcelRequire("9YUki")).AIMateAnalyticsContext);
$parcel$export(module.exports, "AVP_CONTEXT", () => (parcelRequire("k0kR6")).AVP_CONTEXT);
$parcel$export(module.exports, "GROWTH_CONTEXT", () => (parcelRequire("47pca")).GROWTH_CONTEXT);

var $dZtFw = parcelRequire("dZtFw");

var $ijQ0g = parcelRequire("ijQ0g");

var $df3mZ = parcelRequire("df3mZ");


var $eGyZ0 = parcelRequire("eGyZ0");

var $5vo1b = parcelRequire("5vo1b");

var $ir8t7 = parcelRequire("ir8t7");

var $2zY3Y = parcelRequire("2zY3Y");

var $bsk2y = parcelRequire("bsk2y");

var $2m7ZL = parcelRequire("2m7ZL");

var $9YUki = parcelRequire("9YUki");

var $k0kR6 = parcelRequire("k0kR6");

var $47pca = parcelRequire("47pca");

});
parcelRegister("dZtFw", function(module, exports) {

$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => $d9328e570258c173$export$80450e0a84a5ede9);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => $d9328e570258c173$export$3fe25500478a635c);

var $86G5q = parcelRequire("86G5q");
const $d9328e570258c173$export$80450e0a84a5ede9 = 'fabricElementsCtx';
const $d9328e570258c173$export$3fe25500478a635c = (0, $86G5q.default)($d9328e570258c173$export$80450e0a84a5ede9, 'FabricElementsAnalyticsContext');

});
parcelRegister("86G5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea0aebe9edbe5640$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $htBRZ = parcelRequire("htBRZ");
const $ea0aebe9edbe5640$var$createNamespaceContext = (namespace, displayName = 'NamespacedContext')=>{
    const Component = (props)=>{
        const newData = {
            [namespace]: props.data
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htBRZ.default), {
            data: newData,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(props.children)
        });
    };
    Component.displayName = displayName;
    return Component;
};
var $ea0aebe9edbe5640$export$2e2bcd8739ae039 = $ea0aebe9edbe5640$var$createNamespaceContext;

});
parcelRegister("htBRZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $161b548a01e1f817$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $9tX7s = parcelRequire("9tX7s");

var $7kBI2 = parcelRequire("7kBI2");

var $7QRS4 = parcelRequire("7QRS4");
const $161b548a01e1f817$var$ExportedAnalyticsContext = (props)=>{
    const isModernContext = (0, $9tX7s.default) || (0, $fHpHg.fg)('analytics-next-use-modern-context_jira');
    return isModernContext ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QRS4.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7kBI2.default), {
        ...props
    });
};
var $161b548a01e1f817$export$2e2bcd8739ae039 = $161b548a01e1f817$var$ExportedAnalyticsContext;

});
parcelRegister("9tX7s", function(module, exports) {

$parcel$export(module.exports, "default", () => $59dd2b8bea4c719e$export$2e2bcd8739ae039);
/// <reference types="node" />

var $6cAn5 = parcelRequire("6cAn5");
var $59dd2b8bea4c719e$export$2e2bcd8739ae039 = typeof $6cAn5 !== 'undefined' && $6cAn5 !== null && $6cAn5.env?.['ANALYTICS_NEXT_MODERN_CONTEXT'];

});

parcelRegister("7kBI2", function(module, exports) {

$parcel$export(module.exports, "default", () => $7537df5e78f1f44a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");

var $fy0vt = parcelRequire("fy0vt");
const $7537df5e78f1f44a$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func
};
const $7537df5e78f1f44a$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $7537df5e78f1f44a$var$AnalyticsContext extends (0, $5uXOq.Component) {
    static{
        this.contextTypes = $7537df5e78f1f44a$var$ContextTypes;
    }
    static{
        this.childContextTypes = $7537df5e78f1f44a$var$ContextTypes;
    }
    constructor(props){
        super(props), this.getChildContext = ()=>({
                getAtlaskitAnalyticsContext: this.getAnalyticsContext
            }), this.getAnalyticsContext = ()=>{
            const { data: data } = this.props;
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $7537df5e78f1f44a$var$noop } = this.context;
            return [
                ...getAtlaskitAnalyticsContext(),
                data
            ];
        }, this.getAnalyticsEventHandlers = ()=>{
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $7537df5e78f1f44a$var$noop } = this.context;
            return getAtlaskitAnalyticsEventHandlers();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fy0vt.default).Provider, {
            value: this.contextValue,
            children: children
        });
    }
}
var $7537df5e78f1f44a$export$2e2bcd8739ae039 = $7537df5e78f1f44a$var$AnalyticsContext;

});

parcelRegister("7QRS4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f61506011f1ee143$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fy0vt = parcelRequire("fy0vt");

var $d5pZX = parcelRequire("d5pZX");

var $cLmtE = parcelRequire("cLmtE");
const $f61506011f1ee143$var$AnalyticsContext = ({ data: data, children: children })=>{
    const dataRef = (0, $cLmtE.useTrackedRef)(data);
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsContext: getOriginalAnalyticsContext } = (0, $d5pZX.useAnalyticsContext)();
    const getAtlaskitAnalyticsContext = (0, $5uXOq.useCallback)(()=>{
        return [
            ...getOriginalAnalyticsContext(),
            dataRef.current
        ];
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    const value = (0, $5uXOq.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fy0vt.default).Provider, {
        value: value,
        children: children
    });
};
var $f61506011f1ee143$export$2e2bcd8739ae039 = $f61506011f1ee143$var$AnalyticsContext;

});




parcelRegister("ijQ0g", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => $70def46d82bf71b4$export$1fd3aad76a7c6788);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => $70def46d82bf71b4$export$d0a82da1a0b94929);

var $86G5q = parcelRequire("86G5q");
const $70def46d82bf71b4$export$1fd3aad76a7c6788 = 'navigationCtx';
const $70def46d82bf71b4$export$d0a82da1a0b94929 = (0, $86G5q.default)($70def46d82bf71b4$export$1fd3aad76a7c6788, 'NavigationAnalyticsContext');

});

parcelRegister("df3mZ", function(module, exports) {

$parcel$export(module.exports, "EDITOR_CONTEXT", () => $3e12229aa05a4bbd$export$8c8f6d8f1fa796f0);
$parcel$export(module.exports, "EDITOR_APPEARANCE_CONTEXT", () => $3e12229aa05a4bbd$export$9eb2b47430ed3f7c);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => $3e12229aa05a4bbd$export$629cada6c5e621e1);

var $86G5q = parcelRequire("86G5q");
const $3e12229aa05a4bbd$export$8c8f6d8f1fa796f0 = 'fabricEditorCtx';
var $3e12229aa05a4bbd$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
const $3e12229aa05a4bbd$export$629cada6c5e621e1 = (0, $86G5q.default)($3e12229aa05a4bbd$export$8c8f6d8f1fa796f0, 'FabricEditorAnalyticsContext');

});

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $86eff7942395d7f1$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

parcelRegister("eGyZ0", function(module, exports) {

$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => $7250bcea25fa81b5$export$b326383bee6cb993);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => $7250bcea25fa81b5$export$4119ddb38ccbfb87);

var $86G5q = parcelRequire("86G5q");
const $7250bcea25fa81b5$export$b326383bee6cb993 = 'peopleTeamsCtx';
const $7250bcea25fa81b5$export$4119ddb38ccbfb87 = (0, $86G5q.default)($7250bcea25fa81b5$export$b326383bee6cb993, 'PeopleTeamsAnalyticsContext');

});

parcelRegister("5vo1b", function(module, exports) {

$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => $681868aebf87225a$export$da1befb791e93c7e);
$parcel$export(module.exports, "NotificationsAnalyticsContext", () => $681868aebf87225a$export$6f8e7ff1e3feafd7);

var $86G5q = parcelRequire("86G5q");
const $681868aebf87225a$export$da1befb791e93c7e = 'NotificationsCtx';
const $681868aebf87225a$export$6f8e7ff1e3feafd7 = (0, $86G5q.default)($681868aebf87225a$export$da1befb791e93c7e, 'NotificationsAnalyticsContext');

});

parcelRegister("ir8t7", function(module, exports) {

$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => $7ea6d2e700278719$export$fc7a65795610cb71);
$parcel$export(module.exports, "RecentWorkAnalyticsContext", () => $7ea6d2e700278719$export$745926731087ebe2);

var $86G5q = parcelRequire("86G5q");
const $7ea6d2e700278719$export$fc7a65795610cb71 = 'RecentWorkCtx';
const $7ea6d2e700278719$export$745926731087ebe2 = (0, $86G5q.default)($7ea6d2e700278719$export$fc7a65795610cb71, 'RecentWorkAnalyticsContext');

});

parcelRegister("2zY3Y", function(module, exports) {

$parcel$export(module.exports, "ATLAS_CONTEXT", () => $c2f0d230f3070121$export$4906017439f33fc0);

var $86G5q = parcelRequire("86G5q");
const $c2f0d230f3070121$export$4906017439f33fc0 = 'atlasCtx';
const $c2f0d230f3070121$export$43ebbe41370d4543 = (0, $86G5q.default)($c2f0d230f3070121$export$4906017439f33fc0, 'AtlasAnalyticsContext');

});

parcelRegister("bsk2y", function(module, exports) {

$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => $119ae8d5eaebb5e6$export$3240443bf2b83834);

var $86G5q = parcelRequire("86G5q");
const $119ae8d5eaebb5e6$export$3240443bf2b83834 = 'linkingPlatformCtx';
const $119ae8d5eaebb5e6$export$6d568da622ce0a08 = (0, $86G5q.default)($119ae8d5eaebb5e6$export$3240443bf2b83834, 'LinkingPlatformAnalyticsContext');

});

parcelRegister("2m7ZL", function(module, exports) {

$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => $902586c27bcc226a$export$ef0c05448f0f8f9);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => $902586c27bcc226a$export$dcd232f3be312f94);

var $86G5q = parcelRequire("86G5q");
const $902586c27bcc226a$export$ef0c05448f0f8f9 = 'postOfficeCtx';
const $902586c27bcc226a$export$dcd232f3be312f94 = (0, $86G5q.default)($902586c27bcc226a$export$ef0c05448f0f8f9, 'PostOfficeAnalyticsContext');

});

parcelRegister("9YUki", function(module, exports) {

$parcel$export(module.exports, "AI_MATE_CONTEXT", () => $c4a1529fa6b06383$export$5c3a6fd8b96e8b66);
$parcel$export(module.exports, "AIMateAnalyticsContext", () => $c4a1529fa6b06383$export$de3826c30468da26);

var $86G5q = parcelRequire("86G5q");
const $c4a1529fa6b06383$export$5c3a6fd8b96e8b66 = 'aiMateCtx';
const $c4a1529fa6b06383$export$de3826c30468da26 = (0, $86G5q.default)($c4a1529fa6b06383$export$5c3a6fd8b96e8b66, 'AIMateAnalyticsContext');

});

parcelRegister("k0kR6", function(module, exports) {

$parcel$export(module.exports, "AVP_CONTEXT", () => $a01d09b28fdc10a6$export$c2a811a4e42f4af5);

var $86G5q = parcelRequire("86G5q");
const $a01d09b28fdc10a6$export$c2a811a4e42f4af5 = 'avpCtx';
const $a01d09b28fdc10a6$export$da383e8879a25b03 = (0, $86G5q.default)($a01d09b28fdc10a6$export$c2a811a4e42f4af5, 'AVPAnalyticsContext');

});

parcelRegister("47pca", function(module, exports) {

$parcel$export(module.exports, "GROWTH_CONTEXT", () => $7299bdcb8206e118$export$82023f2f4bfb06c1);

var $86G5q = parcelRequire("86G5q");
const $7299bdcb8206e118$export$82023f2f4bfb06c1 = 'editionAwarenessCtx';
const $7299bdcb8206e118$export$84980182680018f = (0, $86G5q.default)($7299bdcb8206e118$export$82023f2f4bfb06c1, 'GrowthAnalyticsContext');

});


parcelRegister("lniFT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("5tYUv")).default);
$parcel$export(module.exports, "LOG_LEVEL", () => (parcelRequire("bDZSw")).LOG_LEVEL);
$parcel$export(module.exports, "FabricChannel", () => (parcelRequire("c9l08")).FabricChannel);

var $5tYUv = parcelRequire("5tYUv");

var $bDZSw = parcelRequire("bDZSw");

var $c9l08 = parcelRequire("c9l08");

});
parcelRegister("5tYUv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a474c7887370a88$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $c9l08 = parcelRequire("c9l08");

var $ar23E = parcelRequire("ar23E");

var $7isAo = parcelRequire("7isAo");

var $bDZSw = parcelRequire("bDZSw");

var $2Pa6e = parcelRequire("2Pa6e");

var $6S46r = parcelRequire("6S46r");

var $lpXbB = parcelRequire("lpXbB");

var $3zty1 = parcelRequire("3zty1");

var $8a0Dq = parcelRequire("8a0Dq");

var $aKFEp = parcelRequire("aKFEp");

var $hwW0V = parcelRequire("hwW0V");

var $kTZJj = parcelRequire("kTZJj");

var $ETsKY = parcelRequire("ETsKY");

var $iy39I = parcelRequire("iy39I");

var $cspfG = parcelRequire("cspfG");

var $cTJ2r = parcelRequire("cTJ2r");

var $jvzwa = parcelRequire("jvzwa");
const $0a474c7887370a88$var$listenerMap = {
    [(0, $c9l08.FabricChannel).elements]: (0, $ar23E.default),
    [(0, $c9l08.FabricChannel).editor]: (0, $6S46r.default),
    [(0, $c9l08.FabricChannel).atlaskit]: (0, $7isAo.default),
    [(0, $c9l08.FabricChannel).navigation]: (0, $2Pa6e.default),
    [(0, $c9l08.FabricChannel).media]: (0, $lpXbB.default),
    [(0, $c9l08.FabricChannel).peopleTeams]: (0, $3zty1.default),
    [(0, $c9l08.FabricChannel).notifications]: (0, $8a0Dq.default),
    [(0, $c9l08.FabricChannel).recentWork]: (0, $aKFEp.default),
    [(0, $c9l08.FabricChannel).atlas]: (0, $hwW0V.default),
    [(0, $c9l08.FabricChannel).crossFlow]: (0, $kTZJj.default),
    [(0, $c9l08.FabricChannel).linkingPlatform]: (0, $ETsKY.default),
    [(0, $c9l08.FabricChannel).postOffice]: (0, $iy39I.default),
    [(0, $c9l08.FabricChannel).aiMate]: (0, $cspfG.default),
    [(0, $c9l08.FabricChannel).avp]: (0, $cTJ2r.default),
    [(0, $c9l08.FabricChannel).growth]: (0, $jvzwa.default)
};
class $0a474c7887370a88$var$FabricAnalyticsListeners extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.logger = new (0, $bDZSw.default)({
            logLevel: props.logLevel
        });
    }
    render() {
        const { client: client, children: children, logLevel: logLevel, excludedChannels: excludedChannels } = this.props;
        if (typeof logLevel === 'number') this.logger.setLogLevel(logLevel);
        const listeners = Object.keys($0a474c7887370a88$var$listenerMap).filter((channel)=>!excludedChannels || excludedChannels.indexOf(channel) < 0).map((channel)=>$0a474c7887370a88$var$listenerMap[channel]).reduce((prev, Listener)=>/*#__PURE__*/ (0, $2OMIu.jsx)(Listener, {
                client: client,
                logger: this.logger,
                children: prev
            }), children);
        return listeners;
    }
}
var $0a474c7887370a88$export$2e2bcd8739ae039 = $0a474c7887370a88$var$FabricAnalyticsListeners;

});
parcelRegister("c9l08", function(module, exports) {

$parcel$export(module.exports, "FabricChannel", () => $ecec8a6963af01bd$export$8faa0b115ef0268b);
var $ecec8a6963af01bd$export$8faa0b115ef0268b = /*#__PURE__*/ function(FabricChannel) {
    FabricChannel["atlaskit"] = "atlaskit";
    FabricChannel["elements"] = "fabric-elements";
    FabricChannel["navigation"] = "navigation";
    FabricChannel["editor"] = "editor";
    FabricChannel["media"] = "media";
    FabricChannel["peopleTeams"] = "peopleTeams";
    FabricChannel["notifications"] = "notifications";
    FabricChannel["recentWork"] = "recentWork";
    FabricChannel["atlas"] = "atlas";
    FabricChannel["crossFlow"] = "crossFlow";
    FabricChannel["linkingPlatform"] = "linkingPlatform";
    FabricChannel["postOffice"] = "postOffice";
    FabricChannel["aiMate"] = "aiMate";
    FabricChannel["avp"] = "avp";
    FabricChannel["growth"] = "growth";
    return FabricChannel;
}({});

});

parcelRegister("ar23E", function(module, exports) {

$parcel$export(module.exports, "ELEMENTS_TAG", () => $7174dcc40c0e1945$export$ed71ae78997933a);
$parcel$export(module.exports, "default", () => $7174dcc40c0e1945$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jblqj = parcelRequire("jblqj");

var $c9l08 = parcelRequire("c9l08");

var $aA5hd = parcelRequire("aA5hd");
const $7174dcc40c0e1945$export$ed71ae78997933a = 'fabricElements';
class $7174dcc40c0e1945$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jblqj.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $c9l08.FabricChannel).elements,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, $aA5hd.handleEvent)(event, $7174dcc40c0e1945$export$ed71ae78997933a, this.props.logger, this.props.client);
        };
    }
}

});
parcelRegister("jblqj", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf18ead6e8a351e6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $9tX7s = parcelRequire("9tX7s");

var $8sghv = parcelRequire("8sghv");

var $j4l6A = parcelRequire("j4l6A");
const $bf18ead6e8a351e6$var$ExportedAnalyticsListener = (props)=>{
    const isModernContext = (0, $9tX7s.default) || (0, $fHpHg.fg)('analytics-next-use-modern-context_jira');
    return isModernContext ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j4l6A.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8sghv.default), {
        ...props
    });
};
var $bf18ead6e8a351e6$export$2e2bcd8739ae039 = $bf18ead6e8a351e6$var$ExportedAnalyticsListener;

});
parcelRegister("8sghv", function(module, exports) {

$parcel$export(module.exports, "default", () => $832709c6b57e593b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");

var $fy0vt = parcelRequire("fy0vt");
const $832709c6b57e593b$var$ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func,
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func
};
const $832709c6b57e593b$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $832709c6b57e593b$var$AnalyticsListener extends (0, $5uXOq.Component) {
    static{
        this.contextTypes = $832709c6b57e593b$var$ContextTypes;
    }
    static{
        this.childContextTypes = $832709c6b57e593b$var$ContextTypes;
    }
    constructor(props){
        super(props), this.getChildContext = ()=>({
                getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext
            }), this.getAnalyticsEventHandlers = ()=>{
            const { channel: channel, onEvent: onEvent } = this.props;
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $832709c6b57e593b$var$noop } = this.context;
            const handler = (event, eventChannel)=>{
                if (channel === '*' || channel === eventChannel) onEvent(event, eventChannel);
            };
            return [
                handler,
                ...getAtlaskitAnalyticsEventHandlers()
            ];
        }, this.getAtlaskitAnalyticsContext = ()=>{
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $832709c6b57e593b$var$noop } = this.context;
            return getAtlaskitAnalyticsContext();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fy0vt.default).Provider, {
            value: this.contextValue,
            children: children
        });
    }
}
var $832709c6b57e593b$export$2e2bcd8739ae039 = $832709c6b57e593b$var$AnalyticsListener;

});

parcelRegister("j4l6A", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca6235dea86dc432$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fy0vt = parcelRequire("fy0vt");

var $d5pZX = parcelRequire("d5pZX");

var $cLmtE = parcelRequire("cLmtE");
const $ca6235dea86dc432$var$AnalyticsListener = ({ children: children, channel: channel, onEvent: onEvent })=>{
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = ()=>[], getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext } = (0, $d5pZX.useAnalyticsContext)();
    const onEventRef = (0, $cLmtE.useTrackedRef)(onEvent);
    const channelRef = (0, $cLmtE.useTrackedRef)(channel);
    const getAnalyticsEventHandlers = (0, $5uXOq.useCallback)(()=>{
        const thisHandler = (event, eventChannel)=>{
            if (channelRef.current === '*' || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [
            thisHandler,
            ...getAtlaskitAnalyticsEventHandlers()
        ];
    }, [
        channelRef,
        onEventRef,
        getAtlaskitAnalyticsEventHandlers
    ]);
    const value = (0, $5uXOq.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fy0vt.default).Provider, {
        value: value,
        children: children
    });
};
var $ca6235dea86dc432$export$2e2bcd8739ae039 = $ca6235dea86dc432$var$AnalyticsListener;

});


parcelRegister("aA5hd", function(module, exports) {

$parcel$export(module.exports, "handleEvent", () => $b4fe07be3006d3b4$export$d6e5ca10785815df);

var $iWM3c = parcelRequire("iWM3c");

var $9lPvM = parcelRequire("9lPvM");
const $b4fe07be3006d3b4$export$d6e5ca10785815df = (event, // If passing through multiple tags, the primary tag should be first in the array.
// The primary tag is used for matching context.
tags, logger, client)=>{
    if (!event.payload) return;
    const payload = (0, $9lPvM.processEventPayload)(event, tags);
    (0, $iWM3c.sendEvent)(logger, client)(payload);
};

});
parcelRegister("iWM3c", function(module, exports) {

$parcel$export(module.exports, "sendEvent", () => $5342b7901abea0bc$export$7329bcdc3edcd90e);
const $5342b7901abea0bc$var$isPromise = (c)=>{
    return typeof c.then === 'function';
};
const $5342b7901abea0bc$export$7329bcdc3edcd90e = (logger, client)=>(event)=>{
        if (client) {
            const { eventType: eventType, ...gasEvent } = event;
            const withClient = (cb)=>{
                if ($5342b7901abea0bc$var$isPromise(client)) client.then(cb).catch((e)=>logger.warn('There was an error sending the event', e));
                else try {
                    cb(client);
                } catch (e) {
                    logger.warn('There was an error sending the event', e);
                }
            };
            switch(event.eventType){
                case 'ui':
                    logger.debug('Sending UI Event via analytics client', gasEvent);
                    withClient((client)=>client.sendUIEvent(gasEvent));
                    break;
                case 'operational':
                    logger.debug('Sending Operational Event via analytics client', gasEvent);
                    withClient((client)=>client.sendOperationalEvent(gasEvent));
                    break;
                case 'track':
                    logger.debug('Sending Track Event via analytics client', gasEvent);
                    withClient((client)=>client.sendTrackEvent(gasEvent));
                    break;
                case 'screen':
                    logger.debug('Sending Screen Event via analytics client', gasEvent);
                    withClient((client)=>client.sendScreenEvent(gasEvent));
                    break;
                default:
                    logger.error(`cannot map eventType ${event.eventType} to an analytics-web-client function`);
            }
        } else logger.warn('AnalyticsWebClient instance is not provided');
    };

});

parcelRegister("9lPvM", function(module, exports) {

$parcel$export(module.exports, "processEventPayload", () => $e275c1a02407aa62$export$c37d638b7f2ca192);

parcelRequire("cnhic");
var $df3mZ = parcelRequire("df3mZ");
var $dZtFw = parcelRequire("dZtFw");

var $1UikQ = parcelRequire("1UikQ");

var $ar23E = parcelRequire("ar23E");

var $6S46r = parcelRequire("6S46r");
const $e275c1a02407aa62$var$extractFieldsFromContext = (fieldsToPick)=>(contexts)=>contexts.map((ctx)=>fieldsToPick.reduce((result, key)=>ctx[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(result, {
                    [key]: ctx[key]
                }) : result, {})).reduce((result, item)=>(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(result, item), {});
const $e275c1a02407aa62$var$fieldExtractor = (contextKey)=>$e275c1a02407aa62$var$extractFieldsFromContext([
        'source',
        'objectType',
        'objectId',
        'containerType',
        'containerId',
        contextKey
    ]);
const $e275c1a02407aa62$var$getContextKey = (tag)=>{
    switch(tag){
        case 0, $ar23E.ELEMENTS_TAG:
            return 0, $dZtFw.ELEMENTS_CONTEXT;
        case 0, $6S46r.EDITOR_TAG:
            return 0, $df3mZ.EDITOR_CONTEXT;
        default:
            return '';
    }
};
const $e275c1a02407aa62$var$updatePayloadWithContext = (primaryTag, event)=>{
    if (event.context.length === 0) return {
        source: (0, $4e2819b72987a07d$export$b055de0e665cb20c),
        ...event.payload
    };
    const contextKey = $e275c1a02407aa62$var$getContextKey(primaryTag) || 'attributes';
    const { [contextKey]: attributes, ...fields } = $e275c1a02407aa62$var$fieldExtractor(contextKey)(event.context);
    if (attributes) event.payload.attributes = (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(attributes, event.payload.attributes || {});
    return {
        source: (0, $4e2819b72987a07d$export$b055de0e665cb20c),
        ...fields,
        ...event.payload
    };
};
const $e275c1a02407aa62$var$addTags = (tags, originalTags = [])=>{
    const mergedTags = new Set([
        ...originalTags,
        ...tags
    ]);
    return Array.from(mergedTags);
};
/**
 * The primary tag is used for matching the analytics event payload
 * with its context.
 */ function $e275c1a02407aa62$var$getPrimaryTag(tags) {
    if (typeof tags === 'string') return tags;
    if (!tags.length) throw new Error('Empty tags string array. Unable to match analytics event payload with context');
    return tags[0];
}
const $e275c1a02407aa62$export$c37d638b7f2ca192 = (event, tags)=>{
    const primaryTag = $e275c1a02407aa62$var$getPrimaryTag(tags);
    const tagsArray = typeof tags === 'string' ? [
        tags
    ] : tags;
    return {
        ...$e275c1a02407aa62$var$updatePayloadWithContext(primaryTag, event),
        tags: $e275c1a02407aa62$var$addTags(tagsArray, event.payload.tags)
    };
};

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $4e2819b72987a07d$export$a1562d08625f5d7e = 'ui';
const $4e2819b72987a07d$export$947dac6c72b26f81 = 'track';
const $4e2819b72987a07d$export$f1d537d508d2945a = 'screen';
const $4e2819b72987a07d$export$12346a674644c156 = 'operational';
const $4e2819b72987a07d$export$b055de0e665cb20c = 'unknown';

parcelRegister("6S46r", function(module, exports) {

$parcel$export(module.exports, "EDITOR_TAG", () => $05e87af4452b6305$export$a1d9dc589a29b3aa);
$parcel$export(module.exports, "default", () => $05e87af4452b6305$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jblqj = parcelRequire("jblqj");

var $c9l08 = parcelRequire("c9l08");

var $aA5hd = parcelRequire("aA5hd");
const $05e87af4452b6305$export$a1d9dc589a29b3aa = 'editor';
const $05e87af4452b6305$export$8aa0d788f94a809 = 'fabricEditor';
class $05e87af4452b6305$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jblqj.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $c9l08.FabricChannel).editor,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, $aA5hd.handleEvent)(event, [
                $05e87af4452b6305$export$a1d9dc589a29b3aa,
                $05e87af4452b6305$export$8aa0d788f94a809
            ], this.props.logger, this.props.client);
        };
    }
}

});




parcelRegister("7isAo", function(module, exports) {

$parcel$export(module.exports, "default", () => $33e8cf5a06ff614d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c9l08 = parcelRequire("c9l08");

var $e7HTo = parcelRequire("e7HTo");

var $7pKGB = parcelRequire("7pKGB");
function $33e8cf5a06ff614d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7pKGB.default), {
        ...props,
        channel: (0, $c9l08.FabricChannel).atlaskit,
        processEvent: (0, $e7HTo.default)
    });
}

});
parcelRegister("e7HTo", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2c2422cada682a2$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");


var $1AX3P = parcelRequire("1AX3P");
const $b2c2422cada682a2$var$ATLASKIT_TAG = 'atlaskit';
const $b2c2422cada682a2$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the Atlaskit event format into the analytics platform format.
 *
 * Atlaskit event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $b2c2422cada682a2$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $1AX3P.getSources)(event);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $4e2819b72987a07d$export$b055de0e665cb20c);
    const extraAttributes = (0, $1AX3P.getExtraAttributes)(event);
    const components = (0, $1AX3P.getComponents)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $1AX3P.getPackageInfo)(event)) || {};
    const { eventType: eventType = (0, $4e2819b72987a07d$export$a1562d08625f5d7e), action: action, actionSubjectId: actionSubjectId, attributes: payloadAttributes, containerId: containerId } = event.payload;
    const attributes = {
        listenerVersion: $b2c2422cada682a2$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: (0, $1AX3P.getPackageHierarchy)(event) || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, payloadAttributes)
    };
    // Ensure atlaskit tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($b2c2422cada682a2$var$ATLASKIT_TAG);
    if (event.payload) {
        if (eventType === (0, $4e2819b72987a07d$export$a1562d08625f5d7e)) return {
            eventType: eventType,
            source: source,
            actionSubject: (0, $1AX3P.getActionSubject)(event),
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: attributes,
            containerId: containerId,
            tags: Array.from(tags)
        };
        if (eventType === (0, $4e2819b72987a07d$export$947dac6c72b26f81) || eventType === (0, $4e2819b72987a07d$export$12346a674644c156) || eventType === (0, $4e2819b72987a07d$export$f1d537d508d2945a)) logger.error('Track, screen and operational events are currently not supported for atlaskit events');
        else logger.error('Invalid event type', eventType);
    }
    return null;
};

});
parcelRegister("1AX3P", function(module, exports) {

$parcel$export(module.exports, "extractFromEventContext", () => $0f2a0a886aa4ec79$export$9b947b4502cd2705);
$parcel$export(module.exports, "getActionSubject", () => $0f2a0a886aa4ec79$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getSources", () => $0f2a0a886aa4ec79$export$5f9bc633b116660f);
$parcel$export(module.exports, "getComponents", () => $0f2a0a886aa4ec79$export$4e811121b221213b);
$parcel$export(module.exports, "getExtraAttributes", () => $0f2a0a886aa4ec79$export$67c3590839ebecdd);
$parcel$export(module.exports, "getPackageInfo", () => $0f2a0a886aa4ec79$export$cd17d76da7967240);
$parcel$export(module.exports, "getPackageHierarchy", () => $0f2a0a886aa4ec79$export$4e0b83da1896ebc7);
/**
 * Largely taken from analytics-web-react
 */ 
var $1UikQ = parcelRequire("1UikQ");
const $0f2a0a886aa4ec79$export$9b947b4502cd2705 = (propertyName, event)=>event.context.map((contextItem)=>contextItem[propertyName]).filter(Boolean);
const $0f2a0a886aa4ec79$export$6f40cdf6d42c018d = (event)=>{
    const overrides = $0f2a0a886aa4ec79$export$9b947b4502cd2705('actionSubjectOverride', event);
    const closestContext = event.context.length > 0 ? event.context[event.context.length - 1] : {};
    const actionSubject = event.payload.actionSubject || closestContext.component;
    return overrides.length > 0 ? overrides[0] : actionSubject;
};
const $0f2a0a886aa4ec79$export$5f9bc633b116660f = (event)=>$0f2a0a886aa4ec79$export$9b947b4502cd2705('source', event);
const $0f2a0a886aa4ec79$export$4e811121b221213b = (event)=>$0f2a0a886aa4ec79$export$9b947b4502cd2705('component', event);
const $0f2a0a886aa4ec79$export$67c3590839ebecdd = (event)=>$0f2a0a886aa4ec79$export$9b947b4502cd2705('attributes', event).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(result, extraAttributes), {});
const $0f2a0a886aa4ec79$export$cd17d76da7967240 = (event)=>event.context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $0f2a0a886aa4ec79$export$18cd124b5098d330 = (event)=>$0f2a0a886aa4ec79$export$9b947b4502cd2705('packageVersion', event);
function $0f2a0a886aa4ec79$export$4e0b83da1896ebc7(event) {
    const packages = $0f2a0a886aa4ec79$export$cd17d76da7967240(event) || [];
    return packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName).join(',') || undefined;
}

});


parcelRegister("7pKGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $41fd45ce6084adf8$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jblqj = parcelRequire("jblqj");

var $iWM3c = parcelRequire("iWM3c");
class $41fd45ce6084adf8$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jblqj.default), {
            onEvent: this.listenerHandler,
            channel: this.props.channel,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.listenerHandler = (event)=>{
            const { client: client, logger: logger, channel: channel, processEvent: processEvent } = this.props;
            if (!event.payload) return;
            logger.debug(`Received ${channel} event`, event);
            const payload = processEvent(event, logger);
            logger.debug(`Processed ${channel} event`, payload);
            if (payload) (0, $iWM3c.sendEvent)(logger, client)(payload);
        };
    }
}

});


parcelRegister("bDZSw", function(module, exports) {

$parcel$export(module.exports, "LOG_LEVEL", () => $b3c59a819dac3e5d$export$ffe0c436e29512cf);
$parcel$export(module.exports, "default", () => $b3c59a819dac3e5d$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $b3c59a819dac3e5d$export$ffe0c436e29512cf = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
class $b3c59a819dac3e5d$export$2e2bcd8739ae039 {
    constructor({ logLevel: logLevel } = {}){
        this.logLevel = $b3c59a819dac3e5d$export$ffe0c436e29512cf.OFF;
        if (typeof logLevel === 'number') this.setLogLevel(logLevel);
    }
    setLogLevel(logLevel) {
        if (logLevel >= $b3c59a819dac3e5d$export$ffe0c436e29512cf.DEBUG && logLevel <= $b3c59a819dac3e5d$export$ffe0c436e29512cf.OFF) this.logLevel = +logLevel;
        else this.logLevel = $b3c59a819dac3e5d$export$ffe0c436e29512cf.OFF;
    }
    logMessage(level, type, ...args) {
        if (level >= this.logLevel) console[type](...args);
    }
    debug(...args) {
        this.logMessage($b3c59a819dac3e5d$export$ffe0c436e29512cf.DEBUG, 'log', ...args);
    }
    info(...args) {
        this.logMessage($b3c59a819dac3e5d$export$ffe0c436e29512cf.INFO, 'info', ...args);
    }
    warn(...args) {
        this.logMessage($b3c59a819dac3e5d$export$ffe0c436e29512cf.WARN, 'warn', ...args);
    }
    error(...args) {
        this.logMessage($b3c59a819dac3e5d$export$ffe0c436e29512cf.ERROR, 'error', ...args);
    }
}

});

parcelRegister("2Pa6e", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca1ae0b2841de09b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c9l08 = parcelRequire("c9l08");

var $5wuHB = parcelRequire("5wuHB");

var $7pKGB = parcelRequire("7pKGB");
function $ca1ae0b2841de09b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7pKGB.default), {
        ...props,
        channel: (0, $c9l08.FabricChannel).navigation,
        processEvent: (0, $5wuHB.default)
    });
}

});
parcelRegister("5wuHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $67f2d0896aef3af0$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");

parcelRequire("cnhic");
var $ijQ0g = parcelRequire("ijQ0g");

var $gusLT = parcelRequire("gusLT");
const $67f2d0896aef3af0$var$NAVIGATION_TAG = 'navigation';
const $67f2d0896aef3af0$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $67f2d0896aef3af0$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $gusLT.getSources)(event, (0, $ijQ0g.NAVIGATION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $4e2819b72987a07d$export$b055de0e665cb20c);
    const extraAttributes = (0, $gusLT.getExtraAttributes)(event, (0, $ijQ0g.NAVIGATION_CONTEXT));
    const components = (0, $gusLT.getComponents)(event, (0, $ijQ0g.NAVIGATION_CONTEXT));
    const packages = (0, $gusLT.getPackageInfo)(event, (0, $ijQ0g.NAVIGATION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $gusLT.getPackageInfo)(event, (0, $ijQ0g.NAVIGATION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $4e2819b72987a07d$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $67f2d0896aef3af0$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($67f2d0896aef3af0$var$NAVIGATION_TAG);
    if (event.payload) switch(eventType){
        case 0, $4e2819b72987a07d$export$a1562d08625f5d7e:
        case 0, $4e2819b72987a07d$export$12346a674644c156:
        case 0, $4e2819b72987a07d$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $4e2819b72987a07d$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("gusLT", function(module, exports) {

$parcel$export(module.exports, "getSources", () => $281488230d7d3176$export$5f9bc633b116660f);
$parcel$export(module.exports, "getComponents", () => $281488230d7d3176$export$4e811121b221213b);
$parcel$export(module.exports, "getExtraAttributes", () => $281488230d7d3176$export$67c3590839ebecdd);
$parcel$export(module.exports, "getPackageInfo", () => $281488230d7d3176$export$cd17d76da7967240);
/**
 * Largely taken from analytics-web-react
 */ 
var $1UikQ = parcelRequire("1UikQ");
const $281488230d7d3176$var$extractFromEventContext = (propertyNames, event, namespacedContextOnly = true, contextName)=>event.context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContext = contextItem[contextName];
            const navContextProp = navContext ? navContext[propertyName] : null;
            const value = namespacedContextOnly ? navContextProp : navContextProp || contextItem[propertyName];
            if (value) acc.push(value);
        });
        return acc;
    }, []);
const $281488230d7d3176$export$5f9bc633b116660f = (event, contextName)=>$281488230d7d3176$var$extractFromEventContext([
        'source'
    ], event, false, contextName);
const $281488230d7d3176$export$4e811121b221213b = (event, contextName)=>$281488230d7d3176$var$extractFromEventContext([
        'component',
        'componentName'
    ], event, false, contextName);
const $281488230d7d3176$export$67c3590839ebecdd = (event, contextName)=>$281488230d7d3176$var$extractFromEventContext([
        'attributes'
    ], event, true, contextName).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(result, extraAttributes), {});
const $281488230d7d3176$export$cd17d76da7967240 = (event, contextName)=>event.context.map((contextItem)=>{
        const navContext = contextItem[contextName];
        const item = navContext ? navContext : contextItem;
        return {
            packageName: item.packageName,
            packageVersion: item.packageVersion
        };
    }).filter((p)=>p.packageName);
const $281488230d7d3176$export$18cd124b5098d330 = (event, contextName)=>$281488230d7d3176$var$extractFromEventContext([
        'packageVersion'
    ], event, true, contextName);

});



parcelRegister("lpXbB", function(module, exports) {

$parcel$export(module.exports, "default", () => $eca743437f2c4def$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c9l08 = parcelRequire("c9l08");

var $7JnCh = parcelRequire("7JnCh");

var $7pKGB = parcelRequire("7pKGB");
function $eca743437f2c4def$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7pKGB.default), {
        ...props,
        channel: (0, $c9l08.FabricChannel).media,
        processEvent: (0, $7JnCh.processEvent)
    });
}

});
parcelRegister("7JnCh", function(module, exports) {

$parcel$export(module.exports, "processEvent", () => $a7c0f7d157aa07a2$export$22af68e3614bf024);

parcelRequire("cnhic");

var $1UikQ = parcelRequire("1UikQ");

var $hYfgW = parcelRequire("hYfgW");

var $1AX3P = parcelRequire("1AX3P");
const $a7c0f7d157aa07a2$var$listenerVersion = "0.0.0-use.local";
function $a7c0f7d157aa07a2$var$getMediaContexts(event) {
    return (0, $1AX3P.extractFromEventContext)((0, $86eff7942395d7f1$export$70df29c238ba7306), event);
}
function $a7c0f7d157aa07a2$var$getMediaRegion() {
    try {
        return window && window.sessionStorage && window.sessionStorage.getItem('media-api-region');
    } catch (e) {
        return;
    }
}
function $a7c0f7d157aa07a2$export$22af68e3614bf024(event) {
    const sources = (0, $1AX3P.getSources)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $1AX3P.getPackageInfo)(event)) || {};
    const extraAttributes = (0, $1AX3P.getExtraAttributes)(event);
    const mediaContexts = $a7c0f7d157aa07a2$var$getMediaContexts(event) || [];
    const mediaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, ...mediaContexts);
    const tags = new Set(event.payload.tags || []);
    tags.add('media');
    const components = (0, $1AX3P.getComponents)(event);
    const mediaRegion = $a7c0f7d157aa07a2$var$getMediaRegion();
    const payload = {
        source: (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $4e2819b72987a07d$export$b055de0e665cb20c),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        // for backward compatibilty
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, extraAttributes, mediaAttributes, event.payload.attributes),
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, $1AX3P.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: $a7c0f7d157aa07a2$var$listenerVersion,
            ...mediaRegion ? {
                mediaRegion: mediaRegion
            } : undefined
        },
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

});


parcelRegister("3zty1", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b06c6cba0aaf9d4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c9l08 = parcelRequire("c9l08");

var $9VBrz = parcelRequire("9VBrz");

var $7pKGB = parcelRequire("7pKGB");
function $9b06c6cba0aaf9d4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7pKGB.default), {
        ...props,
        channel: (0, $c9l08.FabricChannel).peopleTeams,
        processEvent: (0, $9VBrz.default)
    });
}

});
parcelRegister("9VBrz", function(module, exports) {

$parcel$export(module.exports, "default", () => $76046e9817d8d7e5$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");

parcelRequire("cnhic");
var $eGyZ0 = parcelRequire("eGyZ0");

var $gusLT = parcelRequire("gusLT");
const $76046e9817d8d7e5$var$PEOPLE_TEAMS_TAG = 'peopleTeams';
const $76046e9817d8d7e5$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $76046e9817d8d7e5$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $gusLT.getSources)(event, (0, $eGyZ0.PEOPLE_TEAMS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $4e2819b72987a07d$export$b055de0e665cb20c);
    const extraAttributes = (0, $gusLT.getExtraAttributes)(event, (0, $eGyZ0.PEOPLE_TEAMS_CONTEXT));
    const components = (0, $gusLT.getComponents)(event, (0, $eGyZ0.PEOPLE_TEAMS_CONTEXT));
    const packages = (0, $gusLT.getPackageInfo)(event, (0, $eGyZ0.PEOPLE_TEAMS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $gusLT.getPackageInfo)(event, (0, $eGyZ0.PEOPLE_TEAMS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $4e2819b72987a07d$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $76046e9817d8d7e5$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($76046e9817d8d7e5$var$PEOPLE_TEAMS_TAG);
    if (event.payload) switch(eventType){
        case 0, $4e2819b72987a07d$export$a1562d08625f5d7e:
        case 0, $4e2819b72987a07d$export$12346a674644c156:
        case 0, $4e2819b72987a07d$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $4e2819b72987a07d$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("8a0Dq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3023fc1487ed57c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c9l08 = parcelRequire("c9l08");

var $4e6QU = parcelRequire("4e6QU");

var $7pKGB = parcelRequire("7pKGB");
function $f3023fc1487ed57c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7pKGB.default), {
        ...props,
        channel: (0, $c9l08.FabricChannel).notifications,
        processEvent: (0, $4e6QU.default)
    });
}

});
parcelRegister("4e6QU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e43773f44ec269b6$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");


var $gusLT = parcelRequire("gusLT");
parcelRequire("cnhic");
var $5vo1b = parcelRequire("5vo1b");

var $c9l08 = parcelRequire("c9l08");
const $e43773f44ec269b6$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $e43773f44ec269b6$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $gusLT.getSources)(event, (0, $5vo1b.NOTIFICATIONS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $4e2819b72987a07d$export$b055de0e665cb20c);
    const extraAttributes = (0, $gusLT.getExtraAttributes)(event, (0, $5vo1b.NOTIFICATIONS_CONTEXT));
    const components = (0, $gusLT.getComponents)(event, (0, $5vo1b.NOTIFICATIONS_CONTEXT));
    const packages = (0, $gusLT.getPackageInfo)(event, (0, $5vo1b.NOTIFICATIONS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $gusLT.getPackageInfo)(event, (0, $5vo1b.NOTIFICATIONS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $4e2819b72987a07d$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $e43773f44ec269b6$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $c9l08.FabricChannel).notifications);
    if (event.payload) switch(eventType){
        case 0, $4e2819b72987a07d$export$a1562d08625f5d7e:
        case 0, $4e2819b72987a07d$export$12346a674644c156:
        case 0, $4e2819b72987a07d$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $4e2819b72987a07d$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("aKFEp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6f6ba70974a0ecc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c9l08 = parcelRequire("c9l08");

var $2S9nx = parcelRequire("2S9nx");

var $7pKGB = parcelRequire("7pKGB");
function $a6f6ba70974a0ecc$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7pKGB.default), {
        ...props,
        channel: (0, $c9l08.FabricChannel).recentWork,
        processEvent: (0, $2S9nx.default)
    });
}

});
parcelRegister("2S9nx", function(module, exports) {

$parcel$export(module.exports, "default", () => $205febdfc8ff6e88$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");


var $gusLT = parcelRequire("gusLT");
parcelRequire("cnhic");
var $ir8t7 = parcelRequire("ir8t7");

var $c9l08 = parcelRequire("c9l08");
const $205febdfc8ff6e88$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $205febdfc8ff6e88$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $gusLT.getSources)(event, (0, $ir8t7.RECENT_WORK_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $4e2819b72987a07d$export$b055de0e665cb20c);
    const extraAttributes = (0, $gusLT.getExtraAttributes)(event, (0, $ir8t7.RECENT_WORK_CONTEXT));
    const components = (0, $gusLT.getComponents)(event, (0, $ir8t7.RECENT_WORK_CONTEXT));
    const packages = (0, $gusLT.getPackageInfo)(event, (0, $ir8t7.RECENT_WORK_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $gusLT.getPackageInfo)(event, (0, $ir8t7.RECENT_WORK_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $4e2819b72987a07d$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $205febdfc8ff6e88$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $c9l08.FabricChannel).recentWork);
    if (event.payload) switch(eventType){
        case 0, $4e2819b72987a07d$export$a1562d08625f5d7e:
        case 0, $4e2819b72987a07d$export$12346a674644c156:
        case 0, $4e2819b72987a07d$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $4e2819b72987a07d$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("hwW0V", function(module, exports) {

$parcel$export(module.exports, "default", () => $8151b278d7d5bad1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c9l08 = parcelRequire("c9l08");

var $1Lr9b = parcelRequire("1Lr9b");

var $7pKGB = parcelRequire("7pKGB");
function $8151b278d7d5bad1$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7pKGB.default), {
        ...props,
        channel: (0, $c9l08.FabricChannel).atlas,
        processEvent: (0, $1Lr9b.default)
    });
}

});
parcelRegister("1Lr9b", function(module, exports) {

$parcel$export(module.exports, "default", () => $52c415ce210d8780$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");


var $gusLT = parcelRequire("gusLT");
parcelRequire("cnhic");
var $2zY3Y = parcelRequire("2zY3Y");
const $52c415ce210d8780$var$ATLAS_TAG = 'atlas';
const $52c415ce210d8780$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $52c415ce210d8780$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $gusLT.getSources)(event, (0, $2zY3Y.ATLAS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $4e2819b72987a07d$export$b055de0e665cb20c);
    const extraAttributes = (0, $gusLT.getExtraAttributes)(event, (0, $2zY3Y.ATLAS_CONTEXT));
    const components = (0, $gusLT.getComponents)(event, (0, $2zY3Y.ATLAS_CONTEXT));
    const packages = (0, $gusLT.getPackageInfo)(event, (0, $2zY3Y.ATLAS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $gusLT.getPackageInfo)(event, (0, $2zY3Y.ATLAS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $4e2819b72987a07d$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $52c415ce210d8780$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($52c415ce210d8780$var$ATLAS_TAG);
    if (event.payload) switch(eventType){
        case 0, $4e2819b72987a07d$export$a1562d08625f5d7e:
        case 0, $4e2819b72987a07d$export$12346a674644c156:
        case 0, $4e2819b72987a07d$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $4e2819b72987a07d$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("kTZJj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3199f2536dd8a0b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c9l08 = parcelRequire("c9l08");

var $7viWu = parcelRequire("7viWu");

var $7pKGB = parcelRequire("7pKGB");
function $a3199f2536dd8a0b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7pKGB.default), {
        ...props,
        channel: (0, $c9l08.FabricChannel).crossFlow,
        processEvent: (0, $7viWu.default)
    });
}

});
parcelRegister("7viWu", function(module, exports) {

$parcel$export(module.exports, "default", () => $09850fde01d07e1e$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 

var $hYfgW = parcelRequire("hYfgW");
parcelRequire("cnhic");
var $ijQ0g = parcelRequire("ijQ0g");

var $1AX3P = parcelRequire("1AX3P");

var $gusLT = parcelRequire("gusLT");
const $09850fde01d07e1e$var$CROSS_FLOW_TAG = 'crossFlow';
var $09850fde01d07e1e$export$2e2bcd8739ae039 = (event, logger)=>{
    const { eventType: eventType = (0, $4e2819b72987a07d$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, name: name } = event.payload;
    let sources = (0, $1AX3P.getSources)(event);
    const lastSourceFromContext = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources);
    const source = event.payload.source ?? lastSourceFromContext;
    if (lastSourceFromContext !== source) sources.push(source);
    const attributes = {
        // To get extra attributes from AnalyticsContext from other products/platforms, e.g. Jira-frontend
        ...(0, $1AX3P.getExtraAttributes)(event),
        // To inherit the extra attributes from the navigation (Atlassian Switcher) context into the crossFlow events,
        // because the events current crossFlow touchpionts already inherit these attributes in the payload.
        ...(0, $gusLT.getExtraAttributes)(event, (0, $ijQ0g.NAVIGATION_CONTEXT)),
        ...event.payload.attributes,
        namespaces: sources.join('.')
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($09850fde01d07e1e$var$CROSS_FLOW_TAG);
    if (event.payload) switch(eventType){
        case 0, $4e2819b72987a07d$export$a1562d08625f5d7e:
        case 0, $4e2819b72987a07d$export$12346a674644c156:
        case 0, $4e2819b72987a07d$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $4e2819b72987a07d$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("ETsKY", function(module, exports) {

$parcel$export(module.exports, "default", () => $67a4841f1641e468$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $izlmT = parcelRequire("izlmT");

var $c9l08 = parcelRequire("c9l08");

var $7pKGB = parcelRequire("7pKGB");
function $67a4841f1641e468$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7pKGB.default), {
        ...props,
        channel: (0, $c9l08.FabricChannel).linkingPlatform,
        processEvent: (0, $izlmT.default)
    });
}

});
parcelRegister("izlmT", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb2669b2d9796cfa$export$2e2bcd8739ae039);

var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");

parcelRequire("cnhic");
var $bsk2y = parcelRequire("bsk2y");

var $gusLT = parcelRequire("gusLT");

var $c9l08 = parcelRequire("c9l08");
const $eb2669b2d9796cfa$var$listenerVersion = "0.0.0-use.local";
var $eb2669b2d9796cfa$export$2e2bcd8739ae039 = (event)=>{
    const sources = (0, $gusLT.getSources)(event, (0, $bsk2y.LINKING_PLATFORM_CONTEXT));
    const packages = (0, $gusLT.getPackageInfo)(event, (0, $bsk2y.LINKING_PLATFORM_CONTEXT));
    const components = (0, $gusLT.getComponents)(event, (0, $bsk2y.LINKING_PLATFORM_CONTEXT));
    const extraAttributes = (0, $gusLT.getExtraAttributes)(event, (0, $bsk2y.LINKING_PLATFORM_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(packages) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $c9l08.FabricChannel).linkingPlatform);
    const payload = {
        name: event.payload.name,
        action: event.payload.action,
        actionSubject: event.payload.actionSubject,
        actionSubjectId: event.payload.actionSubjectId,
        eventType: event.payload.eventType,
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            listenerVersion: $eb2669b2d9796cfa$var$listenerVersion,
            sourceHierarchy: sources.join('.') || undefined,
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: packageHierarchy.join(',') || undefined,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, event.payload.attributes)
        },
        tags: Array.from(tags),
        source: (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $4e2819b72987a07d$export$b055de0e665cb20c),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
};

});


parcelRegister("iy39I", function(module, exports) {

$parcel$export(module.exports, "default", () => $83e17a23b6278f23$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c9l08 = parcelRequire("c9l08");

var $icTaD = parcelRequire("icTaD");

var $7pKGB = parcelRequire("7pKGB");
function $83e17a23b6278f23$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7pKGB.default), {
        ...props,
        channel: (0, $c9l08.FabricChannel).postOffice,
        processEvent: (0, $icTaD.default)
    });
}

});
parcelRegister("icTaD", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e11b1e8828c5040$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");

parcelRequire("cnhic");
var $2m7ZL = parcelRequire("2m7ZL");

var $gusLT = parcelRequire("gusLT");

var $c9l08 = parcelRequire("c9l08");
const $4e11b1e8828c5040$var$POST_OFFICE_TAG = (0, $c9l08.FabricChannel).postOffice;
const $4e11b1e8828c5040$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $4e11b1e8828c5040$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $gusLT.getSources)(event, (0, $2m7ZL.POST_OFFICE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $4e2819b72987a07d$export$b055de0e665cb20c);
    const extraAttributes = (0, $gusLT.getExtraAttributes)(event, (0, $2m7ZL.POST_OFFICE_CONTEXT));
    const components = (0, $gusLT.getComponents)(event, (0, $2m7ZL.POST_OFFICE_CONTEXT));
    const packages = (0, $gusLT.getPackageInfo)(event, (0, $2m7ZL.POST_OFFICE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $gusLT.getPackageInfo)(event, (0, $2m7ZL.POST_OFFICE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $4e2819b72987a07d$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $4e11b1e8828c5040$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($4e11b1e8828c5040$var$POST_OFFICE_TAG);
    if (event.payload) switch(eventType){
        case 0, $4e2819b72987a07d$export$a1562d08625f5d7e:
        case 0, $4e2819b72987a07d$export$12346a674644c156:
        case 0, $4e2819b72987a07d$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $4e2819b72987a07d$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("cspfG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3695493a5dda6cb7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c9l08 = parcelRequire("c9l08");

var $lmUQt = parcelRequire("lmUQt");

var $7pKGB = parcelRequire("7pKGB");
function $3695493a5dda6cb7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7pKGB.default), {
        ...props,
        channel: (0, $c9l08.FabricChannel).aiMate,
        processEvent: (0, $lmUQt.default)
    });
}

});
parcelRegister("lmUQt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e6324b5435a267a$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");

parcelRequire("cnhic");
var $9YUki = parcelRequire("9YUki");

var $gusLT = parcelRequire("gusLT");
const $5e6324b5435a267a$var$AI_MATE_TAG = 'aiMate';
const $5e6324b5435a267a$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $5e6324b5435a267a$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $gusLT.getSources)(event, (0, $9YUki.AI_MATE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $4e2819b72987a07d$export$b055de0e665cb20c);
    const extraAttributes = (0, $gusLT.getExtraAttributes)(event, (0, $9YUki.AI_MATE_CONTEXT));
    const components = (0, $gusLT.getComponents)(event, (0, $9YUki.AI_MATE_CONTEXT));
    const packages = (0, $gusLT.getPackageInfo)(event, (0, $9YUki.AI_MATE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $gusLT.getPackageInfo)(event, (0, $9YUki.AI_MATE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $4e2819b72987a07d$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $5e6324b5435a267a$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($5e6324b5435a267a$var$AI_MATE_TAG);
    if (event.payload) switch(eventType){
        case 0, $4e2819b72987a07d$export$a1562d08625f5d7e:
        case 0, $4e2819b72987a07d$export$12346a674644c156:
        case 0, $4e2819b72987a07d$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $4e2819b72987a07d$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("cTJ2r", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3aac7c2c855cc44$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c9l08 = parcelRequire("c9l08");

var $89Pv4 = parcelRequire("89Pv4");

var $7pKGB = parcelRequire("7pKGB");
function $e3aac7c2c855cc44$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7pKGB.default), {
        ...props,
        channel: (0, $c9l08.FabricChannel).avp,
        processEvent: (0, $89Pv4.default)
    });
}

});
parcelRegister("89Pv4", function(module, exports) {

$parcel$export(module.exports, "default", () => $db9dd0bb8c765216$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");

parcelRequire("cnhic");
var $k0kR6 = parcelRequire("k0kR6");

var $gusLT = parcelRequire("gusLT");
const $db9dd0bb8c765216$var$AVP_TAG = 'avp';
const $db9dd0bb8c765216$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $db9dd0bb8c765216$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $gusLT.getSources)(event, (0, $k0kR6.AVP_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $4e2819b72987a07d$export$b055de0e665cb20c);
    const extraAttributes = (0, $gusLT.getExtraAttributes)(event, (0, $k0kR6.AVP_CONTEXT));
    const components = (0, $gusLT.getComponents)(event, (0, $k0kR6.AVP_CONTEXT));
    const packages = (0, $gusLT.getPackageInfo)(event, (0, $k0kR6.AVP_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $gusLT.getPackageInfo)(event, (0, $k0kR6.AVP_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $4e2819b72987a07d$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $db9dd0bb8c765216$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, payloadAttributes),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, ...event.context)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($db9dd0bb8c765216$var$AVP_TAG);
    if (event.payload) switch(eventType){
        case 0, $4e2819b72987a07d$export$a1562d08625f5d7e:
        case 0, $4e2819b72987a07d$export$12346a674644c156:
        case 0, $4e2819b72987a07d$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $4e2819b72987a07d$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("jvzwa", function(module, exports) {

$parcel$export(module.exports, "default", () => $65c6675ecd46a4a9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $c9l08 = parcelRequire("c9l08");

var $56RnQ = parcelRequire("56RnQ");

var $7pKGB = parcelRequire("7pKGB");
function $65c6675ecd46a4a9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7pKGB.default), {
        ...props,
        channel: (0, $c9l08.FabricChannel).growth,
        processEvent: (0, $56RnQ.default)
    });
}

});
parcelRegister("56RnQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c85cadae03073e35$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");

parcelRequire("cnhic");
var $47pca = parcelRequire("47pca");

var $gusLT = parcelRequire("gusLT");
const $c85cadae03073e35$var$GROWTH_TAG = 'growth';
const $c85cadae03073e35$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $c85cadae03073e35$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $gusLT.getSources)(event, (0, $47pca.GROWTH_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $4e2819b72987a07d$export$b055de0e665cb20c);
    const extraAttributes = (0, $gusLT.getExtraAttributes)(event, (0, $47pca.GROWTH_CONTEXT));
    const components = (0, $gusLT.getComponents)(event, (0, $47pca.GROWTH_CONTEXT));
    const packages = (0, $gusLT.getPackageInfo)(event, (0, $47pca.GROWTH_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $gusLT.getPackageInfo)(event, (0, $47pca.GROWTH_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $4e2819b72987a07d$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $c85cadae03073e35$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($c85cadae03073e35$var$GROWTH_TAG);
    if (event.payload) switch(eventType){
        case 0, $4e2819b72987a07d$export$a1562d08625f5d7e:
        case 0, $4e2819b72987a07d$export$12346a674644c156:
        case 0, $4e2819b72987a07d$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $4e2819b72987a07d$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});




parcelRegister("bhxqg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("9WdAg")).default);
$parcel$export(module.exports, "AutoDismissFlag", () => (parcelRequire("1D5Rp")).default);
$parcel$export(module.exports, "FlagGroup", () => (parcelRequire("5Xt64")).default);
$parcel$export(module.exports, "useFlags", () => (parcelRequire("7ndW8")).useFlags);
$parcel$export(module.exports, "withFlagsProvider", () => (parcelRequire("7ndW8")).withFlagsProvider);
$parcel$export(module.exports, "FlagsProvider", () => (parcelRequire("7ndW8")).FlagsProvider);

var $9WdAg = parcelRequire("9WdAg");

var $1D5Rp = parcelRequire("1D5Rp");

var $5Xt64 = parcelRequire("5Xt64");

var $7ndW8 = parcelRequire("7ndW8");

});
parcelRegister("9WdAg", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3ccf6695a91ece5$export$2e2bcd8739ae039);
/* flag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $bKnKN = parcelRequire("bKnKN");

var $bWfiu = parcelRequire("bWfiu");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $gOkqF = parcelRequire("gOkqF");

var $cBCgC = parcelRequire("cBCgC");


var $iAAK7 = parcelRequire("iAAK7");

var $5Xt64 = parcelRequire("5Xt64");

var $gpVRy = parcelRequire("gpVRy");
var $9fMm1 = parcelRequire("9fMm1");

var $2qWOL = parcelRequire("2qWOL");
const $f3ccf6695a91ece5$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rkosqtm _1reo15vq _18m915vq _v564z97a _16qs8sq4 _1pbyni7l _1bsb1osq"
};
const $f3ccf6695a91ece5$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
const $f3ccf6695a91ece5$var$oldDescriptionStyles = null;
const $f3ccf6695a91ece5$var$descriptionStyles = null;
const $f3ccf6695a91ece5$var$oldIconWrapperStyles = null;
const $f3ccf6695a91ece5$var$iconWrapperStyles = null;
const $f3ccf6695a91ece5$var$flagWrapperStyles = null;
const $f3ccf6695a91ece5$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $f3ccf6695a91ece5$var$transitionStyles = null; /**
                                * __Flag__
                                *
                                * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
                                * often displayed using a flag group.
                                *
                                * - [Examples](https://atlassian.design/components/flag/examples)
                                * - [Code](https://atlassian.design/components/flag/code)
                                * - [Usage](https://atlassian.design/components/flag/usage)
                                */ 
const $f3ccf6695a91ece5$var$Flag = (props)=>{
    const { actions: actions = [], appearance: appearance = (0, $4bcf9932c1d0df17$export$d6830277b06edd6), icon: icon, title: title, description: description, linkComponent: linkComponent, onMouseOver: onMouseOver, onFocus: onFocus = (0, $bKnKN.default), onMouseOut: onMouseOut, onBlur: onBlur = (0, $bKnKN.default), onDismissed: onDismissedProp = (0, $bKnKN.default), testId: testId, id: id, analyticsContext: analyticsContext, delayAnnouncement: delayAnnouncement, headingLevel: headingLevel = 2 } = props;
    const [isDelayToAnnounce, setIsDelayToAnnounce] = (0, $5uXOq.useState)(false);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $5Xt64.useFlagGroup)();
    const onDismissed = (0, $5uXOq.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const [isExpanded, setIsExpanded] = (0, $5uXOq.useState)(false);
    const onDismissedAnalytics = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        ...$f3ccf6695a91ece5$var$analyticsAttributes
    });
    const isBold = appearance !== (0, $4bcf9932c1d0df17$export$d6830277b06edd6);
    const toggleExpand = (0, $5uXOq.useCallback)(()=>{
        setIsExpanded((previous)=>!previous);
    }, []);
    const buttonActionCallback = (0, $5uXOq.useCallback)(()=>{
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!delayAnnouncement) return;
        setTimeout(()=>{
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    const onFocusAnalytics = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext,
        ...$f3ccf6695a91ece5$var$analyticsAttributes
    });
    const onBlurAnalytics = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext,
        ...$f3ccf6695a91ece5$var$analyticsAttributes
    });
    const autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    const textColor = (0, $2qWOL.flagTextColor)[appearance];
    const iconColor = (0, $2qWOL.flagIconColor)[appearance];
    const iconGlyph = (0, $2qWOL.flagIconGlyph)[appearance];
    const isDismissable = isBold || isDismissAllowed;
    const shouldRenderGap = !isBold && (description || actions.length) || isExpanded; // when delayAnnouncement is available we will use a hidden content for announcement
    const delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cBCgC.default), {
        children: [
            title,
            description
        ]
    }) : undefined;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "alert",
        "data-testid": testId,
        ...autoDismissProps,
        className: (0, $bwpsq.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
            padding: "space.200",
            backgroundColor: (0, $2qWOL.flagBackgroundColor)[appearance],
            xcss: $f3ccf6695a91ece5$var$styles.flag,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                alignBlock: (0, $fHpHg.fg)('platform_ads_component_no_icon_spacing_support') ? 'start' : 'stretch',
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    , {
                        style: {
                            [$f3ccf6695a91ece5$var$CSS_VAR_ICON_COLOR]: iconColor
                        },
                        "data-testid": testId && `${testId}-icon-container`,
                        className: (0, $bwpsq.default)([
                            (0, $fHpHg.fg)('platform_ads_component_no_icon_spacing_support') ? "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz1jn0" : "_1e0c1txw _4cvrv2br _1o9zidpf _syaz1jn0"
                        ]),
                        children: icon || (iconGlyph && (0, $fHpHg.fg)('platform_ads_component_no_icon_spacing_support') ? iconGlyph : null)
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        className: (0, $bwpsq.default)([
                            "_v5641hdc _16jlkb7n"
                        ]),
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
                            space: shouldRenderGap ? 'space.100' : 'space.0',
                            children: [
                                isDelayToAnnounce && delayedAnnouncement,
                                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                                    alignBlock: "stretch",
                                    space: "space.100",
                                    spread: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                                            paddingBlockStart: "space.050",
                                            paddingBlockEnd: "space.025",
                                            xcss: $f3ccf6695a91ece5$var$styles.overflowWrap,
                                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                                                as: `h${headingLevel}`,
                                                size: "xsmall",
                                                color: textColor,
                                                children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                                                    /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce,
                                                    children: title
                                                })
                                            })
                                        }),
                                        isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gpVRy.default), {
                                            testId: testId,
                                            appearance: appearance,
                                            isBold: isBold,
                                            isExpanded: isExpanded,
                                            onClick: isBold ? toggleExpand : buttonActionCallback
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9fMm1.default), {
                                    isExpanded: !isBold || isExpanded,
                                    testId: testId,
                                    children: [
                                        description && /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                        , {
                                            style: {
                                                color: (0, $2qWOL.flagTextColorToken)[appearance]
                                            },
                                            "data-testid": testId && `${testId}-description`,
                                            "aria-hidden": isDelayToAnnounce,
                                            className: (0, $bwpsq.default)([
                                                (0, $fHpHg.fg)('platform_ads_explicit_font_styles') ? "_11c82smr _1reo1wug _18m91wug _c71l53f4 _1i4qfg65" : "_1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
                                            ]),
                                            children: description
                                        }),
                                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iAAK7.default), {
                                            actions: actions,
                                            appearance: appearance,
                                            linkComponent: linkComponent,
                                            testId: testId
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $f3ccf6695a91ece5$export$2e2bcd8739ae039 = $f3ccf6695a91ece5$var$Flag;

});
parcelRegister("bWfiu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4550dc4c69e3d93$export$2e2bcd8739ae039);
/* heading.partial.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $avgEF = parcelRequire("avgEF");

var $a2Xlh = parcelRequire("a2Xlh");

var $cFAsx = parcelRequire("cFAsx");

var $6cAn5 = parcelRequire("6cAn5");
const $e4550dc4c69e3d93$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
const $e4550dc4c69e3d93$var$styles = {
    reset: "_1mouidpf _1dyz4jg8 _1p1dglyw"
};
const $e4550dc4c69e3d93$var$headingColorStylesMap = {
    'color.text': "_syaz1fxt",
    'color.text.inverse': "_syaz15cr",
    'color.text.warning.inverse': "_syazal3n"
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c47bed69b7a147a63fdb8c394e98514a>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ const $e4550dc4c69e3d93$var$headingSizeStylesMap = {
    xxlarge: "_11c84xcc",
    xlarge: "_11c81c04",
    large: "_11c8nf1z",
    medium: "_11c8lodh",
    small: "_11c8nbxd",
    xsmall: "_11c8140y",
    xxsmall: "_11c81vhk"
};
/**
 * @codegenEnd
 */ const $e4550dc4c69e3d93$var$useColor = (colorProp)=>{
    const surface = (0, $a2Xlh.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $avgEF.inverseColorMap).hasOwnProperty(surface)) return (0, $avgEF.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ const $e4550dc4c69e3d93$var$Heading = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, size: size, id: id, testId: testId, as: as, color: colorProp } = props;
    typeof $6cAn5;
    const [hLevel, inferredElement] = (0, $cFAsx.useHeading)($e4550dc4c69e3d93$var$sizeTagMap[size]);
    const Component = as || inferredElement;
    const needsAriaRole = Component === 'div' && hLevel;
    const color = $e4550dc4c69e3d93$var$useColor(colorProp);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $bwpsq.default)([
            $e4550dc4c69e3d93$var$styles.reset,
            size && $e4550dc4c69e3d93$var$headingSizeStylesMap[size],
            $e4550dc4c69e3d93$var$headingColorStylesMap[color]
        ]),
        children: children
    });
});
var $e4550dc4c69e3d93$export$2e2bcd8739ae039 = $e4550dc4c69e3d93$var$Heading;

});
parcelRegister("avgEF", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", () => $d0ab3fa1cbfd22d9$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $d0ab3fa1cbfd22d9$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $d0ab3fa1cbfd22d9$export$632685d741f3dbbf);
$parcel$export(module.exports, "inverseColorMap", () => $d0ab3fa1cbfd22d9$export$2185ce37f9bdd963);
$parcel$export(module.exports, "opacityMap", () => $d0ab3fa1cbfd22d9$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $d0ab3fa1cbfd22d9$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $d0ab3fa1cbfd22d9$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $d0ab3fa1cbfd22d9$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $d0ab3fa1cbfd22d9$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $d0ab3fa1cbfd22d9$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $d0ab3fa1cbfd22d9$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $d0ab3fa1cbfd22d9$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "fontMap", () => $d0ab3fa1cbfd22d9$export$6ffa317d5e70375);
$parcel$export(module.exports, "fontWeightMap", () => $d0ab3fa1cbfd22d9$export$303e322c6b1ed114);
$parcel$export(module.exports, "fontFamilyMap", () => $d0ab3fa1cbfd22d9$export$3c7e9587132614b4);
$parcel$export(module.exports, "paddingStylesMap", () => $d0ab3fa1cbfd22d9$export$e615f061ca585a6c);
$parcel$export(module.exports, "spaceStylesMap", () => $d0ab3fa1cbfd22d9$export$bf46c3f9eeafc71f);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $d0ab3fa1cbfd22d9$export$e7af83bafe7f9e63);
$parcel$export(module.exports, "textColorStylesMap", () => $d0ab3fa1cbfd22d9$export$3a1bcba60b23d7f0);
$parcel$export(module.exports, "textSizeStylesMap", () => $d0ab3fa1cbfd22d9$export$219d364c0da35ae4);
$parcel$export(module.exports, "textWeightStylesMap", () => $d0ab3fa1cbfd22d9$export$38845ca010b93505);
$parcel$export(module.exports, "surfaceColorStylesMap", () => $d0ab3fa1cbfd22d9$export$ff257d957d48c421);
$parcel$export(module.exports, "isSurfaceColorToken", () => $d0ab3fa1cbfd22d9$export$5e65a44e5b6ecadb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $d5aOx = parcelRequire("d5aOx");
const $d0ab3fa1cbfd22d9$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
const $d0ab3fa1cbfd22d9$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
const $d0ab3fa1cbfd22d9$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
const $d0ab3fa1cbfd22d9$export$632685d741f3dbbf = {
    ...$d0ab3fa1cbfd22d9$export$958d0ae7f2977ae4,
    ...$d0ab3fa1cbfd22d9$export$d2dc61f58390201c
};
const $d0ab3fa1cbfd22d9$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $d0ab3fa1cbfd22d9$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
const $d0ab3fa1cbfd22d9$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
const $d0ab3fa1cbfd22d9$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
const $d0ab3fa1cbfd22d9$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
const $d0ab3fa1cbfd22d9$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
const $d0ab3fa1cbfd22d9$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
const $d0ab3fa1cbfd22d9$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
const $d0ab3fa1cbfd22d9$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
const $d0ab3fa1cbfd22d9$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
const $d0ab3fa1cbfd22d9$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
const $d0ab3fa1cbfd22d9$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $d0ab3fa1cbfd22d9$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
const $d0ab3fa1cbfd22d9$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $d0ab3fa1cbfd22d9$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $d0ab3fa1cbfd22d9$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
// Generate maps for Box props. backgroundColor, padding, etc
const $d0ab3fa1cbfd22d9$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
const $d0ab3fa1cbfd22d9$export$ca0f9c2de39ffed7 = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, token)=>{
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = /*#__PURE__*/ (0, $f8Sb3.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[token]
        });
        return emotionSpacingMap;
    }, {});
};
const $d0ab3fa1cbfd22d9$export$e615f061ca585a6c = $d0ab3fa1cbfd22d9$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $d0ab3fa1cbfd22d9$export$ca0f9c2de39ffed7(spacingProperty, $d0ab3fa1cbfd22d9$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $d0ab3fa1cbfd22d9$export$bf46c3f9eeafc71f = $d0ab3fa1cbfd22d9$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $d0ab3fa1cbfd22d9$export$ca0f9c2de39ffed7(spacingProperty, $d0ab3fa1cbfd22d9$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $d0ab3fa1cbfd22d9$export$e7af83bafe7f9e63 = $d0ab3fa1cbfd22d9$export$ca0f9c2de39ffed7('backgroundColor', $d0ab3fa1cbfd22d9$export$d1d79bf68ac056bd);
const $d0ab3fa1cbfd22d9$export$3a1bcba60b23d7f0 = $d0ab3fa1cbfd22d9$export$ca0f9c2de39ffed7('color', $d0ab3fa1cbfd22d9$export$8473307aa00d6ea1);
const $d0ab3fa1cbfd22d9$export$45f3f4fe16f9f7d5 = $d0ab3fa1cbfd22d9$export$ca0f9c2de39ffed7('fontWeight', $d0ab3fa1cbfd22d9$export$303e322c6b1ed114);
const $d0ab3fa1cbfd22d9$export$68cc305da27dbaa4 = $d0ab3fa1cbfd22d9$export$ca0f9c2de39ffed7('fontFamily', $d0ab3fa1cbfd22d9$export$3c7e9587132614b4);
const $d0ab3fa1cbfd22d9$export$128f10c238242f83 = $d0ab3fa1cbfd22d9$export$ca0f9c2de39ffed7('font', $d0ab3fa1cbfd22d9$export$6ffa317d5e70375);
const $d0ab3fa1cbfd22d9$export$219d364c0da35ae4 = $d0ab3fa1cbfd22d9$export$ca0f9c2de39ffed7('font', $d0ab3fa1cbfd22d9$export$236bfe3a33ef1292);
const $d0ab3fa1cbfd22d9$export$38845ca010b93505 = $d0ab3fa1cbfd22d9$export$ca0f9c2de39ffed7('fontWeight', $d0ab3fa1cbfd22d9$export$855cfd311192d666);
const $d0ab3fa1cbfd22d9$export$ff257d957d48c421 = $d0ab3fa1cbfd22d9$export$ca0f9c2de39ffed7((0, $d5aOx.CURRENT_SURFACE_CSS_VAR), $d0ab3fa1cbfd22d9$export$41a358c9c2356760);
const $d0ab3fa1cbfd22d9$export$5e65a44e5b6ecadb = (color)=>$d0ab3fa1cbfd22d9$export$41a358c9c2356760[color] !== undefined;

});
parcelRegister("d5aOx", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $8369a39248f55fcc$export$4ef52930e33717cd);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $8369a39248f55fcc$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $8369a39248f55fcc$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $8369a39248f55fcc$export$352e418ed5b6193a);
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", () => $8369a39248f55fcc$export$dddac1532e822863);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $8369a39248f55fcc$export$9d7b58831ae93caa);
const $8369a39248f55fcc$export$4ef52930e33717cd = 'data-theme';
const $8369a39248f55fcc$export$a00eac3f8684bcd0 = 'data-color-mode';
const $8369a39248f55fcc$export$2112803007239c61 = 'data-contrast-mode';
const $8369a39248f55fcc$export$352e418ed5b6193a = 'data-custom-theme';
const $8369a39248f55fcc$export$6f0c6fb8c80fcc92 = 'ds';
const $8369a39248f55fcc$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
const $8369a39248f55fcc$export$dddac1532e822863 = `--${$8369a39248f55fcc$export$6f0c6fb8c80fcc92}-token-not-found`;
const $8369a39248f55fcc$export$9d7b58831ae93caa = `--${$8369a39248f55fcc$export$6f0c6fb8c80fcc92}-elevation-surface-current`;

});


parcelRegister("a2Xlh", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", () => $1c4d5cd4ce473566$export$1ca2a26fecb070ae);
$parcel$export(module.exports, "useSurface", () => $1c4d5cd4ce473566$export$1aeb4f6b93c4540d);

var $5uXOq = parcelRequire("5uXOq");
const $1c4d5cd4ce473566$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5uXOq.createContext)('elevation.surface');
const $1c4d5cd4ce473566$export$1aeb4f6b93c4540d = ()=>{
    return (0, $5uXOq.useContext)($1c4d5cd4ce473566$export$1ca2a26fecb070ae);
};
$1c4d5cd4ce473566$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});

parcelRegister("cFAsx", function(module, exports) {

$parcel$export(module.exports, "useHeading", () => $9b299dc4b5af2d32$export$97a37b1befbbf9b1);
$parcel$export(module.exports, "default", () => $9b299dc4b5af2d32$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $9b299dc4b5af2d32$var$HeadingLevelContext = /*#__PURE__*/ (0, $5uXOq.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ const $9b299dc4b5af2d32$var$useHeadingLevel = ()=>{
    return (0, $5uXOq.useContext)($9b299dc4b5af2d32$var$HeadingLevelContext);
};
const $9b299dc4b5af2d32$export$97a37b1befbbf9b1 = (fallback)=>{
    const hLevel = $9b299dc4b5af2d32$var$useHeadingLevel();
    /**
	 * Order here is important, we for now apply
	 * 1. inferred a11y level (this only applies if context is present)
	 * 2. default final fallback
	 */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : `h${hLevel}`) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ const $9b299dc4b5af2d32$var$HeadingLevelContextProvider = ({ children: children, value: value })=>{
    const parentHeadingLevel = $9b299dc4b5af2d32$var$useHeadingLevel();
    const headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, $2OMIu.jsx)($9b299dc4b5af2d32$var$HeadingLevelContext.Provider, {
        value: value || headingLevel,
        children: children
    });
};
var $9b299dc4b5af2d32$export$2e2bcd8739ae039 = $9b299dc4b5af2d32$var$HeadingLevelContextProvider;

});


parcelRegister("5sRpy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4091925cf3eefbb$export$2e2bcd8739ae039);
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $a2Xlh = parcelRequire("a2Xlh");
const $c4091925cf3eefbb$var$baseStyles = null;
const $c4091925cf3eefbb$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhk1fno",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1eds",
    'color.background.accent.lime.subtler.pressed': "_bfhk1hgz",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhkhgj8",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhk1b17",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhk1pbw",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkrw5d",
    'color.background.accent.red.subtler.pressed': "_bfhk69rw",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1tf4",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhkprmn",
    'color.background.accent.orange.subtlest': "_bfhk1g3m",
    'color.background.accent.orange.subtlest.hovered': "_bfhkg4tm",
    'color.background.accent.orange.subtlest.pressed': "_bfhk1ya0",
    'color.background.accent.orange.subtler': "_bfhkf2vu",
    'color.background.accent.orange.subtler.hovered': "_bfhk1lml",
    'color.background.accent.orange.subtler.pressed': "_bfhkuxsx",
    'color.background.accent.orange.subtle': "_bfhk1g6e",
    'color.background.accent.orange.subtle.hovered': "_bfhk1oew",
    'color.background.accent.orange.subtle.pressed': "_bfhk1phk",
    'color.background.accent.orange.bolder': "_bfhkjgng",
    'color.background.accent.orange.bolder.hovered': "_bfhkhi52",
    'color.background.accent.orange.bolder.pressed': "_bfhkf767",
    'color.background.accent.yellow.subtlest': "_bfhk1ozg",
    'color.background.accent.yellow.subtlest.hovered': "_bfhk19g9",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk31d1",
    'color.background.accent.yellow.subtler': "_bfhk3fv2",
    'color.background.accent.yellow.subtler.hovered': "_bfhklg04",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1d44",
    'color.background.accent.yellow.subtle': "_bfhkry5t",
    'color.background.accent.yellow.subtle.hovered': "_bfhk17e6",
    'color.background.accent.yellow.subtle.pressed': "_bfhko0y5",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk32kj",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkv5yf",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhkung8",
    'color.background.accent.green.subtler.pressed': "_bfhk1p19",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk8h4p",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1azz",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1j2h",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkg5py",
    'color.background.accent.teal.subtler.pressed': "_bfhkq7li",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk10ai",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhkse6l",
    'color.background.accent.blue.subtlest': "_bfhkavxe",
    'color.background.accent.blue.subtlest.hovered': "_bfhkay3p",
    'color.background.accent.blue.subtlest.pressed': "_bfhk1xmr",
    'color.background.accent.blue.subtler': "_bfhk4v9p",
    'color.background.accent.blue.subtler.hovered': "_bfhk16e6",
    'color.background.accent.blue.subtler.pressed': "_bfhk1uh7",
    'color.background.accent.blue.subtle': "_bfhk1j89",
    'color.background.accent.blue.subtle.hovered': "_bfhk1f4s",
    'color.background.accent.blue.subtle.pressed': "_bfhkqctv",
    'color.background.accent.blue.bolder': "_bfhkc8cv",
    'color.background.accent.blue.bolder.hovered': "_bfhk1cwi",
    'color.background.accent.blue.bolder.pressed': "_bfhkhcrq",
    'color.background.accent.purple.subtlest': "_bfhkp7j4",
    'color.background.accent.purple.subtlest.hovered': "_bfhkm0d5",
    'color.background.accent.purple.subtlest.pressed': "_bfhkgslw",
    'color.background.accent.purple.subtler': "_bfhk1jkz",
    'color.background.accent.purple.subtler.hovered': "_bfhk1wyu",
    'color.background.accent.purple.subtler.pressed': "_bfhk5fkp",
    'color.background.accent.purple.subtle': "_bfhkdh45",
    'color.background.accent.purple.subtle.hovered': "_bfhk1wob",
    'color.background.accent.purple.subtle.pressed': "_bfhkwz05",
    'color.background.accent.purple.bolder': "_bfhkygwo",
    'color.background.accent.purple.bolder.hovered': "_bfhkadgs",
    'color.background.accent.purple.bolder.pressed': "_bfhk1uro",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1een",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1r0p",
    'color.background.accent.magenta.subtler.pressed': "_bfhkxuzc",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk1ovh",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkwaw3",
    'color.background.accent.gray.subtlest': "_bfhk11bn",
    'color.background.accent.gray.subtlest.hovered': "_bfhk12j4",
    'color.background.accent.gray.subtlest.pressed': "_bfhk1lb4",
    'color.background.accent.gray.subtler': "_bfhk1v33",
    'color.background.accent.gray.subtler.hovered': "_bfhk1f7l",
    'color.background.accent.gray.subtler.pressed': "_bfhkd8a2",
    'color.background.accent.gray.subtle': "_bfhk1t05",
    'color.background.accent.gray.subtle.hovered': "_bfhk1a2l",
    'color.background.accent.gray.subtle.pressed': "_bfhk1z0s",
    'color.background.accent.gray.bolder': "_bfhk1t1b",
    'color.background.accent.gray.bolder.hovered': "_bfhke4nv",
    'color.background.accent.gray.bolder.pressed': "_bfhk82ra",
    'color.background.disabled': "_bfhksyzs",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhk1d5g",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhkm7j4",
    'color.background.neutral.hovered': "_bfhk15ej",
    'color.background.neutral.pressed': "_bfhkip91",
    'color.background.neutral.subtle': "_bfhk1w7a",
    'color.background.neutral.subtle.hovered': "_bfhk166n",
    'color.background.neutral.subtle.pressed': "_bfhk1dty",
    'color.background.neutral.bold': "_bfhkcdhy",
    'color.background.neutral.bold.hovered': "_bfhk1bsc",
    'color.background.neutral.bold.pressed': "_bfhk1b6k",
    'color.background.selected': "_bfhkfg4m",
    'color.background.selected.hovered': "_bfhki1yw",
    'color.background.selected.pressed': "_bfhk19ru",
    'color.background.selected.bold': "_bfhk1fvw",
    'color.background.selected.bold.hovered': "_bfhk18hz",
    'color.background.selected.bold.pressed': "_bfhkgr1v",
    'color.background.brand.subtlest': "_bfhk3wxy",
    'color.background.brand.subtlest.hovered': "_bfhkezq1",
    'color.background.brand.subtlest.pressed': "_bfhk2ggb",
    'color.background.brand.bold': "_bfhkb29m",
    'color.background.brand.bold.hovered': "_bfhku1se",
    'color.background.brand.bold.pressed': "_bfhkqkzo",
    'color.background.brand.boldest': "_bfhk15mt",
    'color.background.brand.boldest.hovered': "_bfhk1uwk",
    'color.background.brand.boldest.pressed': "_bfhk17jr",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1io2",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk9pqq",
    'color.background.warning': "_bfhk1tzq",
    'color.background.warning.hovered': "_bfhk1rd4",
    'color.background.warning.pressed': "_bfhk11dh",
    'color.background.warning.bold': "_bfhk190i",
    'color.background.warning.bold.hovered': "_bfhk1i4c",
    'color.background.warning.bold.pressed': "_bfhkrj9s",
    'color.background.success': "_bfhkmv6i",
    'color.background.success.hovered': "_bfhk1jgi",
    'color.background.success.pressed': "_bfhky4f1",
    'color.background.success.bold': "_bfhk8emd",
    'color.background.success.bold.hovered': "_bfhk1q4l",
    'color.background.success.bold.pressed': "_bfhkcrcn",
    'color.background.discovery': "_bfhk1nvp",
    'color.background.discovery.hovered': "_bfhk1xp7",
    'color.background.discovery.pressed': "_bfhkdlkp",
    'color.background.discovery.bold': "_bfhk1lri",
    'color.background.discovery.bold.hovered': "_bfhk1w72",
    'color.background.discovery.bold.pressed': "_bfhkrb53",
    'color.background.information': "_bfhk33gi",
    'color.background.information.hovered': "_bfhk1vps",
    'color.background.information.pressed': "_bfhk1s0z",
    'color.background.information.bold': "_bfhk14wj",
    'color.background.information.bold.hovered': "_bfhk1amz",
    'color.background.information.bold.pressed': "_bfhk5bth",
    'color.blanket': "_bfhk10xm",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkn82g",
    'color.skeleton.subtle': "_bfhkh3tw",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk108i",
    'elevation.surface.pressed': "_bfhk1ji5",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk16qz",
    'elevation.surface.overlay.pressed': "_bfhkvq0a",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk1a0f",
    'elevation.surface.raised.pressed': "_bfhkf7u5",
    'elevation.surface.sunken': "_bfhkqbzx",
    'utility.elevation.surface.current': "_bfhkchd4"
};
const $c4091925cf3eefbb$var$CURRENT_SURFACE_CSS_VAR = `--ds-elevation-surface-current`;
const $c4091925cf3eefbb$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l108i",
    'elevation.surface.pressed': "_1q1l1ji5",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l16qz",
    'elevation.surface.overlay.pressed': "_1q1lvq0a",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l1a0f",
    'elevation.surface.raised.pressed': "_1q1lf7u5",
    'elevation.surface.sunken': "_1q1lqbzx"
};
const $c4091925cf3eefbb$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
const $c4091925cf3eefbb$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
const $c4091925cf3eefbb$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
const $c4091925cf3eefbb$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ const $c4091925cf3eefbb$var$Box = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock = padding, paddingBlockStart: paddingBlockStart = paddingBlock, paddingBlockEnd: paddingBlockEnd = paddingBlock, paddingInline: paddingInline = padding, paddingInlineStart: paddingInlineStart = paddingInline, paddingInlineEnd: paddingInlineEnd = paddingInline, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const node = /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // @ts-ignore -- Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $bwpsq.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $c4091925cf3eefbb$var$backgroundColorMap[backgroundColor],
            backgroundColor && $c4091925cf3eefbb$var$isSurfaceToken(backgroundColor) && $c4091925cf3eefbb$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $c4091925cf3eefbb$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $c4091925cf3eefbb$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $c4091925cf3eefbb$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $c4091925cf3eefbb$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ]),
        ...safeHtmlAttributes,
        "data-testid": testId,
        children: children
    });
    if (backgroundColor) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a2Xlh.SurfaceContext).Provider, {
        value: backgroundColor,
        children: node
    });
    return node;
});
var $c4091925cf3eefbb$export$2e2bcd8739ae039 = $c4091925cf3eefbb$var$Box;
function $c4091925cf3eefbb$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $c4091925cf3eefbb$var$setSurfaceTokenMap;
}

});

parcelRegister("5sLH0", function(module, exports) {

$parcel$export(module.exports, "default", () => $239707162e65d464$export$2e2bcd8739ae039);
/* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6tzHJ = parcelRequire("6tzHJ");

var $AX5oF = parcelRequire("AX5oF");
const $239707162e65d464$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $239707162e65d464$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            $239707162e65d464$var$styles.separator
        ]),
        children: children
    });
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $239707162e65d464$var$Inline = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $2OMIu.jsx)($239707162e65d464$var$Separator, {
        children: separator
    }) : separator;
    const children = separatorComponent ? (0, $5uXOq.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                separator && index > 0 ? separatorComponent : null,
                child
            ]
        }, index);
    }) : rawChildren;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $AX5oF.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $6tzHJ.cx)(grow === 'hug' && $239707162e65d464$var$styles.hug, grow === 'fill' && $239707162e65d464$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$239707162e65d464$var$Inline.displayName = 'Inline';
var $239707162e65d464$export$2e2bcd8739ae039 = $239707162e65d464$var$Inline;

});
parcelRegister("6tzHJ", function(module, exports) {

$parcel$export(module.exports, "cx", () => $1b8b53c45bf104ed$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("5uXOq");

var $1tTNc = parcelRequire("1tTNc");
const { XCSSProp: $1b8b53c45bf104ed$var$XCSSProp, css: $1b8b53c45bf104ed$export$dbf350e5966cf602, cssMap: $1b8b53c45bf104ed$export$eb1ecd84a24ee424, cx: $1b8b53c45bf104ed$export$a274e22fb40f762e } = (0, $1tTNc.createStrictAPI)();

});

parcelRegister("AX5oF", function(module, exports) {

$parcel$export(module.exports, "default", () => $88747ebb652feddb$export$2e2bcd8739ae039);
/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $88747ebb652feddb$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $88747ebb652feddb$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $88747ebb652feddb$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $88747ebb652feddb$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $88747ebb652feddb$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $88747ebb652feddb$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $88747ebb652feddb$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $88747ebb652feddb$var$Flex = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        role: role,
        className: (0, $bwpsq.default)([
            $88747ebb652feddb$var$styles.root,
            gap && $88747ebb652feddb$var$columnGapMap[gap],
            columnGap && $88747ebb652feddb$var$columnGapMap[columnGap],
            gap && $88747ebb652feddb$var$rowGapMap[gap],
            rowGap && $88747ebb652feddb$var$rowGapMap[rowGap],
            alignItems && $88747ebb652feddb$var$alignItemsMap[alignItems],
            direction && $88747ebb652feddb$var$flexDirectionMap[direction],
            justifyContent && $88747ebb652feddb$var$justifyContentMap[justifyContent],
            wrap && $88747ebb652feddb$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$88747ebb652feddb$var$Flex.displayName = 'Flex';
var $88747ebb652feddb$export$2e2bcd8739ae039 = $88747ebb652feddb$var$Flex;

});


parcelRegister("gOkqF", function(module, exports) {

$parcel$export(module.exports, "default", () => $709c41a62a05c9ad$export$2e2bcd8739ae039);
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6tzHJ = parcelRequire("6tzHJ");

var $AX5oF = parcelRequire("AX5oF");
const $709c41a62a05c9ad$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $709c41a62a05c9ad$var$Stack = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $AX5oF.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $6tzHJ.cx)(grow === 'hug' && $709c41a62a05c9ad$var$styles.hug, grow === 'fill' && $709c41a62a05c9ad$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$709c41a62a05c9ad$var$Stack.displayName = 'Stack';
var $709c41a62a05c9ad$export$2e2bcd8739ae039 = $709c41a62a05c9ad$var$Stack;

});

const $4bcf9932c1d0df17$export$d6830277b06edd6 = 'normal';

parcelRegister("iAAK7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5dda70a57da7725$export$2e2bcd8739ae039);
/* flag-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1nSOt = parcelRequire("1nSOt");

var $fHpHg = parcelRequire("fHpHg");

var $5sLH0 = parcelRequire("5sLH0");


var $2qWOL = parcelRequire("2qWOL");
const $d5dda70a57da7725$var$buttonStyles = null;
const $d5dda70a57da7725$var$fontStyles = null;
const $d5dda70a57da7725$var$appearanceNormalButtonStyles = null;
const $d5dda70a57da7725$var$appearanceNormalActionsContainerStyles = null;
const $d5dda70a57da7725$var$FlagActions = (props)=>{
    const { appearance: appearance = (0, $4bcf9932c1d0df17$export$d6830277b06edd6), actions: actions = [], linkComponent: linkComponent, testId: testId } = props;
    if (!actions.length) return null;
    const isBold = appearance !== (0, $4bcf9932c1d0df17$export$d6830277b06edd6);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            !isBold && "_1g4l107e _y8dn107e",
            (0, $fHpHg.fg)('platform_ads_explicit_font_styles') && "_11c82smr"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
            space: "space.100",
            shouldWrap: true,
            alignBlock: "center",
            separator: isBold ? undefined : "\xb7",
            testId: testId && `${testId}-actions`,
            children: actions.map((action, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1nSOt.default), {
                    onClick: action.onClick,
                    href: action.href,
                    target: action.target,
                    appearance: isBold ? 'default' : 'link',
                    component: linkComponent,
                    spacing: "compact",
                    testId: action.testId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        '--color': (0, $2qWOL.actionTextColor)[appearance],
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color': (0, $2qWOL.actionBackgroundColor)[appearance].default,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-hover': (0, $2qWOL.actionBackgroundColor)[appearance].pressed,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-active': (0, $2qWOL.actionBackgroundColor)[appearance].active
                    },
                    className: (0, $bwpsq.default)([
                        "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk61a66 _1wy61a66 _b3g31a66 _eqps1a66 _ow0718uv _1p6b18uv _8dbm18uv _77mc18uv _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                        appearance === (0, $4bcf9932c1d0df17$export$d6830277b06edd6) && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
                    ]),
                    children: action.content
                }, index))
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d5dda70a57da7725$export$2e2bcd8739ae039 = $d5dda70a57da7725$var$FlagActions;

});
parcelRegister("2qWOL", function(module, exports) {

$parcel$export(module.exports, "flagBackgroundColor", () => $8f5b7adf0a178149$export$59e42969c95d314);
$parcel$export(module.exports, "flagIconColor", () => $8f5b7adf0a178149$export$7f70afe2167f8235);
$parcel$export(module.exports, "flagIconGlyph", () => $8f5b7adf0a178149$export$73f08aee70487cd4);
$parcel$export(module.exports, "flagTextColor", () => $8f5b7adf0a178149$export$f50075b2584087f);
$parcel$export(module.exports, "flagTextColorToken", () => $8f5b7adf0a178149$export$13b42cd9d596bfe0);
$parcel$export(module.exports, "actionBackgroundColor", () => $8f5b7adf0a178149$export$81ba6b63eedb299f);
$parcel$export(module.exports, "actionTextColor", () => $8f5b7adf0a178149$export$7bcfe3cca4dd78b6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5E93O = parcelRequire("5E93O");

var $k01Ou = parcelRequire("k01Ou");

var $bMdrA = parcelRequire("bMdrA");

var $85eFT = parcelRequire("85eFT");

const $8f5b7adf0a178149$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};
const $8f5b7adf0a178149$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #626F86)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #172B4D)"
};
const $8f5b7adf0a178149$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
        LEGACY_secondaryColor: "var(--ds-background-danger-bold, #C9372C)"
    }),
    info: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k01Ou))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
        LEGACY_secondaryColor: "var(--ds-background-neutral-bold, #44546F)"
    }),
    normal: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k01Ou))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-subtle, ${(0, $a7f8c6b391092279$export$c39c0fe0f26207ae)})`,
        LEGACY_secondaryColor: "var(--ds-surface-overlay, #FFFFFF)"
    }),
    success: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
        LEGACY_secondaryColor: "var(--ds-background-success-bold, #1F845A)"
    }),
    warning: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($85eFT))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-warning-inverse, ${(0, $a7f8c6b391092279$export$ad0bacf983b7ddaa)})`,
        LEGACY_secondaryColor: "var(--ds-background-warning-bold, #F5CD47)"
    })
};
const $8f5b7adf0a178149$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};
const $8f5b7adf0a178149$export$13b42cd9d596bfe0 = {
    error: `var(--ds-text-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
    info: `var(--ds-text-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
    normal: `var(--ds-text, ${(0, $a7f8c6b391092279$export$7d61b15e0da132af)})`,
    success: `var(--ds-text-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
    warning: `var(--ds-text-warning-inverse, ${(0, $a7f8c6b391092279$export$ad0bacf983b7ddaa)})`
};
const $8f5b7adf0a178149$export$81ba6b63eedb299f = {
    success: {
        default: `var(--ds-background-inverse-subtle, ${(0, $a7f8c6b391092279$export$920c0d5c49070351)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $a7f8c6b391092279$export$920c0d5c49070351)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $a7f8c6b391092279$export$920c0d5c49070351)})`
    },
    info: {
        default: `var(--ds-background-inverse-subtle, ${(0, $a7f8c6b391092279$export$920c0d5c49070351)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $a7f8c6b391092279$export$920c0d5c49070351)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $a7f8c6b391092279$export$920c0d5c49070351)})`
    },
    error: {
        default: `var(--ds-background-inverse-subtle, ${(0, $a7f8c6b391092279$export$920c0d5c49070351)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $a7f8c6b391092279$export$920c0d5c49070351)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $a7f8c6b391092279$export$920c0d5c49070351)})`
    },
    warning: {
        default: `var(--ds-background-inverse-subtle, ${(0, $a7f8c6b391092279$export$920c0d5c49070351)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $a7f8c6b391092279$export$920c0d5c49070351)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $a7f8c6b391092279$export$920c0d5c49070351)})`
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};
const $8f5b7adf0a178149$export$7bcfe3cca4dd78b6 = {
    success: `var(--ds-text-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
    info: `var(--ds-text-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
    error: `var(--ds-text-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
    warning: `var(--ds-text-warning-inverse, ${(0, $a7f8c6b391092279$export$ad0bacf983b7ddaa)})`,
    normal: `var(--ds-link, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`
};

});
parcelRegister("5E93O", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a36a65999ae3c13d3a1917b5e2b052e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $41c7b765078297b0$var$_react = $41c7b765078297b0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $41c7b765078297b0$var$_error = $41c7b765078297b0$var$_interopRequireDefault((parcelRequire("ijSqY")));

var $41c7b765078297b0$var$_error2 = $41c7b765078297b0$var$_interopRequireDefault((parcelRequire("hWOvD")));
function $41c7b765078297b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $41c7b765078297b0$var$ErrorIcon = (props)=>/*#__PURE__*/ $41c7b765078297b0$var$_react.default.createElement($41c7b765078297b0$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $41c7b765078297b0$var$_error2.default
    }, props));
$41c7b765078297b0$var$ErrorIcon.Name = 'ErrorIconMigration';
var $41c7b765078297b0$var$_default = module.exports.default = $41c7b765078297b0$var$ErrorIcon;

});

parcelRegister("k01Ou", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a62cd542d4ba6c4ac33816bbd6056646>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e8f536d1ea5f7463$var$_react = $e8f536d1ea5f7463$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e8f536d1ea5f7463$var$_information = $e8f536d1ea5f7463$var$_interopRequireDefault((parcelRequire("9a675")));

var $e8f536d1ea5f7463$var$_info = $e8f536d1ea5f7463$var$_interopRequireDefault((parcelRequire("lVF4A")));
function $e8f536d1ea5f7463$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e8f536d1ea5f7463$var$InformationIcon = (props)=>/*#__PURE__*/ $e8f536d1ea5f7463$var$_react.default.createElement($e8f536d1ea5f7463$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $e8f536d1ea5f7463$var$_info.default
    }, props));
$e8f536d1ea5f7463$var$InformationIcon.Name = 'InformationIconMigration';
var $e8f536d1ea5f7463$var$_default = module.exports.default = $e8f536d1ea5f7463$var$InformationIcon;

});

parcelRegister("bMdrA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::934663f3d49f13f5eb4d23bc2f11a666>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $892e9b17d76b7a55$var$_react = $892e9b17d76b7a55$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $892e9b17d76b7a55$var$_success = $892e9b17d76b7a55$var$_interopRequireDefault((parcelRequire("cFUJ2")));

var $892e9b17d76b7a55$var$_checkCircle = $892e9b17d76b7a55$var$_interopRequireDefault((parcelRequire("jDpWv")));
function $892e9b17d76b7a55$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $892e9b17d76b7a55$var$SuccessIcon = (props)=>/*#__PURE__*/ $892e9b17d76b7a55$var$_react.default.createElement($892e9b17d76b7a55$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $892e9b17d76b7a55$var$_checkCircle.default
    }, props));
$892e9b17d76b7a55$var$SuccessIcon.Name = 'SuccessIconMigration';
var $892e9b17d76b7a55$var$_default = module.exports.default = $892e9b17d76b7a55$var$SuccessIcon;

});

parcelRegister("85eFT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::783ce92761ea23bbb39745cb99e4a6be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e2a2c775ff008a3$var$_react = $5e2a2c775ff008a3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5e2a2c775ff008a3$var$_warning = $5e2a2c775ff008a3$var$_interopRequireDefault((parcelRequire("c0tV6")));

var $5e2a2c775ff008a3$var$_warning2 = $5e2a2c775ff008a3$var$_interopRequireDefault((parcelRequire("bzBk6")));
function $5e2a2c775ff008a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5e2a2c775ff008a3$var$WarningIcon = (props)=>/*#__PURE__*/ $5e2a2c775ff008a3$var$_react.default.createElement($5e2a2c775ff008a3$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $5e2a2c775ff008a3$var$_warning2.default
    }, props));
$5e2a2c775ff008a3$var$WarningIcon.Name = 'WarningIconMigration';
var $5e2a2c775ff008a3$var$_default = module.exports.default = $5e2a2c775ff008a3$var$WarningIcon;

});



parcelRegister("5Xt64", function(module, exports) {

$parcel$export(module.exports, "useFlagGroup", () => $adf75ec93865dfa7$export$e91ea202abb66350);
$parcel$export(module.exports, "default", () => $adf75ec93865dfa7$export$2e2bcd8739ae039);
/* flag-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bKnKN = parcelRequire("bKnKN");

var $7xhdA = parcelRequire("7xhdA");
var $3aB43 = parcelRequire("3aB43");

var $5g2iQ = parcelRequire("5g2iQ");

var $b4a3S = parcelRequire("b4a3S");

var $cBCgC = parcelRequire("cBCgC");
const $adf75ec93865dfa7$export$1eee5ddc4f6d41c5 = 400;
const $adf75ec93865dfa7$var$defaultFlagGroupContext = {
    onDismissed: (0, $bKnKN.default),
    isDismissAllowed: false
};
const $adf75ec93865dfa7$export$c57ba665aaa722be = /*#__PURE__*/ (0, $5uXOq.createContext)($adf75ec93865dfa7$var$defaultFlagGroupContext);
function $adf75ec93865dfa7$export$e91ea202abb66350() {
    return (0, $5uXOq.useContext)($adf75ec93865dfa7$export$c57ba665aaa722be);
}
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $adf75ec93865dfa7$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
const $adf75ec93865dfa7$var$dismissAllowedStyles = null;
const $adf75ec93865dfa7$var$flagGroupContainerStyles = null;
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ const $adf75ec93865dfa7$var$FlagGroup = (props)=>{
    const { id: id, label: label = 'Flag notifications', labelTag: LabelTag = 'h2', shouldRenderToParent: shouldRenderToParent = false, children: children, onDismissed: onDismissed = (0, $bKnKN.default) } = props;
    const hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    const dismissFlagContext = (0, $5uXOq.useMemo)(()=>({
            onDismissed: onDismissed,
            isDismissAllowed: true
        }), [
        onDismissed
    ]);
    const renderChildren = ()=>{
        return children && typeof children === 'object' ? (0, $5uXOq.Children).map(children, (flag, index)=>{
            const isDismissAllowed = index === 0;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3aB43.default), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in",
                children: ({ className: className, ref: ref })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $bwpsq.default)([
                            $adf75ec93865dfa7$var$groupStyles.root,
                            index === 0 && $adf75ec93865dfa7$var$groupStyles.first,
                            index === 1 && $adf75ec93865dfa7$var$groupStyles.second,
                            index >= 1 && $adf75ec93865dfa7$var$groupStyles.nth,
                            index >= 2 && $adf75ec93865dfa7$var$groupStyles.hidden,
                            isDismissAllowed && "_12a7luct",
                            className
                        ]),
                        ref: ref,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)($adf75ec93865dfa7$export$c57ba665aaa722be.Provider, {
                            value: // Only the first flag should be able to be dismissed.
                            isDismissAllowed ? dismissFlagContext : $adf75ec93865dfa7$var$defaultFlagGroupContext,
                            children: flag
                        })
                    })
            });
        }) : false;
    };
    const flags = /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        id: id,
        className: (0, $bwpsq.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf"
        ]),
        children: [
            hasFlags ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(LabelTag, {
                    children: label
                })
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7xhdA.default), {
                appear: false,
                children: renderChildren()
            })
        ]
    });
    return shouldRenderToParent ? flags : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5g2iQ.default), {
        zIndex: (0, $b4a3S.layers).flag(),
        children: flags
    });
};
var $adf75ec93865dfa7$export$2e2bcd8739ae039 = $adf75ec93865dfa7$var$FlagGroup;

});
parcelRegister("7xhdA", function(module, exports) {

$parcel$export(module.exports, "useExitingPersistence", () => $5fd54e9316d0585a$export$3b6f38abbdcbd000);
$parcel$export(module.exports, "default", () => $5fd54e9316d0585a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $eXGNC = parcelRequire("eXGNC");
// We define empty context here so the object doesn't change.
const $5fd54e9316d0585a$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ const $5fd54e9316d0585a$var$ExitingContext = /*#__PURE__*/ (0, $5uXOq.createContext)($5fd54e9316d0585a$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ const $5fd54e9316d0585a$var$wrapChildWithContextProvider = (child, value = $5fd54e9316d0585a$var$emptyContext)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($5fd54e9316d0585a$var$ExitingContext.Provider, {
        value: value,
        children: child
    }, `${child.key}-provider`);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ const $5fd54e9316d0585a$var$childrenToArray = (children)=>{
    const childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5uXOq.Children).toArray(children).forEach((child)=>{
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
const $5fd54e9316d0585a$var$spliceNewElementsIntoPrevious = (current, previous)=>{
    const splicedChildren = previous.concat([]);
    const previousMap = $5fd54e9316d0585a$var$childrenToObj(previous);
    for(let i = 0; i < current.length; i++){
        const child = current[i];
        const childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
const $5fd54e9316d0585a$var$childrenToObj = (children)=>{
    return children.reduce((acc, child)=>{
        acc[child.key] = child;
        return acc;
    }, {});
};
const $5fd54e9316d0585a$var$getMissingKeys = (current, previous)=>{
    const currentMapKeys = new Set(current.map((child)=>child.key));
    const missing = new Set();
    for(let i = 0; i < previous.length; i++){
        const element = previous[i];
        const key = element.key;
        if (!currentMapKeys.has(key)) missing.add(key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $5fd54e9316d0585a$var$ExitingPersistence = /*#__PURE__*/ (0, $5uXOq.memo)(({ appear: appear = false, children: children, exitThenEnter: exitThenEnter })=>{
    const [stateChildren, setChildren] = (0, $5uXOq.useState)([
        null,
        children
    ]);
    const [exitingChildren, setExitingChildren] = (0, $5uXOq.useState)([]);
    const [defaultContext, setDefaultContext] = (0, $5uXOq.useState)(()=>({
            appear: appear,
            isExiting: false
        }));
    (0, $5uXOq.useEffect)(()=>{
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $eXGNC.isReducedMotion)() && !(0, $fHpHg.fg)('platform_design_system_motion_on_finish_fix')) /**
			 * We still want to use the `ExitingPersistence` with reduced motion,
			 * otherwise the exiting `onFinish` is not called.
			 */ return children;
    /**
		 * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
		 * useState is mocked to return a boolean value.
		 */ if (typeof stateChildren === 'boolean') return children;
    const [previousChildren, currentChildren] = stateChildren;
    const previous = $5fd54e9316d0585a$var$childrenToArray(previousChildren);
    const current = $5fd54e9316d0585a$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    const missingKeys = $5fd54e9316d0585a$var$getMissingKeys(current, previous);
    const isSomeChildRemoved = !!missingKeys.size;
    let visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $5fd54e9316d0585a$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            const nextExitingChildren = visibleChildren.filter((child)=>missingKeys.has(child.key));
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map((child)=>{
        const isExiting = missingKeys.has(child.key);
        return $5fd54e9316d0585a$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? ()=>{
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map((child)=>$5fd54e9316d0585a$var$wrapChildWithContextProvider(child, defaultContext));
    return visibleChildren;
});
const $5fd54e9316d0585a$export$3b6f38abbdcbd000 = ()=>{
    return (0, $5uXOq.useContext)($5fd54e9316d0585a$var$ExitingContext);
};
$5fd54e9316d0585a$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $5fd54e9316d0585a$export$2e2bcd8739ae039 = $5fd54e9316d0585a$var$ExitingPersistence;

});
parcelRegister("eXGNC", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", () => $e446c0f579725438$export$b7baf7667a68d87c);
$parcel$export(module.exports, "useIsReducedMotion", () => $e446c0f579725438$export$c537e63161742ce3);
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", () => $e446c0f579725438$export$f0f789643ba5a83c);
$parcel$export(module.exports, "prefersReducedMotion", () => $e446c0f579725438$export$ff7706047246b98b);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");
const $e446c0f579725438$var$isMatchMediaAvailable = ()=>typeof window !== 'undefined' && 'matchMedia' in window;
const $e446c0f579725438$export$b7baf7667a68d87c = ()=>{
    if (!$e446c0f579725438$var$isMatchMediaAvailable()) return false;
    const { matches: matches } = window.matchMedia('(prefers-reduced-motion: reduce)');
    return matches;
};
const $e446c0f579725438$export$c537e63161742ce3 = ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $5uXOq.useState)($e446c0f579725438$export$b7baf7667a68d87c);
    (0, $5uXOq.useEffect)(()=>{
        if (!$e446c0f579725438$var$isMatchMediaAvailable()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $cBeZP.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
const $e446c0f579725438$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
const $e446c0f579725438$export$ff7706047246b98b = ()=>$e446c0f579725438$export$f0f789643ba5a83c;

});


parcelRegister("3aB43", function(module, exports) {

$parcel$export(module.exports, "default", () => $74e3cdd8c7e50ccf$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gMXex = parcelRequire("gMXex");
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ const $74e3cdd8c7e50ccf$var$SlideIn = ({ children: children, enterFrom: enterFrom, exitTo: exitTo, fade: fade = 'none', duration: duration = 'medium', isPaused: isPaused, onFinish: onFinish, animationTimingFunction: animationTimingFunction = 'ease-out', animationTimingFunctionExiting: animationTimingFunctionExiting = 'ease-in' })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gMXex.default), {
        duration: duration,
        enteringAnimation: `slide-in-from-${enterFrom}`,
        exitingAnimation: `slide-out-from-${exitTo || enterFrom}`,
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish,
        children: children
    });
};
var $74e3cdd8c7e50ccf$export$2e2bcd8739ae039 = $74e3cdd8c7e50ccf$var$SlideIn;

});
parcelRegister("gMXex", function(module, exports) {

$parcel$export(module.exports, "default", () => $97942232f697e400$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");

var $eXGNC = parcelRequire("eXGNC");

var $471WD = parcelRequire("471WD");

var $3BHtG = parcelRequire("3BHtG");

var $7xhdA = parcelRequire("7xhdA");

var $EJBVS = parcelRequire("EJBVS");
const $97942232f697e400$var$zoomIn = null;
const $97942232f697e400$var$zoomOut = null;
const $97942232f697e400$var$fadeIn = null;
const $97942232f697e400$var$fadeOut = null;
const $97942232f697e400$var$fadeInFromTop = null;
const $97942232f697e400$var$fadeOutFromTop = null;
const $97942232f697e400$var$fadeInFromLeft = null;
const $97942232f697e400$var$fadeOutFromLeft = null;
const $97942232f697e400$var$fadeInFromBottom = null;
const $97942232f697e400$var$fadeOutFromBottom = null;
const $97942232f697e400$var$fadeInFromRight = null;
const $97942232f697e400$var$fadeOutFromRight = null;
const $97942232f697e400$var$fadeInFromTopConstant = null;
const $97942232f697e400$var$fadeOutFromTopConstant = null;
const $97942232f697e400$var$fadeInFromLeftConstant = null;
const $97942232f697e400$var$fadeOutFromLeftConstant = null;
const $97942232f697e400$var$fadeInFromBottomConstant = null;
const $97942232f697e400$var$fadeOutFromBottomConstant = null;
const $97942232f697e400$var$fadeInFromRightConstant = null;
const $97942232f697e400$var$fadeOutFromRightConstant = null;
const $97942232f697e400$var$slideInFromTop = null;
const $97942232f697e400$var$slideOutFromTop = null;
const $97942232f697e400$var$slideInFromRight = null;
const $97942232f697e400$var$slideOutFromRight = null;
const $97942232f697e400$var$slideInFromBottom = null;
const $97942232f697e400$var$slideOutFromBottom = null;
const $97942232f697e400$var$slideInFromLeft = null;
const $97942232f697e400$var$slideOutFromLeft = null;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ const $97942232f697e400$var$EnteringMotion = ({ children: children, animationTimingFunction: animationTimingFunction, animationTimingFunctionExiting: animationTimingFunctionExiting = animationTimingFunction, enteringAnimation: enteringAnimation, exitingAnimation: exitingAnimation = enteringAnimation, isPaused: isPaused, onFinish: onFinishMotion, duration: duration = 'large' })=>{
    const staggered = (0, $EJBVS.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $7xhdA.useExitingPersistence)();
    const setTimeout = (0, $3BHtG.useSetTimeout)();
    const paused = isPaused || !staggered.isReady;
    const delay = isExiting ? 0 : staggered.delay;
    const state = isExiting ? 'exiting' : 'entering';
    const [hasAnimationStyles, setHasAnimationStyles] = (0, $5uXOq.useState)(appear);
    (0, $5uXOq.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ const onAnimationEnd = ()=>{
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished?.();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion?.(state);
        };
        if ((0, $eXGNC.isReducedMotion)() && (0, $fHpHg.fg)('platform_design_system_motion_on_finish_fix')) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $471WD.exitingDurations)[duration] : (0, $471WD.durations)[duration] + delay);
        return ()=>{
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $bwpsq.default)([
            (0, $bwpsq.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $bwpsq.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $bwpsq.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $bwpsq.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $bwpsq.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $bwpsq.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $bwpsq.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $bwpsq.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $bwpsq.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $bwpsq.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $bwpsq.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $bwpsq.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $bwpsq.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $bwpsq.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $bwpsq.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $bwpsq.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $bwpsq.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $bwpsq.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $bwpsq.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $bwpsq.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $bwpsq.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $bwpsq.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $bwpsq.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $bwpsq.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $bwpsq.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $bwpsq.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $bwpsq.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $bwpsq.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $bwpsq.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $bwpsq.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $bwpsq.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $bwpsq.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $bwpsq.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $bwpsq.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $bwpsq.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $bwpsq.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $bwpsq.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $bwpsq.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $bwpsq.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $bwpsq.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $bwpsq.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $bwpsq.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $bwpsq.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $bwpsq.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $bwpsq.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: `${delay}ms`
        }
    }, state);
};
var $97942232f697e400$export$2e2bcd8739ae039 = $97942232f697e400$var$EnteringMotion;

});
parcelRegister("471WD", function(module, exports) {

$parcel$export(module.exports, "durations", () => $31d05887bc1275b4$export$38b928a7167ce124);
$parcel$export(module.exports, "exitingDurations", () => $31d05887bc1275b4$export$30fa1a2e62ae150c);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ const $31d05887bc1275b4$export$368bacef0dacbe05 = 25;
const $31d05887bc1275b4$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ const $31d05887bc1275b4$var$EXITING_MOTION_MULTIPLIER = 0.5;
const $31d05887bc1275b4$export$30fa1a2e62ae150c = {
    none: $31d05887bc1275b4$export$38b928a7167ce124.none,
    small: $31d05887bc1275b4$export$38b928a7167ce124.small * $31d05887bc1275b4$var$EXITING_MOTION_MULTIPLIER,
    medium: $31d05887bc1275b4$export$38b928a7167ce124.medium * $31d05887bc1275b4$var$EXITING_MOTION_MULTIPLIER,
    large: $31d05887bc1275b4$export$38b928a7167ce124.large * $31d05887bc1275b4$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("3BHtG", function(module, exports) {

$parcel$export(module.exports, "useRequestAnimationFrame", () => $3a62f18980ef0bce$export$1775f27e7c8051ca);
$parcel$export(module.exports, "useSetTimeout", () => $3a62f18980ef0bce$export$4f34107a2b00f39c);

var $5uXOq = parcelRequire("5uXOq");
const $3a62f18980ef0bce$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $3a62f18980ef0bce$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $5uXOq.useRef)([]);
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $3a62f18980ef0bce$var$getHookDeps(opts));
    return (0, $5uXOq.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
const $3a62f18980ef0bce$export$4f34107a2b00f39c = (opts = {
    cleanup: 'unmount'
})=>{
    const timeouts = (0, $5uXOq.useRef)([]);
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            if (timeouts.current.length) {
                timeouts.current.forEach((id)=>clearTimeout(id));
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $3a62f18980ef0bce$var$getHookDeps(opts));
    return (0, $5uXOq.useCallback)((handler, timeout, ...args)=>{
        const id = setTimeout(()=>{
            timeouts.current = timeouts.current.filter((timeoutId)=>timeoutId !== id);
            handler();
        }, timeout, ...args);
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("EJBVS", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", () => $d84e7ada9fff4c96$export$25c7213fc07ec080);
$parcel$export(module.exports, "default", () => $d84e7ada9fff4c96$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bKnKN = parcelRequire("bKnKN");

var $fPgUT = parcelRequire("fPgUT");

var $hBXf4 = parcelRequire("hBXf4");
const $d84e7ada9fff4c96$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5uXOq.createContext)(()=>({
        isReady: true,
        delay: 0,
        ref: (0, $bKnKN.default)
    }));
const $d84e7ada9fff4c96$export$25c7213fc07ec080 = ()=>{
    const indentifier = (0, $hBXf4.useUniqueId)();
    const context = (0, $5uXOq.useContext)($d84e7ada9fff4c96$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ const $d84e7ada9fff4c96$var$StaggeredEntrance = ({ children: children, column: column, columns: columns = 'responsive', delayStep: delayStep = 50 })=>{
    const elementRefs = (0, $5uXOq.useRef)([]);
    const indexes = [];
    const [actualColumns, setActualColumns] = (0, $5uXOq.useState)(()=>{
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    });
    (0, $fPgUT.useLayoutEffect)(()=>{
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            let currentTop = 0;
            let numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(let i = 0; i < elementRefs.current.length; i++){
                const child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($d84e7ada9fff4c96$var$StaggeredEntranceContext.Provider, {
        value: (id)=>{
            if (!indexes.includes(id)) indexes.push(id);
            const isReady = actualColumns > 0;
            const index = indexes.indexOf(id);
            const currentColumn = column || index % actualColumns;
            const currentRow = Math.floor(index / actualColumns);
            const distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            const delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: (element)=>elementRefs.current[index] = element
            };
        },
        children: children
    });
};
var $d84e7ada9fff4c96$export$2e2bcd8739ae039 = $d84e7ada9fff4c96$var$StaggeredEntrance;

});
parcelRegister("fPgUT", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $0bc2efdb51475f6f$export$e5c5a5f917a5871c);

var $5uXOq = parcelRequire("5uXOq");
const $0bc2efdb51475f6f$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5uXOq.useEffect) : (0, $5uXOq.useLayoutEffect);

});

parcelRegister("hBXf4", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", () => $909a5b025879b4a6$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5uXOq = parcelRequire("5uXOq");
function $909a5b025879b4a6$export$c485849f2e393253() {
    const identifier = (0, $5uXOq.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("5g2iQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $be041be15d4b7c03$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $ejjOh = parcelRequire("ejjOh");

var $fLA2F = parcelRequire("fLA2F");

var $4BIwF = parcelRequire("4BIwF");

var $8zgmI = parcelRequire("8zgmI");
function $be041be15d4b7c03$export$2e2bcd8739ae039({ zIndex: zIndex = 0, children: children, mountStrategy: mountStrategy = 'effect' }) {
    const isSubsequentRender = (0, $4BIwF.default)(mountStrategy);
    (0, $8zgmI.default)(zIndex);
    return !(0, $fHpHg.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ejjOh.default), {
        zIndex: zIndex,
        children: children
    }) : null : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fLA2F.default), {
        zIndex: zIndex,
        children: children
    });
}

});
parcelRegister("ejjOh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d92baf69d0c90ab7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $8dkxI = parcelRequire("8dkxI");
function $d92baf69d0c90ab7$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const container = (0, $5uXOq.useMemo)(()=>(0, $8dkxI.createContainer)(zIndex), [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $8dkxI.appendPortalContainerIfNotAppended)(container);
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            (0, $8dkxI.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $7nsd3.createPortal)(children, container);
}

});
parcelRegister("8dkxI", function(module, exports) {

$parcel$export(module.exports, "createContainer", () => $9ced7c49a1987448$export$26ae5ca175b4ec5a);
$parcel$export(module.exports, "removePortalContainer", () => $9ced7c49a1987448$export$da99f98bf3fe55b3);
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $9ced7c49a1987448$export$c582005add11e141);
$parcel$export(module.exports, "createAtlaskitPortal", () => $9ced7c49a1987448$export$fef014d7cef9e543);
$parcel$export(module.exports, "createPortalParent", () => $9ced7c49a1987448$export$95029ca7aca2989e);

const $9ced7c49a1987448$export$26ae5ca175b4ec5a = (zIndex)=>{
    const container = document.createElement('div');
    container.className = (0, $0b39752fc2bc7c2a$export$13f57c02915787b3);
    container.style.zIndex = `${zIndex}`;
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ const $9ced7c49a1987448$var$getBody = ()=>{
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ const $9ced7c49a1987448$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $0b39752fc2bc7c2a$export$72f415121273627e));
    if (!parentElement) {
        const parent = document.createElement('div');
        parent.className = (0, $0b39752fc2bc7c2a$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        $9ced7c49a1987448$var$getBody()?.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $9ced7c49a1987448$export$da99f98bf3fe55b3 = (container)=>{
    $9ced7c49a1987448$var$getPortalParent().removeChild(container);
};
const $9ced7c49a1987448$export$c582005add11e141 = (container)=>{
    if (!container.parentElement) $9ced7c49a1987448$var$getPortalParent().appendChild(container);
};
const $9ced7c49a1987448$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $9ced7c49a1987448$export$fef014d7cef9e543 = (zIndex)=>{
    //atlaskit-portal div
    if ($9ced7c49a1987448$var$isDocumentDefined()) {
        const atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $0b39752fc2bc7c2a$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = `${zIndex}`;
        return atlaskitportal;
    }
};
const $9ced7c49a1987448$export$95029ca7aca2989e = ()=>{
    //atlaskit-portal-container div
    if ($9ced7c49a1987448$var$isDocumentDefined()) {
        const parentElement = document.querySelector((0, $0b39752fc2bc7c2a$export$72f415121273627e));
        if (!parentElement) {
            const parent = document.createElement('div');
            parent.className = (0, $0b39752fc2bc7c2a$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            $9ced7c49a1987448$var$getBody()?.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};

});
const $0b39752fc2bc7c2a$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $0b39752fc2bc7c2a$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $0b39752fc2bc7c2a$export$13f57c02915787b3 = 'atlaskit-portal';



parcelRegister("fLA2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2a8a81329a34801$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $cIcl7 = parcelRequire("cIcl7");

var $8dkxI = parcelRequire("8dkxI");
function $f2a8a81329a34801$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const [atlaskitPortal, setAtlaskitPortal] = (0, $5uXOq.useState)(null);
    (0, $cIcl7.useIsomorphicLayoutEffect)(()=>{
        const tempPortalContainer = (0, $8dkxI.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        const portalParent = (0, $8dkxI.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return ()=>{
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
	 * We wrap portal children with a Suspense boundary because in React 18 concurrent,
	 * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
	 * our portal gets in an infinite loop of rendering.
	 */ const suspendedChildren = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: children
    });
    return atlaskitPortal ? /*#__PURE__*/ (0, $7nsd3.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("cIcl7", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $060b16c80f535f91$export$700979bc83e7db82);

var $5uXOq = parcelRequire("5uXOq");
const $060b16c80f535f91$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5uXOq.useLayoutEffect) : (0, $5uXOq.useEffect);

});


parcelRegister("4BIwF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bfc1b4fcf9c2fc4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cIcl7 = parcelRequire("cIcl7");
const $5bfc1b4fcf9c2fc4$var$useIsSubsequentRender = (mountStrategy)=>{
    const [isSubsequentRender, setIsSubsequentRender] = (0, $5uXOq.useState)(false);
    const [useMountEffect] = (0, $5uXOq.useState)(()=>mountStrategy === 'layoutEffect' ? (0, $cIcl7.useIsomorphicLayoutEffect) : (0, $5uXOq.useEffect));
    useMountEffect(()=>{
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $5bfc1b4fcf9c2fc4$export$2e2bcd8739ae039 = $5bfc1b4fcf9c2fc4$var$useIsSubsequentRender;

});

parcelRegister("8zgmI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3c4f2149567bf4d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $aZcKS = parcelRequire("aZcKS");
const $f3c4f2149567bf4d$var$useFirePortalEvent = (zIndex)=>{
    const zIndexNumber = Number(zIndex);
    (0, $5uXOq.useEffect)(()=>{
        (0, $aZcKS.default)((0, $6389428f3f803f5f$export$ed5835cc67e87f72), zIndexNumber);
        return ()=>{
            (0, $aZcKS.default)((0, $6389428f3f803f5f$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $f3c4f2149567bf4d$export$2e2bcd8739ae039 = $f3c4f2149567bf4d$var$useFirePortalEvent;

});
const $6389428f3f803f5f$export$ed5835cc67e87f72 = 'akPortalMount';
const $6389428f3f803f5f$export$80816bd900e5bd00 = 'akPortalUnmount';

parcelRegister("aZcKS", function(module, exports) {

$parcel$export(module.exports, "default", () => $04d46f069ffac525$export$2e2bcd8739ae039);
const $04d46f069ffac525$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ const $04d46f069ffac525$var$getLayerName = (zIndex)=>{
    return $04d46f069ffac525$var$zIndexToName.hasOwnProperty(zIndex) ? $04d46f069ffac525$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ const $04d46f069ffac525$var$getEvent = (eventName, zIndex)=>{
    const detail = {
        layer: $04d46f069ffac525$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $04d46f069ffac525$export$2e2bcd8739ae039(eventName, zIndex) {
    const event = $04d46f069ffac525$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});




parcelRegister("gpVRy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e47308cbfd474060$export$2e2bcd8739ae039);
/* dismiss-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kweMg = parcelRequire("kweMg");

var $8eqvE = parcelRequire("8eqvE");

var $tkOiB = parcelRequire("tkOiB");

var $7rJgC = parcelRequire("7rJgC");

var $2qWOL = parcelRequire("2qWOL");
const $e47308cbfd474060$var$styles = {
    button: "_16jlidpf _1o9zidpf _i0dl1wug _1dqoglyw _1e0c1txw _1bsb1tcg _4t3i1tcg _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _4cvr1h6o _1bah1h6o _80omtlke _o5721q9c"
};
const $e47308cbfd474060$var$DismissButtonComponent = ({ appearance: appearance, onClick: onClick, isBold: isBold, isExpanded: isExpanded, testId: testId })=>{
    let ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($kweMg)));
    let buttonLabel = 'Dismiss';
    let size = 'small';
    let buttonTestId = testId && `${testId}-dismiss`;
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($tkOiB))) : (0, (/*@__PURE__*/$parcel$interopDefault($8eqvE)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        size = 'medium';
        buttonTestId = testId && `${testId}-toggle`;
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
        xcss: $e47308cbfd474060$var$styles.button,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            background: 'none'
        },
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId,
        "aria-label": buttonLabel,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(ButtonIcon, {
            label: "",
            LEGACY_size: size,
            LEGACY_primaryColor: (0, $2qWOL.flagTextColorToken)[appearance],
            color: (0, $2qWOL.flagTextColorToken)[appearance]
        })
    });
};
const $e47308cbfd474060$var$DismissButton = /*#__PURE__*/ (0, $5uXOq.memo)($e47308cbfd474060$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e47308cbfd474060$export$2e2bcd8739ae039 = $e47308cbfd474060$var$DismissButton;

});
parcelRegister("kweMg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e25fa526c0658720d6f2766d6bdbde06>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef02424fceea31b2$var$_react = $ef02424fceea31b2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ef02424fceea31b2$var$_close = $ef02424fceea31b2$var$_interopRequireDefault((parcelRequire("eh9vz")));

var $ef02424fceea31b2$var$_cross = $ef02424fceea31b2$var$_interopRequireDefault((parcelRequire("goMg1")));
function $ef02424fceea31b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef02424fceea31b2$var$CloseIcon = (props)=>/*#__PURE__*/ $ef02424fceea31b2$var$_react.default.createElement($ef02424fceea31b2$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $ef02424fceea31b2$var$_cross.default
    }, props));
$ef02424fceea31b2$var$CloseIcon.Name = 'CloseIconMigration';
var $ef02424fceea31b2$var$_default = module.exports.default = $ef02424fceea31b2$var$CloseIcon;

});

parcelRegister("8eqvE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d03c6653983b99c648f0774c0bc3810c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5fe431bf0fb9e021$var$_react = $5fe431bf0fb9e021$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5fe431bf0fb9e021$var$_chevronDown = $5fe431bf0fb9e021$var$_interopRequireDefault((parcelRequire("jVpd1")));

var $5fe431bf0fb9e021$var$_chevronDown2 = $5fe431bf0fb9e021$var$_interopRequireDefault((parcelRequire("dcVSO")));
function $5fe431bf0fb9e021$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronDownIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5fe431bf0fb9e021$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $5fe431bf0fb9e021$var$_react.default.createElement($5fe431bf0fb9e021$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $5fe431bf0fb9e021$var$_chevronDown2.default
    }, props));
$5fe431bf0fb9e021$var$ChevronDownIcon.Name = 'ChevronDownIconMigration';
var $5fe431bf0fb9e021$var$_default = module.exports.default = $5fe431bf0fb9e021$var$ChevronDownIcon;

});

parcelRegister("tkOiB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c9bd6be3e7327013ae0b836bac300b8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0582da091b0d6633$var$_react = $0582da091b0d6633$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0582da091b0d6633$var$_chevronUp = $0582da091b0d6633$var$_interopRequireDefault((parcelRequire("4V64t")));

var $0582da091b0d6633$var$_chevronUp2 = $0582da091b0d6633$var$_interopRequireDefault((parcelRequire("aB7fx")));
function $0582da091b0d6633$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronUpIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0582da091b0d6633$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $0582da091b0d6633$var$_react.default.createElement($0582da091b0d6633$var$_chevronUp.default, Object.assign({
        LEGACY_fallbackIcon: $0582da091b0d6633$var$_chevronUp2.default
    }, props));
$0582da091b0d6633$var$ChevronUpIcon.Name = 'ChevronUpIconMigration';
var $0582da091b0d6633$var$_default = module.exports.default = $0582da091b0d6633$var$ChevronUpIcon;

});

parcelRegister("7rJgC", function(module, exports) {

$parcel$export(module.exports, "default", () => $45eb5a500c66cf9b$export$2e2bcd8739ae039);
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $eNCZ4 = parcelRequire("eNCZ4");

var $bKnKN = parcelRequire("bKnKN");

var $9ewsv = parcelRequire("9ewsv");

var $kueXD = parcelRequire("kueXD");
const $45eb5a500c66cf9b$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
}; /**
    * __Pressable__
    *
    * A primitive for building custom buttons.
    *
    * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
    * - [Code](https://atlassian.design/components/primitives/pressable/code)
    * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
    */ 
const $45eb5a500c66cf9b$var$Pressable = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $bKnKN.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $5uXOq.useContext)((0, $9ewsv.default));
    const handleClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kueXD.default // @ts-expect-error we don't allow `button` on Focusable for makers as they should use Pressable instead
    ), {
        as: "button" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- TODO: Properly type this and allow pass-through if we can determine the type
        ,
        style: style,
        ...safeHtmlAttributes,
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $DEWI6.cx)($45eb5a500c66cf9b$var$styles.root, isDisabled && $45eb5a500c66cf9b$var$styles.disabled, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
});
var $45eb5a500c66cf9b$export$2e2bcd8739ae039 = $45eb5a500c66cf9b$var$Pressable;

});
parcelRegister("kueXD", function(module, exports) {

$parcel$export(module.exports, "default", () => $df50242ae21b6a00$export$2e2bcd8739ae039);
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $df50242ae21b6a00$var$focusRingStyles = null;
const $df50242ae21b6a00$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ const $df50242ae21b6a00$var$Focusable = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'button', children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ...safeHtmlAttributes,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $bwpsq.default)([
            "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah311pw _2mwq11pw",
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        "data-testid": testId,
        children: children
    });
});
var $df50242ae21b6a00$export$2e2bcd8739ae039 = $df50242ae21b6a00$var$Focusable;

});



parcelRegister("9fMm1", function(module, exports) {

$parcel$export(module.exports, "default", () => $30409f0b2c86392a$export$2e2bcd8739ae039);
/* expander.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7xhdA = parcelRequire("7xhdA");
var $geBdj = parcelRequire("geBdj");

var $5sRpy = parcelRequire("5sRpy");
var $gOkqF = parcelRequire("gOkqF");
const $30409f0b2c86392a$var$styles = {
    expander: "_1bsb1osq",
    container: "_v5641xzp"
};
const $30409f0b2c86392a$var$Expander = ({ children: children, isExpanded: isExpanded, testId: testId })=>{
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $30409f0b2c86392a$var$styles.expander,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && `${testId}-expander`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7xhdA.default), {
            appear: true,
            children: isExpanded && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $geBdj.default), {
                children: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                        xcss: $30409f0b2c86392a$var$styles.container,
                        ...props,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gOkqF.default), {
                            space: "space.100",
                            children: children
                        })
                    })
            })
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$30409f0b2c86392a$export$2e2bcd8739ae039 = $30409f0b2c86392a$var$Expander;

});
parcelRegister("geBdj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a840c69e028813fd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gMXex = parcelRequire("gMXex");
const $a840c69e028813fd$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $a840c69e028813fd$var$FadeIn = ({ children: children, duration: duration = 'large', entranceDirection: entranceDirection, exitDirection: exitDirection, distance: distance = 'proportional', onFinish: onFinish, isPaused: isPaused })=>{
    const invertedEntranceDirection = entranceDirection !== undefined ? $a840c69e028813fd$var$invertedDirection[entranceDirection] : undefined;
    const isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? `fade-out-from-${exitDirection || invertedEntranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-out';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gMXex.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? `fade-in-from-${entranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused,
        children: children
    });
};
var $a840c69e028813fd$export$2e2bcd8739ae039 = $a840c69e028813fd$var$FadeIn;

});



parcelRegister("1D5Rp", function(module, exports) {

$parcel$export(module.exports, "default", () => $bce16b6409e00175$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $bKnKN = parcelRequire("bKnKN");

var $9WdAg = parcelRequire("9WdAg");

var $5Xt64 = parcelRequire("5Xt64");
const $bce16b6409e00175$var$packageName = "platform-pkg";
const $bce16b6409e00175$var$packageVersion = "0.0.0-use.local";
const $bce16b6409e00175$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ const $bce16b6409e00175$var$AutoDismissFlag = (props)=>{
    const { id: id, analyticsContext: analyticsContext, onDismissed: onDismissedProp = (0, $bKnKN.default) } = props;
    const autoDismissTimer = (0, $5uXOq.useRef)(null);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $5Xt64.useFlagGroup)();
    const onDismissed = (0, $5uXOq.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const onDismissedAnalytics = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName: $bce16b6409e00175$var$packageName,
        packageVersion: $bce16b6409e00175$var$packageVersion
    });
    const isAutoDismissAllowed = isDismissAllowed && onDismissed;
    const dismissFlag = (0, $5uXOq.useCallback)(()=>{
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    const stopAutoDismissTimer = (0, $5uXOq.useCallback)(()=>{
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    const startAutoDismissTimer = (0, $5uXOq.useCallback)(()=>{
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, $bce16b6409e00175$export$66c3d409977b5615 * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed
    ]);
    (0, $5uXOq.useEffect)(()=>{
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9WdAg.default), {
        ...props,
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    });
};
var $bce16b6409e00175$export$2e2bcd8739ae039 = $bce16b6409e00175$var$AutoDismissFlag;

});

parcelRegister("7ndW8", function(module, exports) {

$parcel$export(module.exports, "useFlags", () => $704a82c52db5c9e1$export$2879604e6aec4ab);
$parcel$export(module.exports, "FlagsProvider", () => $704a82c52db5c9e1$export$a4270ab432ac8a58);
$parcel$export(module.exports, "withFlagsProvider", () => $704a82c52db5c9e1$export$7b676815c264eaf3);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1D5Rp = parcelRequire("1D5Rp");

var $9WdAg = parcelRequire("9WdAg");

var $5Xt64 = parcelRequire("5Xt64");
const $704a82c52db5c9e1$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(null);
function $704a82c52db5c9e1$export$2879604e6aec4ab() {
    const api = (0, $5uXOq.useContext)($704a82c52db5c9e1$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $704a82c52db5c9e1$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $704a82c52db5c9e1$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $5uXOq.useState)([]);
    const removeFlag = (0, $5uXOq.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $5uXOq.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $704a82c52db5c9e1$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($704a82c52db5c9e1$var$FlagContext.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Xt64.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $1D5Rp.default) : (0, $9WdAg.default);
                    return /*#__PURE__*/ (0, $5uXOq.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}
const $704a82c52db5c9e1$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, $2OMIu.jsx)($704a82c52db5c9e1$export$a4270ab432ac8a58, {
        children: fn()
    });

});


parcelRegister("3JSCE", function(module, exports) {

$parcel$export(module.exports, "Popper", () => (parcelRequire("e5neF")).Popper);
$parcel$export(module.exports, "placements", () => (parcelRequire("8GdE7")).placements);
$parcel$export(module.exports, "Manager", () => (parcelRequire("7Ye64")).Manager);
$parcel$export(module.exports, "Reference", () => (parcelRequire("87gQG")).Reference);

var $8GdE7 = parcelRequire("8GdE7");
var $e5neF = parcelRequire("e5neF");

var $7Ye64 = parcelRequire("7Ye64");
var $87gQG = parcelRequire("87gQG");

});
parcelRegister("8GdE7", function(module, exports) {

$parcel$export(module.exports, "top", () => $651cd4c8221ce0b0$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $651cd4c8221ce0b0$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $651cd4c8221ce0b0$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $651cd4c8221ce0b0$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $651cd4c8221ce0b0$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $651cd4c8221ce0b0$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $651cd4c8221ce0b0$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $651cd4c8221ce0b0$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $651cd4c8221ce0b0$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $651cd4c8221ce0b0$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $651cd4c8221ce0b0$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $651cd4c8221ce0b0$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $651cd4c8221ce0b0$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $651cd4c8221ce0b0$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $651cd4c8221ce0b0$export$d087d3878fdf71d5);
var $651cd4c8221ce0b0$export$1e95b668f3b82d = 'top';
var $651cd4c8221ce0b0$export$40e543e69a8b3fbb = 'bottom';
var $651cd4c8221ce0b0$export$79ffe56a765070d2 = 'right';
var $651cd4c8221ce0b0$export$eabcd2c8791e7bf4 = 'left';
var $651cd4c8221ce0b0$export$dfb5619354ba860 = 'auto';
var $651cd4c8221ce0b0$export$aec2ce47c367b8c3 = [
    $651cd4c8221ce0b0$export$1e95b668f3b82d,
    $651cd4c8221ce0b0$export$40e543e69a8b3fbb,
    $651cd4c8221ce0b0$export$79ffe56a765070d2,
    $651cd4c8221ce0b0$export$eabcd2c8791e7bf4
];
var $651cd4c8221ce0b0$export$b3571188c770cc5a = 'start';
var $651cd4c8221ce0b0$export$bd5df0f255a350f8 = 'end';
var $651cd4c8221ce0b0$export$390fd549c5303b4d = 'clippingParents';
var $651cd4c8221ce0b0$export$d7b7311ec04a3e8f = 'viewport';
var $651cd4c8221ce0b0$export$ae5ab1c730825774 = 'popper';
var $651cd4c8221ce0b0$export$ca50aac9f3ba507f = 'reference';
var $651cd4c8221ce0b0$export$368f9a87e87fa4e1 = /*#__PURE__*/ $651cd4c8221ce0b0$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $651cd4c8221ce0b0$export$b3571188c770cc5a,
        placement + "-" + $651cd4c8221ce0b0$export$bd5df0f255a350f8
    ]);
}, []);
var $651cd4c8221ce0b0$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($651cd4c8221ce0b0$export$aec2ce47c367b8c3, [
    $651cd4c8221ce0b0$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $651cd4c8221ce0b0$export$b3571188c770cc5a,
        placement + "-" + $651cd4c8221ce0b0$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $651cd4c8221ce0b0$export$421679a7c3d56e = 'beforeRead';
var $651cd4c8221ce0b0$export$aafa59e2e03f2942 = 'read';
var $651cd4c8221ce0b0$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $651cd4c8221ce0b0$export$c65e99957a05207c = 'beforeMain';
var $651cd4c8221ce0b0$export$f22da7240b7add18 = 'main';
var $651cd4c8221ce0b0$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $651cd4c8221ce0b0$export$8d4d2d70e7d46032 = 'beforeWrite';
var $651cd4c8221ce0b0$export$68d8715fc104d294 = 'write';
var $651cd4c8221ce0b0$export$70a6e5159acce2e6 = 'afterWrite';
var $651cd4c8221ce0b0$export$d087d3878fdf71d5 = [
    $651cd4c8221ce0b0$export$421679a7c3d56e,
    $651cd4c8221ce0b0$export$aafa59e2e03f2942,
    $651cd4c8221ce0b0$export$6964f6c886723980,
    $651cd4c8221ce0b0$export$c65e99957a05207c,
    $651cd4c8221ce0b0$export$f22da7240b7add18,
    $651cd4c8221ce0b0$export$bab79516f2d662fe,
    $651cd4c8221ce0b0$export$8d4d2d70e7d46032,
    $651cd4c8221ce0b0$export$68d8715fc104d294,
    $651cd4c8221ce0b0$export$70a6e5159acce2e6
];

});

parcelRegister("e5neF", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $9a473844273c7dd3$export$badac9ada3a0bdf9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bOQ7p = parcelRequire("bOQ7p");

var $ev6eB = parcelRequire("ev6eB");

var $8GdE7 = parcelRequire("8GdE7");
const $9a473844273c7dd3$var$viewportPadding = 5;
const $9a473844273c7dd3$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $9a473844273c7dd3$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $9a473844273c7dd3$var$defaultChildrenFn() {
    return null;
}
const $9a473844273c7dd3$var$defaultOffset = [
    0,
    8
];
function $9a473844273c7dd3$export$badac9ada3a0bdf9({ children: children = $9a473844273c7dd3$var$defaultChildrenFn, offset: offset = $9a473844273c7dd3$var$defaultOffset, placement: placement = 'bottom-start', referenceElement: referenceElement, modifiers: modifiers, strategy: strategy = 'fixed', shouldFitViewport: shouldFitViewport = false }) {
    const [offsetX, offsetY] = offset;
    const internalModifiers = (0, $5uXOq.useMemo)(()=>{
        const preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $9a473844273c7dd3$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        const offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        const maxSizeModifiers = shouldFitViewport ? (0, $ev6eB.getMaxSizeModifiers)({
            viewportPadding: $9a473844273c7dd3$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [
            ...$9a473844273c7dd3$var$constantModifiers,
            preventOverflowModifier,
            offsetModifier,
            ...maxSizeModifiers
        ];
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    const mergedModifiers = (0, $5uXOq.useMemo)(()=>{
        if (modifiers == null) return internalModifiers;
        return [
            ...internalModifiers,
            ...modifiers
        ];
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bOQ7p.Popper), {
        // @ts-expect-error - No overload matches this call
        // This error was introduced after upgrading to TypeScript 5
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement,
        children: children
    });
}

});
parcelRegister("bOQ7p", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $89accadc82131cf4$export$badac9ada3a0bdf9);

var $5uXOq = parcelRequire("5uXOq");

var $7Ye64 = parcelRequire("7Ye64");

var $63Vjo = parcelRequire("63Vjo");

var $eGIzd = parcelRequire("eGIzd");
var $89accadc82131cf4$var$NOOP = function NOOP() {
    return void 0;
};
var $89accadc82131cf4$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $89accadc82131cf4$var$EMPTY_MODIFIERS = [];
function $89accadc82131cf4$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $89accadc82131cf4$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $5uXOq.useContext((0, $7Ye64.ManagerReferenceNodeContext));
    var _React$useState = $5uXOq.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $5uXOq.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $5uXOq.useEffect(function() {
        (0, $63Vjo.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $5uXOq.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $eGIzd.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $5uXOq.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $89accadc82131cf4$var$NOOP,
            update: update || $89accadc82131cf4$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $63Vjo.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("7Ye64", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $5cd9125481fcace7$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $5cd9125481fcace7$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $5cd9125481fcace7$export$d0d38e7dec7a1a61);

var $5uXOq = parcelRequire("5uXOq");
var $5cd9125481fcace7$export$3dbd3405086fec7b = $5uXOq.createContext();
var $5cd9125481fcace7$export$cbabb21c2529b130 = $5uXOq.createContext();
function $5cd9125481fcace7$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $5uXOq.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $5uXOq.useRef(false);
    $5uXOq.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $5uXOq.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $5uXOq.createElement($5cd9125481fcace7$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $5uXOq.createElement($5cd9125481fcace7$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("63Vjo", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $469f7ace8b2f6b22$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $469f7ace8b2f6b22$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $469f7ace8b2f6b22$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $469f7ace8b2f6b22$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $469f7ace8b2f6b22$export$700979bc83e7db82);

var $5uXOq = parcelRequire("5uXOq");
var $469f7ace8b2f6b22$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $469f7ace8b2f6b22$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $469f7ace8b2f6b22$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $469f7ace8b2f6b22$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $469f7ace8b2f6b22$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $469f7ace8b2f6b22$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;

});

parcelRegister("eGIzd", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $ab178efce815ae0e$export$f4d5bf230a36dd6e);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $cTHFq = parcelRequire("cTHFq");

var $lHrkK = parcelRequire("lHrkK");

var $63Vjo = parcelRequire("63Vjo");
var $ab178efce815ae0e$var$EMPTY_MODIFIERS = [];
var $ab178efce815ae0e$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $5uXOq.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $ab178efce815ae0e$var$EMPTY_MODIFIERS
    };
    var _React$useState = $5uXOq.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $5uXOq.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $7nsd3.flushSync(function() {
                    setState({
                        styles: (0, $63Vjo.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $63Vjo.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $5uXOq.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($lHrkK)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $5uXOq.useRef();
    (0, $63Vjo.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $63Vjo.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $cTHFq.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("cTHFq", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $963c7e75c41c8bad$export$8f7491d57c8f97a9);

var $8Ya9G = parcelRequire("8Ya9G");

var $iOG84 = parcelRequire("iOG84");

var $irEfP = parcelRequire("irEfP");

var $9gf86 = parcelRequire("9gf86");

var $46UnA = parcelRequire("46UnA");

var $d9lip = parcelRequire("d9lip");

var $6xsna = parcelRequire("6xsna");

var $731zC = parcelRequire("731zC");

var $kizE9 = parcelRequire("kizE9");

var $d5FpK = parcelRequire("d5FpK");


var $963c7e75c41c8bad$export$d34966752335dd47 = [
    (0, $iOG84.default),
    (0, $irEfP.default),
    (0, $9gf86.default),
    (0, $46UnA.default),
    (0, $d9lip.default),
    (0, $6xsna.default),
    (0, $731zC.default),
    (0, $kizE9.default),
    (0, $d5FpK.default)
];
var $963c7e75c41c8bad$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $8Ya9G.popperGenerator)({
    defaultModifiers: $963c7e75c41c8bad$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("8Ya9G", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $687bcdeb3f700309$export$ed5e13716264f202);

var $l5RXN = parcelRequire("l5RXN");

var $hLRhz = parcelRequire("hLRhz");

var $1q5v2 = parcelRequire("1q5v2");

var $aSOgT = parcelRequire("aSOgT");

var $hKhkC = parcelRequire("hKhkC");

var $hLOYB = parcelRequire("hLOYB");

var $RC7LS = parcelRequire("RC7LS");


var $hjzcP = parcelRequire("hjzcP");
var $687bcdeb3f700309$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $687bcdeb3f700309$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $687bcdeb3f700309$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $687bcdeb3f700309$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $687bcdeb3f700309$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $hjzcP.isElement)(reference) ? (0, $1q5v2.default)(reference) : reference.contextElement ? (0, $1q5v2.default)(reference.contextElement) : [],
                    popper: (0, $1q5v2.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $hKhkC.default)((0, $RC7LS.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$687bcdeb3f700309$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $l5RXN.default)(reference, (0, $aSOgT.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $hLRhz.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $hLOYB.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$687bcdeb3f700309$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $687bcdeb3f700309$export$8f7491d57c8f97a9 = /*#__PURE__*/ $687bcdeb3f700309$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("l5RXN", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5b3ec9add883ca2$export$2e2bcd8739ae039);

var $jQaUq = parcelRequire("jQaUq");

var $iiWYT = parcelRequire("iiWYT");

var $jLehM = parcelRequire("jLehM");

var $hjzcP = parcelRequire("hjzcP");

var $26SzO = parcelRequire("26SzO");

var $49JhL = parcelRequire("49JhL");

var $bDDWu = parcelRequire("bDDWu");

var $kkf18 = parcelRequire("kkf18");
function $f5b3ec9add883ca2$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $kkf18.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $kkf18.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $f5b3ec9add883ca2$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $hjzcP.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $hjzcP.isHTMLElement)(offsetParent) && $f5b3ec9add883ca2$var$isElementScaled(offsetParent);
    var documentElement = (0, $49JhL.default)(offsetParent);
    var rect = (0, $jQaUq.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $jLehM.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $bDDWu.default)(documentElement)) scroll = (0, $iiWYT.default)(offsetParent);
        if ((0, $hjzcP.isHTMLElement)(offsetParent)) {
            offsets = (0, $jQaUq.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $26SzO.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("jQaUq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e71b55fc8806c55e$export$2e2bcd8739ae039);

var $hjzcP = parcelRequire("hjzcP");

var $kkf18 = parcelRequire("kkf18");

var $lps5S = parcelRequire("lps5S");

var $fvlu3 = parcelRequire("fvlu3");
function $e71b55fc8806c55e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $hjzcP.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $kkf18.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $kkf18.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $hjzcP.isElement)(element) ? (0, $lps5S.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $fvlu3.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("hjzcP", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $c9af8533e4d50668$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $c9af8533e4d50668$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $c9af8533e4d50668$export$af51f0f06c0f328a);

var $lps5S = parcelRequire("lps5S");
function $c9af8533e4d50668$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $lps5S.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $c9af8533e4d50668$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $lps5S.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $c9af8533e4d50668$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $lps5S.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("lps5S", function(module, exports) {

$parcel$export(module.exports, "default", () => $f961b99eaa915b94$export$2e2bcd8739ae039);
function $f961b99eaa915b94$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("kkf18", function(module, exports) {

$parcel$export(module.exports, "max", () => $ecc15305df576487$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $ecc15305df576487$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $ecc15305df576487$export$2077e0241d6afd3c);
var $ecc15305df576487$export$8960430cfd85939f = Math.max;
var $ecc15305df576487$export$96ec731ed4dcb222 = Math.min;
var $ecc15305df576487$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("fvlu3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b49a6a76fed2686c$export$2e2bcd8739ae039);

var $6pxtR = parcelRequire("6pxtR");
function $b49a6a76fed2686c$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6pxtR.default)());
}

});
parcelRegister("6pxtR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aaf0c6f24f4fa64$export$2e2bcd8739ae039);
function $4aaf0c6f24f4fa64$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("iiWYT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d537a8dbb0e55e64$export$2e2bcd8739ae039);

var $c5HdC = parcelRequire("c5HdC");

var $lps5S = parcelRequire("lps5S");

var $hjzcP = parcelRequire("hjzcP");

var $dBxNS = parcelRequire("dBxNS");
function $d537a8dbb0e55e64$export$2e2bcd8739ae039(node) {
    if (node === (0, $lps5S.default)(node) || !(0, $hjzcP.isHTMLElement)(node)) return (0, $c5HdC.default)(node);
    else return (0, $dBxNS.default)(node);
}

});
parcelRegister("c5HdC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cd77a013f6ad4f9$export$2e2bcd8739ae039);

var $lps5S = parcelRequire("lps5S");
function $8cd77a013f6ad4f9$export$2e2bcd8739ae039(node) {
    var win = (0, $lps5S.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("dBxNS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e78f3c09d68e1ce$export$2e2bcd8739ae039);
function $9e78f3c09d68e1ce$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("jLehM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e62d7cf1e40c772d$export$2e2bcd8739ae039);
function $e62d7cf1e40c772d$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("26SzO", function(module, exports) {

$parcel$export(module.exports, "default", () => $18967a179b129f42$export$2e2bcd8739ae039);

var $jQaUq = parcelRequire("jQaUq");

var $49JhL = parcelRequire("49JhL");

var $c5HdC = parcelRequire("c5HdC");
function $18967a179b129f42$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $jQaUq.default)((0, $49JhL.default)(element)).left + (0, $c5HdC.default)(element).scrollLeft;
}

});
parcelRegister("49JhL", function(module, exports) {

$parcel$export(module.exports, "default", () => $306b21754451a902$export$2e2bcd8739ae039);

var $hjzcP = parcelRequire("hjzcP");
function $306b21754451a902$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $hjzcP.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("bDDWu", function(module, exports) {

$parcel$export(module.exports, "default", () => $879251f3a88f1bff$export$2e2bcd8739ae039);

var $6YhGB = parcelRequire("6YhGB");
function $879251f3a88f1bff$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $6YhGB.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("6YhGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $513610bf53cbb766$export$2e2bcd8739ae039);

var $lps5S = parcelRequire("lps5S");
function $513610bf53cbb766$export$2e2bcd8739ae039(element) {
    return (0, $lps5S.default)(element).getComputedStyle(element);
}

});



parcelRegister("hLRhz", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf00283c235ca9fc$export$2e2bcd8739ae039);

var $jQaUq = parcelRequire("jQaUq");
function $cf00283c235ca9fc$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $jQaUq.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("1q5v2", function(module, exports) {

$parcel$export(module.exports, "default", () => $108c7c43b18ff6f6$export$2e2bcd8739ae039);

var $essmN = parcelRequire("essmN");

var $gtRKQ = parcelRequire("gtRKQ");

var $lps5S = parcelRequire("lps5S");

var $bDDWu = parcelRequire("bDDWu");
function $108c7c43b18ff6f6$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $essmN.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $lps5S.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $bDDWu.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($108c7c43b18ff6f6$export$2e2bcd8739ae039((0, $gtRKQ.default)(target)));
}

});
parcelRegister("essmN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a869af3e43a41797$export$2e2bcd8739ae039);

var $gtRKQ = parcelRequire("gtRKQ");

var $bDDWu = parcelRequire("bDDWu");

var $jLehM = parcelRequire("jLehM");

var $hjzcP = parcelRequire("hjzcP");
function $a869af3e43a41797$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $jLehM.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $hjzcP.isHTMLElement)(node) && (0, $bDDWu.default)(node)) return node;
    return $a869af3e43a41797$export$2e2bcd8739ae039((0, $gtRKQ.default)(node));
}

});
parcelRegister("gtRKQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bff90d4a14694a52$export$2e2bcd8739ae039);

var $jLehM = parcelRequire("jLehM");

var $49JhL = parcelRequire("49JhL");

var $hjzcP = parcelRequire("hjzcP");
function $bff90d4a14694a52$export$2e2bcd8739ae039(element) {
    if ((0, $jLehM.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $hjzcP.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $49JhL.default)(element) // fallback
    );
}

});



parcelRegister("aSOgT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ec5f169d5ad2c41$export$2e2bcd8739ae039);

var $lps5S = parcelRequire("lps5S");

var $jLehM = parcelRequire("jLehM");

var $6YhGB = parcelRequire("6YhGB");

var $hjzcP = parcelRequire("hjzcP");

var $4uuaf = parcelRequire("4uuaf");

var $gtRKQ = parcelRequire("gtRKQ");

var $6pxtR = parcelRequire("6pxtR");
function $7ec5f169d5ad2c41$var$getTrueOffsetParent(element) {
    if (!(0, $hjzcP.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $6YhGB.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $7ec5f169d5ad2c41$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6pxtR.default)());
    var isIE = /Trident/i.test((0, $6pxtR.default)());
    if (isIE && (0, $hjzcP.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $6YhGB.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $gtRKQ.default)(element);
    if ((0, $hjzcP.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $hjzcP.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $jLehM.default)(currentNode)) < 0){
        var css = (0, $6YhGB.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $7ec5f169d5ad2c41$export$2e2bcd8739ae039(element) {
    var window = (0, $lps5S.default)(element);
    var offsetParent = $7ec5f169d5ad2c41$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $4uuaf.default)(offsetParent) && (0, $6YhGB.default)(offsetParent).position === 'static')offsetParent = $7ec5f169d5ad2c41$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $jLehM.default)(offsetParent) === 'html' || (0, $jLehM.default)(offsetParent) === 'body' && (0, $6YhGB.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $7ec5f169d5ad2c41$var$getContainingBlock(element) || window;
}

});
parcelRegister("4uuaf", function(module, exports) {

$parcel$export(module.exports, "default", () => $34515cc169027727$export$2e2bcd8739ae039);

var $jLehM = parcelRequire("jLehM");
function $34515cc169027727$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $jLehM.default)(element)) >= 0;
}

});


parcelRegister("hKhkC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceb42d421bb1da3a$export$2e2bcd8739ae039);

var $8GdE7 = parcelRequire("8GdE7");
function $ceb42d421bb1da3a$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $ceb42d421bb1da3a$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $ceb42d421bb1da3a$var$order(modifiers); // order based on phase
    return (0, $8GdE7.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("hLOYB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cefe5e4d51f88701$export$2e2bcd8739ae039);
function $cefe5e4d51f88701$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("RC7LS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a12860d4e40e815$export$2e2bcd8739ae039);
function $0a12860d4e40e815$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("iOG84", function(module, exports) {

$parcel$export(module.exports, "default", () => $db2d937dde2a194c$export$2e2bcd8739ae039);

var $lps5S = parcelRequire("lps5S");
var $db2d937dde2a194c$var$passive = {
    passive: true
};
function $db2d937dde2a194c$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $lps5S.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $db2d937dde2a194c$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $db2d937dde2a194c$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $db2d937dde2a194c$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $db2d937dde2a194c$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $db2d937dde2a194c$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $db2d937dde2a194c$var$effect,
    data: {}
};

});

parcelRegister("irEfP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6d9f94947a26289$export$2e2bcd8739ae039);

var $6vreB = parcelRequire("6vreB");
function $d6d9f94947a26289$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $6vreB.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $d6d9f94947a26289$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $d6d9f94947a26289$var$popperOffsets,
    data: {}
};

});
parcelRegister("6vreB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bcac383cb3516bf$export$2e2bcd8739ae039);

var $5lmZP = parcelRequire("5lmZP");

var $fUCnl = parcelRequire("fUCnl");

var $62PBD = parcelRequire("62PBD");

var $8GdE7 = parcelRequire("8GdE7");
function $4bcac383cb3516bf$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $5lmZP.default)(placement) : null;
    var variation = placement ? (0, $fUCnl.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $8GdE7.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $8GdE7.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $8GdE7.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $8GdE7.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $62PBD.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $8GdE7.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $8GdE7.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("5lmZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e40c07709324ee5$export$2e2bcd8739ae039);

function $3e40c07709324ee5$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("fUCnl", function(module, exports) {

$parcel$export(module.exports, "default", () => $b959da9228b16686$export$2e2bcd8739ae039);
function $b959da9228b16686$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("62PBD", function(module, exports) {

$parcel$export(module.exports, "default", () => $466af5d9a5f61e96$export$2e2bcd8739ae039);
function $466af5d9a5f61e96$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("9gf86", function(module, exports) {

$parcel$export(module.exports, "default", () => $6be15819e9cb9e06$export$2e2bcd8739ae039);

var $8GdE7 = parcelRequire("8GdE7");

var $aSOgT = parcelRequire("aSOgT");

var $lps5S = parcelRequire("lps5S");

var $49JhL = parcelRequire("49JhL");

var $6YhGB = parcelRequire("6YhGB");

var $5lmZP = parcelRequire("5lmZP");

var $fUCnl = parcelRequire("fUCnl");

var $kkf18 = parcelRequire("kkf18");
var $6be15819e9cb9e06$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $6be15819e9cb9e06$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $kkf18.round)(x * dpr) / dpr || 0,
        y: (0, $kkf18.round)(y * dpr) / dpr || 0
    };
}
function $6be15819e9cb9e06$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $8GdE7.left);
    var sideY = (0, $8GdE7.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $aSOgT.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $lps5S.default)(popper)) {
            offsetParent = (0, $49JhL.default)(popper);
            if ((0, $6YhGB.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $8GdE7.top) || (placement === (0, $8GdE7.left) || placement === (0, $8GdE7.right)) && variation === (0, $8GdE7.end)) {
            sideY = (0, $8GdE7.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $8GdE7.left) || (placement === (0, $8GdE7.top) || placement === (0, $8GdE7.bottom)) && variation === (0, $8GdE7.end)) {
            sideX = (0, $8GdE7.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $6be15819e9cb9e06$var$unsetSides);
    var _ref4 = roundOffsets === true ? $6be15819e9cb9e06$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $lps5S.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $6be15819e9cb9e06$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $5lmZP.default)(state.placement),
        variation: (0, $fUCnl.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $6be15819e9cb9e06$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $6be15819e9cb9e06$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $6be15819e9cb9e06$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $6be15819e9cb9e06$var$computeStyles,
    data: {}
};

});

parcelRegister("46UnA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe374c0170ca276$export$2e2bcd8739ae039);

var $jLehM = parcelRequire("jLehM");

var $hjzcP = parcelRequire("hjzcP");
// and applies them to the HTMLElements such as popper and arrow
function $2fe374c0170ca276$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $hjzcP.isHTMLElement)(element) || !(0, $jLehM.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $2fe374c0170ca276$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $hjzcP.isHTMLElement)(element) || !(0, $jLehM.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $2fe374c0170ca276$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $2fe374c0170ca276$var$applyStyles,
    effect: $2fe374c0170ca276$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("d9lip", function(module, exports) {

$parcel$export(module.exports, "default", () => $992ca28dbce16f34$export$2e2bcd8739ae039);

var $5lmZP = parcelRequire("5lmZP");

var $8GdE7 = parcelRequire("8GdE7");
function $992ca28dbce16f34$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $5lmZP.default)(placement);
    var invertDistance = [
        (0, $8GdE7.left),
        (0, $8GdE7.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $8GdE7.left),
        (0, $8GdE7.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $992ca28dbce16f34$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $8GdE7.placements).reduce(function(acc, placement) {
        acc[placement] = $992ca28dbce16f34$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $992ca28dbce16f34$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $992ca28dbce16f34$var$offset
};

});

parcelRegister("6xsna", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c2bd557bf5e5cd5$export$2e2bcd8739ae039);

var $hjE9c = parcelRequire("hjE9c");

var $5lmZP = parcelRequire("5lmZP");

var $3byBa = parcelRequire("3byBa");

var $6k8cN = parcelRequire("6k8cN");

var $1XRn8 = parcelRequire("1XRn8");

var $8GdE7 = parcelRequire("8GdE7");

var $fUCnl = parcelRequire("fUCnl");
function $4c2bd557bf5e5cd5$var$getExpandedFallbackPlacements(placement) {
    if ((0, $5lmZP.default)(placement) === (0, $8GdE7.auto)) return [];
    var oppositePlacement = (0, $hjE9c.default)(placement);
    return [
        (0, $3byBa.default)(placement),
        oppositePlacement,
        (0, $3byBa.default)(oppositePlacement)
    ];
}
function $4c2bd557bf5e5cd5$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $5lmZP.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $hjE9c.default)(preferredPlacement)
    ] : $4c2bd557bf5e5cd5$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $5lmZP.default)(placement) === (0, $8GdE7.auto) ? (0, $1XRn8.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $5lmZP.default)(placement);
        var isStartVariation = (0, $fUCnl.default)(placement) === (0, $8GdE7.start);
        var isVertical = [
            (0, $8GdE7.top),
            (0, $8GdE7.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $6k8cN.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $8GdE7.right) : (0, $8GdE7.left) : isStartVariation ? (0, $8GdE7.bottom) : (0, $8GdE7.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $hjE9c.default)(mainVariationSide);
        var altVariationSide = (0, $hjE9c.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $4c2bd557bf5e5cd5$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $4c2bd557bf5e5cd5$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("hjE9c", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9b35a75a47e779d$export$2e2bcd8739ae039);
var $c9b35a75a47e779d$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $c9b35a75a47e779d$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $c9b35a75a47e779d$var$hash[matched];
    });
}

});

parcelRegister("3byBa", function(module, exports) {

$parcel$export(module.exports, "default", () => $251d3cb5e2141b1a$export$2e2bcd8739ae039);
var $251d3cb5e2141b1a$var$hash = {
    start: 'end',
    end: 'start'
};
function $251d3cb5e2141b1a$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $251d3cb5e2141b1a$var$hash[matched];
    });
}

});

parcelRegister("6k8cN", function(module, exports) {

$parcel$export(module.exports, "default", () => $49aaf9c1f8c7220f$export$2e2bcd8739ae039);

var $fbO4y = parcelRequire("fbO4y");

var $49JhL = parcelRequire("49JhL");

var $jQaUq = parcelRequire("jQaUq");

var $6vreB = parcelRequire("6vreB");

var $8VLfW = parcelRequire("8VLfW");

var $8GdE7 = parcelRequire("8GdE7");

var $hjzcP = parcelRequire("hjzcP");

var $5Npj5 = parcelRequire("5Npj5");

var $4DeOL = parcelRequire("4DeOL");
function $49aaf9c1f8c7220f$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $8GdE7.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $8GdE7.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $8GdE7.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $5Npj5.default)(typeof padding !== 'number' ? padding : (0, $4DeOL.default)(padding, (0, $8GdE7.basePlacements)));
    var altContext = elementContext === (0, $8GdE7.popper) ? (0, $8GdE7.reference) : (0, $8GdE7.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $fbO4y.default)((0, $hjzcP.isElement)(element) ? element : element.contextElement || (0, $49JhL.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $jQaUq.default)(state.elements.reference);
    var popperOffsets = (0, $6vreB.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $8VLfW.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $8GdE7.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $8GdE7.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $8GdE7.right),
                (0, $8GdE7.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $8GdE7.top),
                (0, $8GdE7.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("fbO4y", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0eeb96c3f47531b$export$2e2bcd8739ae039);

var $8GdE7 = parcelRequire("8GdE7");

var $aDDfx = parcelRequire("aDDfx");

var $8tx8A = parcelRequire("8tx8A");

var $1q5v2 = parcelRequire("1q5v2");

var $aSOgT = parcelRequire("aSOgT");

var $49JhL = parcelRequire("49JhL");

var $6YhGB = parcelRequire("6YhGB");

var $hjzcP = parcelRequire("hjzcP");

var $jQaUq = parcelRequire("jQaUq");

var $gtRKQ = parcelRequire("gtRKQ");

var $2frIr = parcelRequire("2frIr");

var $jLehM = parcelRequire("jLehM");

var $8VLfW = parcelRequire("8VLfW");

var $kkf18 = parcelRequire("kkf18");
function $b0eeb96c3f47531b$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $jQaUq.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $b0eeb96c3f47531b$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $8GdE7.viewport) ? (0, $8VLfW.default)((0, $aDDfx.default)(element, strategy)) : (0, $hjzcP.isElement)(clippingParent) ? $b0eeb96c3f47531b$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $8VLfW.default)((0, $8tx8A.default)((0, $49JhL.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $b0eeb96c3f47531b$var$getClippingParents(element) {
    var clippingParents = (0, $1q5v2.default)((0, $gtRKQ.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $6YhGB.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $hjzcP.isHTMLElement)(element) ? (0, $aSOgT.default)(element) : element;
    if (!(0, $hjzcP.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $hjzcP.isElement)(clippingParent) && (0, $2frIr.default)(clippingParent, clipperElement) && (0, $jLehM.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $b0eeb96c3f47531b$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $b0eeb96c3f47531b$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $b0eeb96c3f47531b$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $kkf18.max)(rect.top, accRect.top);
        accRect.right = (0, $kkf18.min)(rect.right, accRect.right);
        accRect.bottom = (0, $kkf18.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $kkf18.max)(rect.left, accRect.left);
        return accRect;
    }, $b0eeb96c3f47531b$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("aDDfx", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bebfe0e65855787$export$2e2bcd8739ae039);

var $lps5S = parcelRequire("lps5S");

var $49JhL = parcelRequire("49JhL");

var $26SzO = parcelRequire("26SzO");

var $fvlu3 = parcelRequire("fvlu3");
function $7bebfe0e65855787$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $lps5S.default)(element);
    var html = (0, $49JhL.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $fvlu3.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $26SzO.default)(element),
        y: y
    };
}

});

parcelRegister("8tx8A", function(module, exports) {

$parcel$export(module.exports, "default", () => $62babc96989bff13$export$2e2bcd8739ae039);

var $49JhL = parcelRequire("49JhL");

var $6YhGB = parcelRequire("6YhGB");

var $26SzO = parcelRequire("26SzO");

var $c5HdC = parcelRequire("c5HdC");

var $kkf18 = parcelRequire("kkf18");
function $62babc96989bff13$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $49JhL.default)(element);
    var winScroll = (0, $c5HdC.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $kkf18.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $kkf18.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $26SzO.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $6YhGB.default)(body || html).direction === 'rtl') x += (0, $kkf18.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("2frIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a327b3db27c248b$export$2e2bcd8739ae039);

var $hjzcP = parcelRequire("hjzcP");
function $1a327b3db27c248b$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $hjzcP.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("8VLfW", function(module, exports) {

$parcel$export(module.exports, "default", () => $68084dad87164cca$export$2e2bcd8739ae039);
function $68084dad87164cca$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("5Npj5", function(module, exports) {

$parcel$export(module.exports, "default", () => $438528c54e0b5170$export$2e2bcd8739ae039);

var $dmsgX = parcelRequire("dmsgX");
function $438528c54e0b5170$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $dmsgX.default)(), paddingObject);
}

});
parcelRegister("dmsgX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ba342c6f1ce1ecd$export$2e2bcd8739ae039);
function $9ba342c6f1ce1ecd$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("4DeOL", function(module, exports) {

$parcel$export(module.exports, "default", () => $35f64c74258b8408$export$2e2bcd8739ae039);
function $35f64c74258b8408$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("1XRn8", function(module, exports) {

$parcel$export(module.exports, "default", () => $16e4b3bd282cd23d$export$2e2bcd8739ae039);

var $fUCnl = parcelRequire("fUCnl");

var $8GdE7 = parcelRequire("8GdE7");

var $6k8cN = parcelRequire("6k8cN");

var $5lmZP = parcelRequire("5lmZP");
function $16e4b3bd282cd23d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $8GdE7.placements) : _options$allowedAutoP;
    var variation = (0, $fUCnl.default)(placement);
    var placements = variation ? flipVariations ? (0, $8GdE7.variationPlacements) : (0, $8GdE7.variationPlacements).filter(function(placement) {
        return (0, $fUCnl.default)(placement) === variation;
    }) : (0, $8GdE7.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $6k8cN.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $5lmZP.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("731zC", function(module, exports) {

$parcel$export(module.exports, "default", () => $521a08aaecdfc295$export$2e2bcd8739ae039);

var $8GdE7 = parcelRequire("8GdE7");

var $5lmZP = parcelRequire("5lmZP");

var $62PBD = parcelRequire("62PBD");

var $6CPSz = parcelRequire("6CPSz");

var $5Rh9l = parcelRequire("5Rh9l");

var $hLRhz = parcelRequire("hLRhz");

var $aSOgT = parcelRequire("aSOgT");

var $6k8cN = parcelRequire("6k8cN");

var $fUCnl = parcelRequire("fUCnl");

var $dmsgX = parcelRequire("dmsgX");

var $kkf18 = parcelRequire("kkf18");
function $521a08aaecdfc295$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $6k8cN.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $5lmZP.default)(state.placement);
    var variation = (0, $fUCnl.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $62PBD.default)(basePlacement);
    var altAxis = (0, $6CPSz.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $8GdE7.top) : (0, $8GdE7.left);
        var altSide = mainAxis === 'y' ? (0, $8GdE7.bottom) : (0, $8GdE7.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $8GdE7.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $8GdE7.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $hLRhz.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $dmsgX.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $5Rh9l.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $aSOgT.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $5Rh9l.within)(tether ? (0, $kkf18.min)(min, tetherMin) : min, offset, tether ? (0, $kkf18.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $8GdE7.top) : (0, $8GdE7.left);
        var _altSide = mainAxis === 'x' ? (0, $8GdE7.bottom) : (0, $8GdE7.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $8GdE7.top),
            (0, $8GdE7.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $5Rh9l.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $5Rh9l.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $521a08aaecdfc295$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $521a08aaecdfc295$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("6CPSz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d2e88c9d44e788f$export$2e2bcd8739ae039);
function $4d2e88c9d44e788f$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("5Rh9l", function(module, exports) {

$parcel$export(module.exports, "within", () => $443f348a8c7a0e04$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $443f348a8c7a0e04$export$86c8af6d3ef0b4a);

var $kkf18 = parcelRequire("kkf18");
function $443f348a8c7a0e04$export$f28d906d67a997f3(min, value, max) {
    return (0, $kkf18.max)(min, (0, $kkf18.min)(value, max));
}
function $443f348a8c7a0e04$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $443f348a8c7a0e04$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("kizE9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec7123beb85ad55d$export$2e2bcd8739ae039);

var $5lmZP = parcelRequire("5lmZP");

var $hLRhz = parcelRequire("hLRhz");

var $2frIr = parcelRequire("2frIr");

var $aSOgT = parcelRequire("aSOgT");

var $62PBD = parcelRequire("62PBD");

var $5Rh9l = parcelRequire("5Rh9l");

var $5Npj5 = parcelRequire("5Npj5");

var $4DeOL = parcelRequire("4DeOL");

var $8GdE7 = parcelRequire("8GdE7");
var $ec7123beb85ad55d$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $5Npj5.default)(typeof padding !== 'number' ? padding : (0, $4DeOL.default)(padding, (0, $8GdE7.basePlacements)));
};
function $ec7123beb85ad55d$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $5lmZP.default)(state.placement);
    var axis = (0, $62PBD.default)(basePlacement);
    var isVertical = [
        (0, $8GdE7.left),
        (0, $8GdE7.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $ec7123beb85ad55d$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $hLRhz.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $8GdE7.top) : (0, $8GdE7.left);
    var maxProp = axis === 'y' ? (0, $8GdE7.bottom) : (0, $8GdE7.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $aSOgT.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $5Rh9l.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $ec7123beb85ad55d$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $2frIr.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $ec7123beb85ad55d$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $ec7123beb85ad55d$var$arrow,
    effect: $ec7123beb85ad55d$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("d5FpK", function(module, exports) {

$parcel$export(module.exports, "default", () => $987bde041c0b5dc3$export$2e2bcd8739ae039);

var $8GdE7 = parcelRequire("8GdE7");

var $6k8cN = parcelRequire("6k8cN");
function $987bde041c0b5dc3$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $987bde041c0b5dc3$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $8GdE7.top),
        (0, $8GdE7.right),
        (0, $8GdE7.bottom),
        (0, $8GdE7.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $987bde041c0b5dc3$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $6k8cN.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $6k8cN.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $987bde041c0b5dc3$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $987bde041c0b5dc3$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $987bde041c0b5dc3$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $987bde041c0b5dc3$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $987bde041c0b5dc3$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $987bde041c0b5dc3$var$hide
};

});




parcelRegister("ev6eB", function(module, exports) {

$parcel$export(module.exports, "getMaxSizeModifiers", () => $a5d5f72b04a79e31$export$6d8c2b45c99d6e3f);
function $a5d5f72b04a79e31$export$6d8c2b45c99d6e3f({ viewportPadding: viewportPadding }) {
    return [
        {
            /**
			 * Performing DOM measurements in the 'read' phase,
			 * which is the convention for popper modifiers
			 */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn ({ state: state, name: name }) {
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
			 * Applying max size CSS
			 */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn ({ state: state }) {
                const data = state.modifiersData.maxSizeData;
                if (typeof data?.viewport?.width !== 'number' || typeof data?.viewport?.height !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                const { viewport: viewport } = data;
                const { popperOffsets: popperOffsets = {
                    x: 0,
                    y: 0
                } } = state.modifiersData;
                const [basePlacement] = state.placement.split('-');
                const placementOffset = state.modifiersData?.offset?.[state.placement] ?? {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                let maxWidth = viewport.width - 2 * viewportPadding;
                let maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = `${maxWidth}px`;
                state.styles.popper.maxHeight = `${maxHeight}px`;
            }
        }
    ];
}

});


parcelRegister("87gQG", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $5e8c0bfb9ab21f5e$export$e0be378c32fb70a7);

var $5uXOq = parcelRequire("5uXOq");

var $hBYjV = parcelRequire("hBYjV");

var $7Ye64 = parcelRequire("7Ye64");

var $63Vjo = parcelRequire("63Vjo");
function $5e8c0bfb9ab21f5e$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $5uXOq.useContext((0, $7Ye64.ManagerReferenceNodeSetterContext));
    var refHandler = $5uXOq.useCallback(function(node) {
        (0, $63Vjo.setRef)(innerRef, node);
        (0, $63Vjo.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $5uXOq.useEffect(function() {
        return function() {
            return (0, $63Vjo.setRef)(innerRef, null);
        };
    }, []);
    $5uXOq.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $63Vjo.unwrapArray)(children)({
        ref: refHandler
    });
}

});


parcelRegister("3TR0I", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dbd99ea2cd6ab74$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $wq1Kd = parcelRequire("wq1Kd");
const $6dbd99ea2cd6ab74$var$withAnalyticsEvents = (createEventMap = {})=>(WrappedComponent)=>{
        const WithAnalyticsEvents = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
            const { patchedEventProps: patchedEventProps } = (0, $wq1Kd.usePatchedProps)(createEventMap, props);
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
            return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                ...props,
                ...patchedEventProps,
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            });
        });
        WithAnalyticsEvents.displayName = `WithAnalyticsEvents(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsEvents;
    };
var $6dbd99ea2cd6ab74$export$2e2bcd8739ae039 = $6dbd99ea2cd6ab74$var$withAnalyticsEvents;

});
parcelRegister("wq1Kd", function(module, exports) {

$parcel$export(module.exports, "usePatchedProps", () => $0106e1c8966c38cf$export$9ebb5a84d17e5d18);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");
function $0106e1c8966c38cf$export$9ebb5a84d17e5d18(createEventMap = {}, wrappedComponentProps) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const handlerCache = (0, $5uXOq.useRef)({});
    const patchedProps = (0, $5uXOq.useMemo)(()=>{
        const cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter((key)=>!(key in createEventMap)).forEach((key)=>delete cache[key]);
        return Object.keys(createEventMap).reduce((p, k)=>{
            const eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes(typeof eventCreator)) return p;
            const propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return {
                ...p,
                [k]: cache[k].wrappedCallback
            };
            const wrappedCallback = (...args)=>{
                const analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') propValue(...args, analyticsEvent);
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return {
                ...p,
                [k]: wrappedCallback
            };
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("6moNf", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $60a476c4a31828a3$export$1a04351537078b55);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $cLmtE = parcelRequire("cLmtE");
function $60a476c4a31828a3$export$1a04351537078b55({ fn: fn, action: action, componentName: componentName, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $cLmtE.useTrackedRef)(analyticsData);
    const fnRef = (0, $cLmtE.useTrackedRef)(fn);
    const handler = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("2zyAl", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("cVsDc")).getGlobalObject);
$parcel$export(module.exports, "getGlobalSingleton", () => (parcelRequire("cVsDc")).getGlobalSingleton);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("8iYMs")).isPlainObject);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("8iYMs")).isThenable);
$parcel$export(module.exports, "consoleSandbox", () => (parcelRequire("3zTYc")).consoleSandbox);
$parcel$export(module.exports, "logger", () => (parcelRequire("3zTYc")).logger);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("k9zn8")).uuid4);
$parcel$export(module.exports, "dropUndefinedKeys", () => (parcelRequire("7WyHU")).dropUndefinedKeys);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("dtkXJ")).SyncPromise);





parcelRequire("cVsDc");

parcelRequire("8iYMs");
parcelRequire("3zTYc");

parcelRequire("k9zn8");

var $aV0ua = parcelRequire("aV0ua");

parcelRequire("7WyHU");







parcelRequire("dtkXJ");

var $lrKz8 = parcelRequire("lrKz8");





$parcel$exportWildcard(module.exports, $aV0ua);
$parcel$exportWildcard(module.exports, $lrKz8);

});

parcelRegister("k9nuy", function(module, exports) {

$parcel$export(module.exports, "default", () => $edbf28b9942cca73$export$2e2bcd8739ae039);
/* text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3joPi = parcelRequire("3joPi");

var $gHPOa = parcelRequire("gHPOa");

var $a2Xlh = parcelRequire("a2Xlh");
const $edbf28b9942cca73$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $edbf28b9942cca73$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $a2Xlh.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($edbf28b9942cca73$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $edbf28b9942cca73$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
const $edbf28b9942cca73$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pmoej",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
const $edbf28b9942cca73$var$fontSizeMap = {
    medium: "_11c82smr",
    UNSAFE_small: "_11c8dcr7",
    large: "_11c81ixg",
    small: "_11c81o8v"
};
const $edbf28b9942cca73$var$fontWeightMap = {
    bold: "_k48pmoej",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
const $edbf28b9942cca73$var$textColorMap = {
    'color.text': "_syaz1fxt",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syaz1q28",
    'color.text.accent.orange.bolder': "_syaz1vps",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syazpnps",
    'color.text.accent.blue.bolder': "_syazsc1o",
    'color.text.accent.purple': "_syaz10m5",
    'color.text.accent.purple.bolder': "_syaz2ibx",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1dyx",
    'color.text.accent.gray.bolder': "_syaz1x9z",
    'color.text.disabled': "_syaz1lh4",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syazaqb7",
    'color.text.brand': "_syaz1e6v",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syazwx40",
    'color.text.warning.inverse': "_syazal3n",
    'color.text.success': "_syazy73q",
    'color.text.discovery': "_syazzjem",
    'color.text.information': "_syaze0os",
    'color.text.subtlest': "_syaz131l",
    'color.text.subtle': "_syaz1gjq",
    'color.link': "_syaz14q2",
    'color.link.pressed': "_syaz16c2",
    'color.link.visited': "_syazw7te",
    'color.link.visited.pressed': "_syazg3x0"
};
const $edbf28b9942cca73$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ const $edbf28b9942cca73$var$Text = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, xcss: xcss, children: children }, ref)=>{
    (0, $3joPi.default)($edbf28b9942cca73$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $gHPOa.useHasTextAncestor)();
    const color = $edbf28b9942cca73$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        id: id,
        className: (0, $bwpsq.default)([
            $edbf28b9942cca73$var$styles.root,
            size && $edbf28b9942cca73$var$fontSizeMap[size],
            color && $edbf28b9942cca73$var$textColorMap[color],
            maxLines && $edbf28b9942cca73$var$styles.truncation,
            maxLines === 1 && $edbf28b9942cca73$var$styles.breakAll,
            align && $edbf28b9942cca73$var$styles[`textAlign.${align}`],
            weight && $edbf28b9942cca73$var$fontWeightMap[weight],
            Component === 'em' && $edbf28b9942cca73$var$styles['as.em'],
            Component === 'strong' && $edbf28b9942cca73$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref,
        children: children
    });
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gHPOa.HasTextAncestorProvider), {
        value: true,
        children: component
    });
});
var $edbf28b9942cca73$export$2e2bcd8739ae039 = $edbf28b9942cca73$var$Text;

});
parcelRegister("gHPOa", function(module, exports) {

$parcel$export(module.exports, "useHasTextAncestor", () => $4a1655b936045900$export$9322276ec105d055);
$parcel$export(module.exports, "HasTextAncestorProvider", () => $4a1655b936045900$export$ae933c6cbe5643ad);

var $5uXOq = parcelRequire("5uXOq");
const $4a1655b936045900$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const $4a1655b936045900$export$9322276ec105d055 = ()=>(0, $5uXOq.useContext)($4a1655b936045900$var$HasTextAncestorContext);
const $4a1655b936045900$export$ae933c6cbe5643ad = $4a1655b936045900$var$HasTextAncestorContext.Provider;

});


parcelRegister("asiGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $386649853433b802$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $htBRZ = parcelRequire("htBRZ");
const $386649853433b802$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $5uXOq.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htBRZ.default), {
                data: analyticsData,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                    ...rest,
                    ref: ref
                })
            });
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $386649853433b802$export$2e2bcd8739ae039 = $386649853433b802$var$withAnalyticsContext;

});

parcelRegister("3s0xG", function(module, exports) {

$parcel$export(module.exports, "default", () => $159f2e1e18715384$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $jHTSg = parcelRequire("jHTSg");

var $bWfiu = parcelRequire("bWfiu");

var $5sRpy = parcelRequire("5sRpy");
var $k9nuy = parcelRequire("k9nuy");

var $clxo5 = parcelRequire("clxo5");

var $imRX0 = parcelRequire("imRX0");
var $bdPaN = parcelRequire("bdPaN");
var $cS9FU = parcelRequire("cS9FU");
var $jYveu = parcelRequire("jYveu");
/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ const $159f2e1e18715384$var$EmptyState = ({ buttonGroupLabel: buttonGroupLabel, description: description, header: header, headingLevel: headingLevel = 4, imageHeight: imageHeight, imageUrl: imageUrl, imageWidth: imageWidth, isLoading: isLoading, maxImageHeight: maxImageHeight = 160, maxImageWidth: maxImageWidth = 160, primaryAction: primaryAction, renderImage: renderImage, secondaryAction: secondaryAction, width: width, size: size, tertiaryAction: tertiaryAction, testId: testId })=>{
    const actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $imRX0.default), {
        children: [
            primaryAction && secondaryAction ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jHTSg.default), {
                label: buttonGroupLabel || 'Button group',
                testId: testId && `${testId}-button-group`,
                children: [
                    secondaryAction,
                    primaryAction
                ]
            }) : primaryAction || secondaryAction,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jYveu.default), {
                children: isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {
                    testId: "empty-state-spinner"
                })
            })
        ]
    }) : null;
    const tag = `h${headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4}`;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bdPaN.default), {
        testId: testId,
        width: width || size || 'wide',
        children: [
            imageUrl ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cS9FU.default), {
                src: imageUrl,
                maxWidth: maxImageWidth,
                maxHeight: maxImageHeight,
                width: imageWidth,
                height: imageHeight
            }) : renderImage && renderImage({
                maxImageWidth: maxImageWidth,
                maxImageHeight: maxImageHeight,
                imageWidth: imageWidth,
                imageHeight: imageHeight
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                paddingBlockEnd: "space.200",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                    size: "medium",
                    as: tag,
                    children: header
                })
            }),
            description && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                paddingBlockEnd: "space.300",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                    as: "p",
                    children: description
                })
            }),
            actionsContainer,
            tertiaryAction
        ]
    });
};
var $159f2e1e18715384$export$2e2bcd8739ae039 = $159f2e1e18715384$var$EmptyState;

});
parcelRegister("imRX0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5844a53270a9525e$export$2e2bcd8739ae039);
/* actions-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $5844a53270a9525e$var$actionsStyles = null;
/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */ const $5844a53270a9525e$var$ActionsContainer = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _6rthu2gc _bozg1jfw"
        ]),
        children: children
    });
var $5844a53270a9525e$export$2e2bcd8739ae039 = $5844a53270a9525e$var$ActionsContainer;

});

parcelRegister("bdPaN", function(module, exports) {

$parcel$export(module.exports, "default", () => $96012881549efb7c$export$2e2bcd8739ae039);
/* container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $96012881549efb7c$var$containerStyles = null;
/* Use max-width so the component can shrink on smaller viewports. */ const $96012881549efb7c$var$wideContainerStyles = null;
const $96012881549efb7c$var$narrowContainerStyles = null;
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */ const $96012881549efb7c$var$Container = ({ children: children, width: width, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_6rthoahv _1pfhoahv _12l21wug _ahbq1wug _y3gn1h6o",
            width === 'narrow' ? "_p12fko4j" : "_p12f1pl1"
        ]),
        children: children
    });
var $96012881549efb7c$export$2e2bcd8739ae039 = $96012881549efb7c$var$Container;

});

parcelRegister("cS9FU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9379f55267ee3118$export$2e2bcd8739ae039);
/* image.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $9379f55267ee3118$var$CSS_VAR_MAX_WIDTH = '--max-width';
const $9379f55267ee3118$var$CSS_VAR_MAX_HEIGHT = '--max-height';
const $9379f55267ee3118$var$imageStyles = null;
/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */ const $9379f55267ee3118$var$Image = ({ maxHeight: maxHeight, maxWidth: maxWidth, height: height = 'auto', width: width = 'auto', src: src })=>/*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        style: {
            [$9379f55267ee3118$var$CSS_VAR_MAX_WIDTH]: `${maxWidth}px`,
            [$9379f55267ee3118$var$CSS_VAR_MAX_HEIGHT]: `${maxHeight}px`
        },
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        src: src,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _p12fnzqo _c71l8wry _6rth1ejb _1pfhidpf _12l21wug _ahbq1wug"
        ])
    });
var $9379f55267ee3118$export$2e2bcd8739ae039 = $9379f55267ee3118$var$Image;

});

parcelRegister("jYveu", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1c89587de5d4596$export$2e2bcd8739ae039);
/* spinner-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $c1c89587de5d4596$var$spinnerContainerStyles = null;
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */ const $c1c89587de5d4596$var$SpinnerContainer = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1bsb1ejb _ahbqpxbi"
        ]),
        children: children
    });
var $c1c89587de5d4596$export$2e2bcd8739ae039 = $c1c89587de5d4596$var$SpinnerContainer;

});


parcelRegister("jJRcn", function(module, exports) {

$parcel$export(module.exports, "useCallbackWithAnalytics", () => $fe3f2718085c1421$export$53c2b9c37c40e0d8);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $cLmtE = parcelRequire("cLmtE");
const $fe3f2718085c1421$export$53c2b9c37c40e0d8 = (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const methodRef = (0, $cLmtE.useTrackedRef)(method);
    const payloadRef = (0, $cLmtE.useTrackedRef)(payload);
    return (0, $5uXOq.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};

});

parcelRegister("9Iej8", function(module, exports) {

$parcel$export(module.exports, "default", () => $398e401f22d072d8$export$2e2bcd8739ae039);
var $398e401f22d072d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("iRDaG", function(module, exports) {

$parcel$export(module.exports, "fontFallback", () => $210c1ae307de832f$export$2a99220fb32ec798);
/**
 * Font token fallbacks are verbose.
 * This object exists purely to make using fallbacks less cumbersome while we still need to use them.
 * Will be removed once fallbacks are no longer needed.
 *
 * This is referenced by the use-tokens-typography ESLint rule.
 */ const $210c1ae307de832f$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif'
    }
};

});

parcelRegister("lt7FJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7df3b88bef2fb99e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $9tX7s = parcelRequire("9tX7s");

var $7kBI2 = parcelRequire("7kBI2");

var $7QRS4 = parcelRequire("7QRS4");
class $7df3b88bef2fb99e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { data: data, children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        const isModernContext = (0, $9tX7s.default) || (0, $fHpHg.fg)('analytics-next-use-modern-context_jira');
        if (hasError) {
            if (ErrorComponent) {
                if (isModernContext) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QRS4.default), {
                    data: data,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(ErrorComponent, {})
                });
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7kBI2.default), {
                    data: data,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(ErrorComponent, {})
                });
            }
            return null;
        }
        if (isModernContext) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QRS4.default), {
            data: data,
            children: children
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7kBI2.default), {
            data: data,
            children: children
        });
    }
}

});


$parcel$global.rlb("hPzOn")
//# sourceMappingURL=shared~vendor~atlaskit~ar.97c5230f.js.map
